import { useEffect, useState } from "react";
import CanDataWrapper, { CanTableType } from "./CanDataWrapper";
import Space from "antd/es/space/index";

import moment from "moment";

import * as CanDataYeoul from "../../commons/CanDataYeoul";
import * as Common from "../../commons/common";
import * as TypeDTO from "../../commons/typeDTO";
import * as TypeUtils from "../../commons/typeUtils";

function CanDataYeoulViewer({
    loading,
    vehicleInfo,
    runningCanDataList,
    noFileteredCount,
    selectedDataPointIndex,
    onChangedSelectDataPointIndex,
    onMountedChart,
    onZoomed,
}: {
    loading: boolean;
    vehicleInfo?: TypeDTO.CarDto | undefined;
    runningCanDataList?: Array<TypeDTO.CanData> | undefined;
    noFileteredCount: number;
    selectedDataPointIndex?: number;
    onChangedSelectDataPointIndex?: (dataPointIndex: number) => void;
    onMountedChart?: () => void;
    onZoomed?: (zoom: any) => void;
}) {
    const [currentCanData, setCurrentCanData] = useState<CanDataYeoul.CanData>();

    const convertRemarkWithUnit = (value: number | undefined, unit: string) => {
        return value !== undefined ? value.toFixed(2) + unit : "";
    };

    const convertRemarkString = (value: number | undefined) => {
        if (value === undefined) return "";
        return String(value);
    };

    //#region BMS_BatteryInfo
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bmsBatteryInfoPanelOpen, setBmsBatteryInfoPanelOpen] = useState(false);
    const [bmsBatteryInfoChartMounted, setBmsBatteryInfoChartMounted] = useState(false);
    const [selectedBmsBatteryInfo, setSelectedBmsBatteryInfo] = useState<Array<React.Key>>([]);
    const [seriesChartDatasBmsBatteryInfo, setSeriesChartDatasBmsBatteryInfo] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBmsBatteryInfoBattVol, setChartBmsBatteryInfoBattVol] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTERY_INFO_BATT_VOL_NAME,
        data: [],
    });

    const [chartBmsBatteryInfoBattCurr, setChartBmsBatteryInfoBattCurr] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTERY_INFO_BATT_CURR_NAME,
        data: [],
    });

    const [chartBmsBatteryInfoBattSOC, setChartBmsBatteryInfoBattSOC] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTERY_INFO_BATT_SOC_NAME,
        data: [],
    });

    const [chartBmsBatteryInfoFaultLevel, setChartBmsBatteryInfoFaultLevel] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTERY_INFO_FAULT_LEVEL_NAME,
        data: [],
    });

    const [chartBmsBatteryInfoBattSOH, setChartBmsBatteryInfoBattSOH] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTERY_INFO_BATT_SOH_NAME,
        data: [],
    });

    const [chartBmsBatteryInfoEmergCutoffHvReq, setChartBmsBatteryInfoEmergCutoffHvReq] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTERY_INFO_EMERG_CUTOFF_HV_REQ_NAME,
        data: [],
    });

    const [chartBmsBatteryInfoPmtCutoffLvFb, setChartBmsBatteryInfoPmtCutoffLvFb] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTERY_INFO_PMT_CUTOFF_LV_FB_NAME,
        data: [],
    });

    const [chartBmsBatteryInfoSelfChkState, setChartBmsBatteryInfoSelfChkState] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTERY_INFO_SELF_CHK_STATE_NAME,
        data: [],
    });

    const [chartBmsBatteryInfoNegRelaySts, setChartBmsBatteryInfoNegRelaySts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTERY_INFO_NEG_RELAY_STS_NAME,
        data: [],
    });

    const [chartBmsBatteryInfoHeatRelaySts, setChartBmsBatteryInfoHeatRelaySts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTERY_INFO_HEAT_RELAY_STS_NAME,
        data: [],
    });

    const [chartBmsBatteryInfoActWorkSts, setChartBmsBatteryInfoActWorkSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTERY_INFO_ACT_WORK_STS_NAME,
        data: [],
    });

    const getTableTooltipBmsBatteryInfo = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_BMS_BATTERY_INFO_BATT_VOL_KEY:
                return (
                    <>
                        <p>
                            BMS_BatteryInfo
                            <br />
                            CAN ID: 0x18FA40F4
                            <br />
                            Name: BMS_BattVol
                        </p>
                        <p>StartBit: 0, Length: 16; Unit: V; Factor: 0.05</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTERY_INFO_BATT_CURR_KEY:
                return (
                    <>
                        <p>
                            BMS_BatteryInfo
                            <br />
                            CAN ID: 0x18FA40F4
                            <br />
                            Name: BMS_BattCurr
                        </p>
                        <p>StartBit: 16, Length: 16; Unit: A; Factor: 0.05; Offset: -1600</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTERY_INFO_BATT_SOC_KEY:
                return (
                    <>
                        <p>
                            BMS_BatteryInfo
                            <br />
                            CAN ID: 0x18FA40F4
                            <br />
                            Name: BMS_BattSOC
                        </p>
                        <p>StartBit: 32, Length: 8; Unit: %; Factor: 0.4</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTERY_INFO_FAULT_LEVEL_KEY:
                return (
                    <>
                        <p>
                            BMS_BatteryInfo
                            <br />
                            CAN ID: 0x18FA40F4
                            <br />
                            Name: BMS_FaultLevel
                        </p>
                        <p>StartBit: 54, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTERY_INFO_BATT_SOH_KEY:
                return (
                    <>
                        <p>
                            BMS_BatteryInfo
                            <br />
                            CAN ID: 0x18FA40F4
                            <br />
                            Name: BMS_BattSOH
                        </p>
                        <p>StartBit: 40, Length: 8; Unit: %; Factor: 0.4</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTERY_INFO_EMERG_CUTOFF_HV_REQ_KEY:
                return (
                    <>
                        <p>
                            BMS_BatteryInfo
                            <br />
                            CAN ID: 0x18FA40F4
                            <br />
                            Name: BMS_EmergCutoffHVReq
                        </p>
                        <p>StartBit: 48, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTERY_INFO_PMT_CUTOFF_LV_FB_KEY:
                return (
                    <>
                        <p>
                            BMS_BatteryInfo
                            <br />
                            CAN ID: 0x18FA40F4
                            <br />
                            Name: BMS_PmtCutoffLVFb
                        </p>
                        <p>StartBit: 50, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTERY_INFO_SELF_CHK_STATE_KEY:
                return (
                    <>
                        <p>
                            BMS_BatteryInfo
                            <br />
                            CAN ID: 0x18FA40F4
                            <br />
                            Name: BMS_SelfChkState
                        </p>
                        <p>StartBit: 52, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTERY_INFO_NEG_RELAY_STS_KEY:
                return (
                    <>
                        <p>
                            BMS_BatteryInfo
                            <br />
                            CAN ID: 0x18FA40F4
                            <br />
                            Name: BMS_NegRelaySts
                        </p>
                        <p>StartBit: 56, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTERY_INFO_HEAT_RELAY_STS_KEY:
                return (
                    <>
                        <p>
                            BMS_BatteryInfo
                            <br />
                            CAN ID: 0x18FA40F4
                            <br />
                            Name: BMS_HeatRelaySts
                        </p>
                        <p>StartBit: 58, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTERY_INFO_ACT_WORK_STS_KEY:
                return (
                    <>
                        <p>
                            BMS_BatteryInfo
                            <br />
                            CAN ID: 0x18FA40F4
                            <br />
                            Name: BMS_ActWorkSts
                        </p>
                        <p>StartBit: 60, Length: 4; Unit: bit</p>
                    </>
                );
        }
        return null;
    };

    const getBmsBatteryInfoBattVolValue = () => {
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_BATT_VOL_KEY) && currentCanData?.bmsBatteryInfo) {
            return convertRemarkWithUnit(currentCanData.bmsBatteryInfo.battVol, Common.UNIT_VOLTAGE);
        }
        return "";
    };

    const getBmsBatteryInfoBattCurrValue = () => {
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_BATT_CURR_KEY) && currentCanData?.bmsBatteryInfo) {
            return convertRemarkWithUnit(currentCanData.bmsBatteryInfo.battCurr, Common.UNIT_CURRENT);
        }
        return "";
    };

    const getBmsBatteryInfoBattSOCValue = () => {
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_BATT_SOC_KEY) && currentCanData?.bmsBatteryInfo) {
            return convertRemarkWithUnit(currentCanData.bmsBatteryInfo.battSOC, Common.UNIT_PERCENT);
        }
        return "";
    };

    const getBmsBatteryInfoFaultLevelValue = () => {
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_FAULT_LEVEL_KEY) && currentCanData?.bmsBatteryInfo) {
            return convertRemarkString(currentCanData.bmsBatteryInfo.faultLevel);
        }
        return "";
    };

    const getBmsBatteryInfoBattSOHValue = () => {
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_BATT_SOH_KEY) && currentCanData?.bmsBatteryInfo) {
            return convertRemarkWithUnit(currentCanData.bmsBatteryInfo.battSOH, Common.UNIT_PERCENT);
        }
        return "";
    };

    const getBmsBatteryInfoEmergCutoffHvReqValue = () => {
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_EMERG_CUTOFF_HV_REQ_KEY) && currentCanData?.bmsBatteryInfo) {
            return convertRemarkString(currentCanData.bmsBatteryInfo.emergCutoffHvReq);
        }
        return "";
    };

    const getBmsBatteryInfoPmtCutoffLvFbValue = () => {
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_PMT_CUTOFF_LV_FB_KEY) && currentCanData?.bmsBatteryInfo) {
            return convertRemarkString(currentCanData.bmsBatteryInfo.pmtCutoffLvFb);
        }
        return "";
    };

    const getBmsBatteryInfoSelfChkStateValue = () => {
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_SELF_CHK_STATE_KEY) && currentCanData?.bmsBatteryInfo) {
            return convertRemarkString(currentCanData.bmsBatteryInfo.selfChkState);
        }
        return "";
    };

    const getBmsBatteryInfoNegRelayStsValue = () => {
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_NEG_RELAY_STS_KEY) && currentCanData?.bmsBatteryInfo) {
            return convertRemarkString(currentCanData.bmsBatteryInfo.negRelaySts);
        }
        return "";
    };

    const getBmsBatteryInfoHeatRelayStsValue = () => {
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_HEAT_RELAY_STS_KEY) && currentCanData?.bmsBatteryInfo) {
            return convertRemarkString(currentCanData.bmsBatteryInfo.heatRelaySts);
        }
        return "";
    };

    const getBmsBatteryInfoActWorkStsValue = () => {
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_ACT_WORK_STS_KEY) && currentCanData?.bmsBatteryInfo) {
            return convertRemarkString(currentCanData.bmsBatteryInfo.actWorkSts);
        }
        return "";
    };

    const onChangeBmsBatteryInfo = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBmsBatteryInfo(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBmsBatteryInfo: Array<TypeUtils.ChartData> = [];

        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_BATT_VOL_KEY)) chartDatasBmsBatteryInfo.push(chartBmsBatteryInfoBattVol);
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_BATT_CURR_KEY)) chartDatasBmsBatteryInfo.push(chartBmsBatteryInfoBattCurr);
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_BATT_SOC_KEY)) chartDatasBmsBatteryInfo.push(chartBmsBatteryInfoBattSOC);
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_FAULT_LEVEL_KEY)) chartDatasBmsBatteryInfo.push(chartBmsBatteryInfoFaultLevel);
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_BATT_SOH_KEY)) chartDatasBmsBatteryInfo.push(chartBmsBatteryInfoBattSOH);
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_EMERG_CUTOFF_HV_REQ_KEY)) chartDatasBmsBatteryInfo.push(chartBmsBatteryInfoEmergCutoffHvReq);
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_PMT_CUTOFF_LV_FB_KEY)) chartDatasBmsBatteryInfo.push(chartBmsBatteryInfoPmtCutoffLvFb);
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_SELF_CHK_STATE_KEY)) chartDatasBmsBatteryInfo.push(chartBmsBatteryInfoSelfChkState);
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_NEG_RELAY_STS_KEY)) chartDatasBmsBatteryInfo.push(chartBmsBatteryInfoNegRelaySts);
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_HEAT_RELAY_STS_KEY)) chartDatasBmsBatteryInfo.push(chartBmsBatteryInfoHeatRelaySts);
        if (selectedBmsBatteryInfo.includes(Common.YEOUL_BMS_BATTERY_INFO_ACT_WORK_STS_KEY)) chartDatasBmsBatteryInfo.push(chartBmsBatteryInfoActWorkSts);

        setSeriesChartDatasBmsBatteryInfo(chartDatasBmsBatteryInfo);
    }, [selectedBmsBatteryInfo, chartBmsBatteryInfoBattVol, chartBmsBatteryInfoBattCurr, chartBmsBatteryInfoBattSOC, chartBmsBatteryInfoFaultLevel, chartBmsBatteryInfoBattSOH, chartBmsBatteryInfoEmergCutoffHvReq, chartBmsBatteryInfoPmtCutoffLvFb, chartBmsBatteryInfoSelfChkState, chartBmsBatteryInfoNegRelaySts, chartBmsBatteryInfoHeatRelaySts, chartBmsBatteryInfoActWorkSts]);

    const tableDataBmsBatteryInfo: CanTableType[] = [
        {
            key: Common.YEOUL_BMS_BATTERY_INFO_BATT_VOL_KEY,
            name: Common.YEOUL_BMS_BATTERY_INFO_BATT_VOL_NAME,
            value: getBmsBatteryInfoBattVolValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTERY_INFO_BATT_CURR_KEY,
            name: Common.YEOUL_BMS_BATTERY_INFO_BATT_CURR_NAME,
            value: getBmsBatteryInfoBattCurrValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTERY_INFO_BATT_SOC_KEY,
            name: Common.YEOUL_BMS_BATTERY_INFO_BATT_SOC_NAME,
            value: getBmsBatteryInfoBattSOCValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTERY_INFO_FAULT_LEVEL_KEY,
            name: Common.YEOUL_BMS_BATTERY_INFO_FAULT_LEVEL_NAME,
            value: getBmsBatteryInfoFaultLevelValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTERY_INFO_BATT_SOH_KEY,
            name: Common.YEOUL_BMS_BATTERY_INFO_BATT_SOH_NAME,
            value: getBmsBatteryInfoBattSOHValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTERY_INFO_EMERG_CUTOFF_HV_REQ_KEY,
            name: Common.YEOUL_BMS_BATTERY_INFO_EMERG_CUTOFF_HV_REQ_NAME,
            value: getBmsBatteryInfoEmergCutoffHvReqValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTERY_INFO_PMT_CUTOFF_LV_FB_KEY,
            name: Common.YEOUL_BMS_BATTERY_INFO_PMT_CUTOFF_LV_FB_NAME,
            value: getBmsBatteryInfoPmtCutoffLvFbValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTERY_INFO_SELF_CHK_STATE_KEY,
            name: Common.YEOUL_BMS_BATTERY_INFO_SELF_CHK_STATE_NAME,
            value: getBmsBatteryInfoSelfChkStateValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTERY_INFO_NEG_RELAY_STS_KEY,
            name: Common.YEOUL_BMS_BATTERY_INFO_NEG_RELAY_STS_NAME,
            value: getBmsBatteryInfoNegRelayStsValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTERY_INFO_HEAT_RELAY_STS_KEY,
            name: Common.YEOUL_BMS_BATTERY_INFO_HEAT_RELAY_STS_NAME,
            value: getBmsBatteryInfoHeatRelayStsValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTERY_INFO_ACT_WORK_STS_KEY,
            name: Common.YEOUL_BMS_BATTERY_INFO_ACT_WORK_STS_NAME,
            value: getBmsBatteryInfoActWorkStsValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region VCU_BodyControlInfo
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcuBodyControlInfoPanelOpen, setVcuBodyControlInfoPanelOpen] = useState(false);
    const [vcuBodyControlInfoChartMounted, setVcuBodyControlInfoChartMounted] = useState(false);
    const [selectedVcuBodyControlInfo, setSelectedVcuBodyControlInfo] = useState<Array<React.Key>>([]);
    const [seriesChartDatasVcuBodyControlInfo, setSeriesChartDatasVcuBodyControlInfo] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcuBodyControlInfoVehicleSpd, setChartVcuBodyControlInfoVehicleSpd] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_BODY_CONTROL_INFO_VEHICLE_SPD_NAME,
        data: [],
    });

    const [chartVcuBodyControlInfoAccPedalPosition, setChartVcuBodyControlInfoAccPedalPosition] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_BODY_CONTROL_INFO_ACC_PEDAL_POSITION_NAME,
        data: [],
    });

    const [chartVcuBodyControlInfoAceleratPedalPositionFlt, setChartVcuBodyControlInfoAceleratPedalPositionFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_BODY_CONTROL_INFO_ACELERAT_PEDAL_POSITION_FLT_NAME,
        data: [],
    });

    const [chartVcuBodyControlInfoBrakePedalPositionFlt, setChartVcuBodyControlInfoBrakePedalPositionFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_BODY_CONTROL_INFO_BRAKE_PEDAL_POSITION_FLT_NAME,
        data: [],
    });

    const getTableTooltipVcuBodyControlInfo = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_VCU_BODY_CONTROL_INFO_VEHICLE_SPD_KEY:
                return (
                    <>
                        <p>
                            VCU_BodyControlInfo
                            <br />
                            CAN ID: 0x0CFAB127
                            <br />
                            Name: VCU_VehicleSpd
                        </p>
                        <p>StartBit: 8, Length: 16; Unit: km/h; Factor: 0.00390625</p>
                    </>
                );
            case Common.YEOUL_VCU_BODY_CONTROL_INFO_ACC_PEDAL_POSITION_KEY:
                return (
                    <>
                        <p>
                            VCU_BodyControlInfo
                            <br />
                            CAN ID: 0x0CFAB127
                            <br />
                            Name: VCU_AccPedalPosition
                        </p>
                        <p>StartBit: 32, Length: 8; Unit: %; Factor: 0.4</p>
                    </>
                );
            case Common.YEOUL_VCU_BODY_CONTROL_INFO_ACELERAT_PEDAL_POSITION_FLT_KEY:
                return (
                    <>
                        <p>
                            VCU_BodyControlInfo
                            <br />
                            CAN ID: 0x0CFAB127
                            <br />
                            Name: VCU_AceleratPedalPositionFlt
                        </p>
                        <p>StartBit: 50, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_BODY_CONTROL_INFO_BRAKE_PEDAL_POSITION_FLT_KEY:
                return (
                    <>
                        <p>
                            VCU_BodyControlInfo
                            <br />
                            CAN ID: 0x0CFAB127
                            <br />
                            Name: VCU_BrakePedalPositionFlt
                        </p>
                        <p>StartBit: 52, Length: 2; Unit: bit</p>
                    </>
                );
        }
        return null;
    };

    const getVcuBodyControlInfoVehicleSpdValue = () => {
        if (selectedVcuBodyControlInfo.includes(Common.YEOUL_VCU_BODY_CONTROL_INFO_VEHICLE_SPD_KEY) && currentCanData?.vcuBodyControlInfo) {
            return convertRemarkWithUnit(currentCanData.vcuBodyControlInfo.vehicleSpd, Common.UNIT_SPEED);
        }
        return "";
    };

    const getVcuBodyControlInfoAccPedalPositionValue = () => {
        if (selectedVcuBodyControlInfo.includes(Common.YEOUL_VCU_BODY_CONTROL_INFO_ACC_PEDAL_POSITION_KEY) && currentCanData?.vcuBodyControlInfo) {
            return convertRemarkWithUnit(currentCanData.vcuBodyControlInfo.accPedalPosition, Common.UNIT_PERCENT);
        }
        return "";
    };

    const getVcuBodyControlInfoAceleratPedalPositionFltValue = () => {
        if (selectedVcuBodyControlInfo.includes(Common.YEOUL_VCU_BODY_CONTROL_INFO_ACELERAT_PEDAL_POSITION_FLT_KEY) && currentCanData?.vcuBodyControlInfo) {
            return convertRemarkString(currentCanData.vcuBodyControlInfo.aceleratPedalPositionFlt);
        }
        return "";
    };

    const getVcuBodyControlInfoBrakePedalPositionFltValue = () => {
        if (selectedVcuBodyControlInfo.includes(Common.YEOUL_VCU_BODY_CONTROL_INFO_BRAKE_PEDAL_POSITION_FLT_KEY) && currentCanData?.vcuBodyControlInfo) {
            return convertRemarkString(currentCanData.vcuBodyControlInfo.brakePedalPositionFlt);
        }
        return "";
    };

    const onChangeVcuBodyControlInfo = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcuBodyControlInfo(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcuBodyControlInfo: Array<TypeUtils.ChartData> = [];

        if (selectedVcuBodyControlInfo.includes(Common.YEOUL_VCU_BODY_CONTROL_INFO_VEHICLE_SPD_KEY)) chartDatasVcuBodyControlInfo.push(chartVcuBodyControlInfoVehicleSpd);
        if (selectedVcuBodyControlInfo.includes(Common.YEOUL_VCU_BODY_CONTROL_INFO_ACC_PEDAL_POSITION_KEY)) chartDatasVcuBodyControlInfo.push(chartVcuBodyControlInfoAccPedalPosition);
        if (selectedVcuBodyControlInfo.includes(Common.YEOUL_VCU_BODY_CONTROL_INFO_ACELERAT_PEDAL_POSITION_FLT_KEY)) chartDatasVcuBodyControlInfo.push(chartVcuBodyControlInfoAceleratPedalPositionFlt);
        if (selectedVcuBodyControlInfo.includes(Common.YEOUL_VCU_BODY_CONTROL_INFO_BRAKE_PEDAL_POSITION_FLT_KEY)) chartDatasVcuBodyControlInfo.push(chartVcuBodyControlInfoBrakePedalPositionFlt);

        setSeriesChartDatasVcuBodyControlInfo(chartDatasVcuBodyControlInfo);
    }, [selectedVcuBodyControlInfo, chartVcuBodyControlInfoVehicleSpd, chartVcuBodyControlInfoAccPedalPosition, chartVcuBodyControlInfoAceleratPedalPositionFlt, chartVcuBodyControlInfoBrakePedalPositionFlt]);

    const tableDataVcuBodyControlInfo: CanTableType[] = [
        {
            key: Common.YEOUL_VCU_BODY_CONTROL_INFO_VEHICLE_SPD_KEY,
            name: Common.YEOUL_VCU_BODY_CONTROL_INFO_VEHICLE_SPD_NAME,
            value: getVcuBodyControlInfoVehicleSpdValue(),
        },
        {
            key: Common.YEOUL_VCU_BODY_CONTROL_INFO_ACC_PEDAL_POSITION_KEY,
            name: Common.YEOUL_VCU_BODY_CONTROL_INFO_ACC_PEDAL_POSITION_NAME,
            value: getVcuBodyControlInfoAccPedalPositionValue(),
        },
        {
            key: Common.YEOUL_VCU_BODY_CONTROL_INFO_ACELERAT_PEDAL_POSITION_FLT_KEY,
            name: Common.YEOUL_VCU_BODY_CONTROL_INFO_ACELERAT_PEDAL_POSITION_FLT_NAME,
            value: getVcuBodyControlInfoAceleratPedalPositionFltValue(),
        },
        {
            key: Common.YEOUL_VCU_BODY_CONTROL_INFO_BRAKE_PEDAL_POSITION_FLT_KEY,
            name: Common.YEOUL_VCU_BODY_CONTROL_INFO_BRAKE_PEDAL_POSITION_FLT_NAME,
            value: getVcuBodyControlInfoBrakePedalPositionFltValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region VCU_ErrCode
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcuErrCodePanelOpen, setVcuErrCodePanelOpen] = useState(false);
    const [vcuErrCodeChartMounted, setVcuErrCodeChartMounted] = useState(false);
    const [selectedVcuErrCode, setSelectedVcuErrCode] = useState<Array<React.Key>>([]);
    const [seriesChartDatasVcuErrCode, setSeriesChartDatasVcuErrCode] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcuErrCodeAec, setChartVcuErrCodeAec] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_ERR_CODE_AEC_NAME,
        data: [],
    });

    const [chartVcuErrCodeDte, setChartVcuErrCodeDte] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_ERR_CODE_DTE_NAME,
        data: [],
    });

    const getTableTooltipVcuErrCode = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_VCU_ERR_CODE_AEC_KEY:
                return (
                    <>
                        <p>
                            VCU_ErrCode
                            <br />
                            CAN ID: 0x18FAA027
                            <br />
                            Name: VCU_AEC
                        </p>
                        <p>StartBit: 24, Length: 8; Unit: kWh/100km</p>
                    </>
                );
            case Common.YEOUL_VCU_ERR_CODE_DTE_KEY:
                return (
                    <>
                        <p>
                            VCU_ErrCode
                            <br />
                            CAN ID: 0x18FAA027
                            <br />
                            Name: VCU_DTE
                        </p>
                        <p>StartBit: 32, Length: 16; Unit: km; Factor: 0.125</p>
                    </>
                );
        }
        return null;
    };

    const getVcuErrCodeAecValue = () => {
        if (selectedVcuErrCode.includes(Common.YEOUL_VCU_ERR_CODE_AEC_KEY) && currentCanData?.vcuErrCode) {
            return convertRemarkString(currentCanData.vcuErrCode.aec);
        }
        return "";
    };

    const getVcuErrCodeDteValue = () => {
        if (selectedVcuErrCode.includes(Common.YEOUL_VCU_ERR_CODE_DTE_KEY) && currentCanData?.vcuErrCode) {
            return convertRemarkWithUnit(currentCanData.vcuErrCode.dte, Common.UNIT_DISTANCE);
        }
        return "";
    };

    const onChangeVcuErrCode = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcuErrCode(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcuErrCode: Array<TypeUtils.ChartData> = [];

        if (selectedVcuErrCode.includes(Common.YEOUL_VCU_ERR_CODE_AEC_KEY)) chartDatasVcuErrCode.push(chartVcuErrCodeAec);
        if (selectedVcuErrCode.includes(Common.YEOUL_VCU_ERR_CODE_DTE_KEY)) chartDatasVcuErrCode.push(chartVcuErrCodeDte);

        setSeriesChartDatasVcuErrCode(chartDatasVcuErrCode);
    }, [selectedVcuErrCode, chartVcuErrCodeAec, chartVcuErrCodeDte]);

    const tableDataVcuErrCode: CanTableType[] = [
        {
            key: Common.YEOUL_VCU_ERR_CODE_AEC_KEY,
            name: Common.YEOUL_VCU_ERR_CODE_AEC_NAME,
            value: getVcuErrCodeAecValue(),
        },
        {
            key: Common.YEOUL_VCU_ERR_CODE_DTE_KEY,
            name: Common.YEOUL_VCU_ERR_CODE_DTE_NAME,
            value: getVcuErrCodeDteValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region LBMS_Info
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [lbmsInfoPanelOpen, setLbmsInfoPanelOpen] = useState(false);
    const [lbmsInfoChartMounted, setLbmsInfoChartMounted] = useState(false);
    const [selectedLbmsInfo, setSelectedLbmsInfo] = useState<Array<React.Key>>([]);
    const [seriesChartDatasLbmsInfo, setSeriesChartDatasLbmsInfo] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartLbmsInfoBattCurrent, setChartLbmsInfoBattCurrent] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LBMS_INFO_BATT_CURRENT_NAME,
        data: [],
    });

    const [chartLbmsInfoBattVolt, setChartLbmsInfoBattVolt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LBMS_INFO_BATT_VOLT_NAME,
        data: [],
    });

    const getTableTooltipLbmsInfo = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_LBMS_INFO_BATT_CURRENT_KEY:
                return (
                    <>
                        <p>
                            LBMS_Info
                            <br />
                            CAN ID: 0x18FFBF74
                            <br />
                            Name: LBMS_BattCurrent
                        </p>
                        <p>StartBit: 0, Length: 16; Unit: A; Factor: 0.05; Offset: -1000</p>
                    </>
                );
            case Common.YEOUL_LBMS_INFO_BATT_VOLT_KEY:
                return (
                    <>
                        <p>
                            LBMS_Info
                            <br />
                            CAN ID: 0x18FFBF74
                            <br />
                            Name: LBMS_BattVolt
                        </p>
                        <p>StartBit: 16, Length: 16; Unit: V; Factor: 0.001</p>
                    </>
                );
        }
        return null;
    };

    const getLbmsInfoBattCurrentValue = () => {
        if (selectedLbmsInfo.includes(Common.YEOUL_LBMS_INFO_BATT_CURRENT_KEY) && currentCanData?.lbmsInfo) {
            return convertRemarkWithUnit(currentCanData.lbmsInfo.battCurrent, Common.UNIT_CURRENT);
        }
        return "";
    };

    const getLbmsInfoBattVoltValue = () => {
        if (selectedLbmsInfo.includes(Common.YEOUL_LBMS_INFO_BATT_VOLT_KEY) && currentCanData?.lbmsInfo) {
            return convertRemarkWithUnit(currentCanData.lbmsInfo.battVolt, Common.UNIT_VOLTAGE);
        }
        return "";
    };

    const onChangeLbmsInfo = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedLbmsInfo(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasLbmsInfo: Array<TypeUtils.ChartData> = [];

        if (selectedLbmsInfo.includes(Common.YEOUL_LBMS_INFO_BATT_CURRENT_KEY)) chartDatasLbmsInfo.push(chartLbmsInfoBattCurrent);
        if (selectedLbmsInfo.includes(Common.YEOUL_LBMS_INFO_BATT_VOLT_KEY)) chartDatasLbmsInfo.push(chartLbmsInfoBattVolt);

        setSeriesChartDatasLbmsInfo(chartDatasLbmsInfo);
    }, [selectedLbmsInfo, chartLbmsInfoBattCurrent, chartLbmsInfoBattVolt]);

    const tableDataLbmsInfo: CanTableType[] = [
        {
            key: Common.YEOUL_LBMS_INFO_BATT_CURRENT_KEY,
            name: Common.YEOUL_LBMS_INFO_BATT_CURRENT_NAME,
            value: getLbmsInfoBattCurrentValue(),
        },
        {
            key: Common.YEOUL_LBMS_INFO_BATT_VOLT_KEY,
            name: Common.YEOUL_LBMS_INFO_BATT_VOLT_NAME,
            value: getLbmsInfoBattVoltValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region VCU_PTInfoIndicate
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcuPtInfoIndicatePanelOpen, setVcuPtInfoIndicatePanelOpen] = useState(false);
    const [vcuPtInfoIndicateChartMounted, setVcuPtInfoIndicateChartMounted] = useState(false);
    const [selectedVcuPtInfoIndicate, setSelectedVcuPtInfoIndicate] = useState<Array<React.Key>>([]);
    const [seriesChartDatasVcuPtInfoIndicate, setSeriesChartDatasVcuPtInfoIndicate] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcuPtInfoIndicateGearPositionInd, setChartVcuPtInfoIndicateGearPositionInd] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_PT_INFO_INDICATE_GEAR_POSITION_IND_NAME,
        data: [],
    });

    const [chartVcuPtInfoIndicateHandbrakeSts, setChartVcuPtInfoIndicateHandbrakeSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_PT_INFO_INDICATE_HANDBRAKE_STS_NAME,
        data: [],
    });

    const [chartVcuPtInfoIndicateVehicleRunMode, setChartVcuPtInfoIndicateVehicleRunMode] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_PT_INFO_INDICATE_VEHICLE_RUN_MODE_NAME,
        data: [],
    });

    const [chartVcuPtInfoIndicateDriveModeInd, setChartVcuPtInfoIndicateDriveModeInd] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_PT_INFO_INDICATE_DRIVE_MODE_IND_NAME,
        data: [],
    });

    const getTableTooltipVcuPtInfoIndicate = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_VCU_PT_INFO_INDICATE_GEAR_POSITION_IND_KEY:
                return (
                    <>
                        <p>
                            VCU_PTInfoIndicate
                            <br />
                            CAN ID: 0x18FAB027
                            <br />
                            Name: VCU_GearPositionInd
                        </p>
                        <p>StartBit: 32, Length: 8; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_PT_INFO_INDICATE_HANDBRAKE_STS_KEY:
                return (
                    <>
                        <p>
                            VCU_PTInfoIndicate
                            <br />
                            CAN ID: 0x18FAB027
                            <br />
                            Name: VCU_HandbrakeSts
                        </p>
                        <p>StartBit: 40, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_PT_INFO_INDICATE_VEHICLE_RUN_MODE_KEY:
                return (
                    <>
                        <p>
                            VCU_PTInfoIndicate
                            <br />
                            CAN ID: 0x18FAB027
                            <br />
                            Name: VCU_VehicleRunMode
                        </p>
                        <p>StartBit: 56, Length: 4; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_PT_INFO_INDICATE_DRIVE_MODE_IND_KEY:
                return (
                    <>
                        <p>
                            VCU_PTInfoIndicate
                            <br />
                            CAN ID: 0x18FAB027
                            <br />
                            Name: VCU_DriveModeInd
                        </p>
                        <p>StartBit: 0, Length: 4; Unit: bit</p>
                    </>
                );
        }
        return null;
    };

    const getVcuPtInfoIndicateGearPositionIndValue = () => {
        if (selectedVcuPtInfoIndicate.includes(Common.YEOUL_VCU_PT_INFO_INDICATE_GEAR_POSITION_IND_KEY) && currentCanData?.vcuPtInfoIndicate) {
            return convertRemarkString(currentCanData.vcuPtInfoIndicate.gearPositionInd);
        }
        return "";
    };

    const getVcuPtInfoIndicateHandbrakeStsValue = () => {
        if (selectedVcuPtInfoIndicate.includes(Common.YEOUL_VCU_PT_INFO_INDICATE_HANDBRAKE_STS_KEY) && currentCanData?.vcuPtInfoIndicate) {
            return convertRemarkString(currentCanData.vcuPtInfoIndicate.handbrakeSts);
        }
        return "";
    };

    const getVcuPtInfoIndicateVehicleRunModeValue = () => {
        if (selectedVcuPtInfoIndicate.includes(Common.YEOUL_VCU_PT_INFO_INDICATE_VEHICLE_RUN_MODE_KEY) && currentCanData?.vcuPtInfoIndicate) {
            return convertRemarkString(currentCanData.vcuPtInfoIndicate.vehicleRunMode);
        }
        return "";
    };

    const getVcuPtInfoIndicateDriveModeIndValue = () => {
        if (selectedVcuPtInfoIndicate.includes(Common.YEOUL_VCU_PT_INFO_INDICATE_DRIVE_MODE_IND_KEY) && currentCanData?.vcuPtInfoIndicate) {
            return convertRemarkString(currentCanData.vcuPtInfoIndicate.driveModeInd);
        }
        return "";
    };

    const onChangeVcuPtInfoIndicate = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcuPtInfoIndicate(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcuPtInfoIndicate: Array<TypeUtils.ChartData> = [];

        if (selectedVcuPtInfoIndicate.includes(Common.YEOUL_VCU_PT_INFO_INDICATE_GEAR_POSITION_IND_KEY)) chartDatasVcuPtInfoIndicate.push(chartVcuPtInfoIndicateGearPositionInd);
        if (selectedVcuPtInfoIndicate.includes(Common.YEOUL_VCU_PT_INFO_INDICATE_HANDBRAKE_STS_KEY)) chartDatasVcuPtInfoIndicate.push(chartVcuPtInfoIndicateHandbrakeSts);
        if (selectedVcuPtInfoIndicate.includes(Common.YEOUL_VCU_PT_INFO_INDICATE_VEHICLE_RUN_MODE_KEY)) chartDatasVcuPtInfoIndicate.push(chartVcuPtInfoIndicateVehicleRunMode);
        if (selectedVcuPtInfoIndicate.includes(Common.YEOUL_VCU_PT_INFO_INDICATE_DRIVE_MODE_IND_KEY)) chartDatasVcuPtInfoIndicate.push(chartVcuPtInfoIndicateDriveModeInd);

        setSeriesChartDatasVcuPtInfoIndicate(chartDatasVcuPtInfoIndicate);
    }, [selectedVcuPtInfoIndicate, chartVcuPtInfoIndicateGearPositionInd, chartVcuPtInfoIndicateHandbrakeSts, chartVcuPtInfoIndicateVehicleRunMode, chartVcuPtInfoIndicateDriveModeInd]);

    const tableDataVcuPtInfoIndicate: CanTableType[] = [
        {
            key: Common.YEOUL_VCU_PT_INFO_INDICATE_GEAR_POSITION_IND_KEY,
            name: Common.YEOUL_VCU_PT_INFO_INDICATE_GEAR_POSITION_IND_NAME,
            value: getVcuPtInfoIndicateGearPositionIndValue(),
        },
        {
            key: Common.YEOUL_VCU_PT_INFO_INDICATE_HANDBRAKE_STS_KEY,
            name: Common.YEOUL_VCU_PT_INFO_INDICATE_HANDBRAKE_STS_NAME,
            value: getVcuPtInfoIndicateHandbrakeStsValue(),
        },
        {
            key: Common.YEOUL_VCU_PT_INFO_INDICATE_VEHICLE_RUN_MODE_KEY,
            name: Common.YEOUL_VCU_PT_INFO_INDICATE_VEHICLE_RUN_MODE_NAME,
            value: getVcuPtInfoIndicateVehicleRunModeValue(),
        },
        {
            key: Common.YEOUL_VCU_PT_INFO_INDICATE_DRIVE_MODE_IND_KEY,
            name: Common.YEOUL_VCU_PT_INFO_INDICATE_DRIVE_MODE_IND_NAME,
            value: getVcuPtInfoIndicateDriveModeIndValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region BMS_Min_Max_CellVolt
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bmsMinMaxCellVoltPanelOpen, setBmsMinMaxCellVoltPanelOpen] = useState(false);
    const [bmsMinMaxCellVoltChartMounted, setBmsMinMaxCellVoltChartMounted] = useState(false);
    const [selectedBmsMinMaxCellVolt, setSelectedBmsMinMaxCellVolt] = useState<Array<React.Key>>([]);
    const [seriesChartDatasBmsMinMaxCellVolt, setSeriesChartDatasBmsMinMaxCellVolt] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBmsMinMaxCellVoltMinCellVolt, setChartBmsMinMaxCellVoltMinCellVolt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_CELL_VOLT_NAME,
        data: [],
    });

    const [chartBmsMinMaxCellVoltMinVoltCellNum, setChartBmsMinMaxCellVoltMinVoltCellNum] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_VOLT_CELL_NUM_NAME,
        data: [],
    });

    const [chartBmsMinMaxCellVoltMinVoltCellPackNum, setChartBmsMinMaxCellVoltMinVoltCellPackNum] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_VOLT_CELL_PACK_NUM_NAME,
        data: [],
    });

    const [chartBmsMinMaxCellVoltMaxCellVolt, setChartBmsMinMaxCellVoltMaxCellVolt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_CELL_VOLT_NAME,
        data: [],
    });

    const [chartBmsMinMaxCellVoltMaxVoltCellNum, setChartBmsMinMaxCellVoltMaxVoltCellNum] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_VOLT_CELL_NUM_NAME,
        data: [],
    });

    const [chartBmsMinMaxCellVoltMaxVoltCellPackNum, setChartBmsMinMaxCellVoltMaxVoltCellPackNum] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_VOLT_CELL_PACK_NUM_NAME,
        data: [],
    });

    const getTableTooltipBmsMinMaxCellVolt = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_CELL_VOLT_KEY:
                return (
                    <>
                        <p>
                            BMS_Min_Max_CellVolt
                            <br />
                            CAN ID: 0x18FA4AF4
                            <br />
                            Name: BMS_MinCellVolt
                        </p>
                        <p>StartBit: 0, Length: 16; Unit: V; Factor: 0.001</p>
                    </>
                );
            case Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_VOLT_CELL_NUM_KEY:
                return (
                    <>
                        <p>
                            BMS_Min_Max_CellVolt
                            <br />
                            CAN ID: 0x18FA4AF4
                            <br />
                            Name: BMS_MinVoltCellNum
                        </p>
                        <p>StartBit: 16, Length: 8; Unit: bit; Offset: 1</p>
                    </>
                );
            case Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_VOLT_CELL_PACK_NUM_KEY:
                return (
                    <>
                        <p>
                            BMS_Min_Max_CellVolt
                            <br />
                            CAN ID: 0x18FA4AF4
                            <br />
                            Name: BMS_MinVoltCellPackNum
                        </p>
                        <p>StartBit: 24, Length: 8; Unit: 箱; Offset: 1</p>
                    </>
                );
            case Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_CELL_VOLT_KEY:
                return (
                    <>
                        <p>
                            BMS_Min_Max_CellVolt
                            <br />
                            CAN ID: 0x18FA4AF4
                            <br />
                            Name: BMS_MaxCellVolt
                        </p>
                        <p>StartBit: 32, Length: 16; Unit: V; Factor: 0.001</p>
                    </>
                );
            case Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_VOLT_CELL_NUM_KEY:
                return (
                    <>
                        <p>
                            BMS_Min_Max_CellVolt
                            <br />
                            CAN ID: 0x18FA4AF4
                            <br />
                            Name: BMS_MaxVoltCellNum
                        </p>
                        <p>StartBit: 48, Length: 8; Unit: bit; Offset: 1</p>
                    </>
                );
            case Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_VOLT_CELL_PACK_NUM_KEY:
                return (
                    <>
                        <p>
                            BMS_Min_Max_CellVolt
                            <br />
                            CAN ID: 0x18FA4AF4
                            <br />
                            Name: BMS_MaxVoltCellPackNum
                        </p>
                        <p>StartBit: 56, Length: 8; Unit: 箱; Offset: 1</p>
                    </>
                );
        }
        return null;
    };

    const getBmsMinMaxCellVoltMinCellVoltValue = () => {
        if (selectedBmsMinMaxCellVolt.includes(Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_CELL_VOLT_KEY) && currentCanData?.bmsMinMaxCellVolt) {
            return convertRemarkWithUnit(currentCanData.bmsMinMaxCellVolt.minCellVolt, Common.UNIT_VOLTAGE);
        }
        return "";
    };

    const getBmsMinMaxCellVoltMinVoltCellNumValue = () => {
        if (selectedBmsMinMaxCellVolt.includes(Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_VOLT_CELL_NUM_KEY) && currentCanData?.bmsMinMaxCellVolt) {
            return convertRemarkString(currentCanData.bmsMinMaxCellVolt.minVoltCellNum);
        }
        return "";
    };

    const getBmsMinMaxCellVoltMinVoltCellPackNumValue = () => {
        if (selectedBmsMinMaxCellVolt.includes(Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_VOLT_CELL_PACK_NUM_KEY) && currentCanData?.bmsMinMaxCellVolt) {
            return convertRemarkString(currentCanData.bmsMinMaxCellVolt.minVoltCellPackNum);
        }
        return "";
    };

    const getBmsMinMaxCellVoltMaxCellVoltValue = () => {
        if (selectedBmsMinMaxCellVolt.includes(Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_CELL_VOLT_KEY) && currentCanData?.bmsMinMaxCellVolt) {
            return convertRemarkWithUnit(currentCanData.bmsMinMaxCellVolt.maxCellVolt, Common.UNIT_VOLTAGE);
        }
        return "";
    };

    const getBmsMinMaxCellVoltMaxVoltCellNumValue = () => {
        if (selectedBmsMinMaxCellVolt.includes(Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_VOLT_CELL_NUM_KEY) && currentCanData?.bmsMinMaxCellVolt) {
            return convertRemarkString(currentCanData.bmsMinMaxCellVolt.maxVoltCellNum);
        }
        return "";
    };

    const getBmsMinMaxCellVoltMaxVoltCellPackNumValue = () => {
        if (selectedBmsMinMaxCellVolt.includes(Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_VOLT_CELL_PACK_NUM_KEY) && currentCanData?.bmsMinMaxCellVolt) {
            return convertRemarkString(currentCanData.bmsMinMaxCellVolt.maxVoltCellPackNum);
        }
        return "";
    };

    const onChangeBmsMinMaxCellVolt = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBmsMinMaxCellVolt(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBmsMinMaxCellVolt: Array<TypeUtils.ChartData> = [];

        if (selectedBmsMinMaxCellVolt.includes(Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_CELL_VOLT_KEY)) chartDatasBmsMinMaxCellVolt.push(chartBmsMinMaxCellVoltMinCellVolt);
        if (selectedBmsMinMaxCellVolt.includes(Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_VOLT_CELL_NUM_KEY)) chartDatasBmsMinMaxCellVolt.push(chartBmsMinMaxCellVoltMinVoltCellNum);
        if (selectedBmsMinMaxCellVolt.includes(Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_VOLT_CELL_PACK_NUM_KEY)) chartDatasBmsMinMaxCellVolt.push(chartBmsMinMaxCellVoltMinVoltCellPackNum);
        if (selectedBmsMinMaxCellVolt.includes(Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_CELL_VOLT_KEY)) chartDatasBmsMinMaxCellVolt.push(chartBmsMinMaxCellVoltMaxCellVolt);
        if (selectedBmsMinMaxCellVolt.includes(Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_VOLT_CELL_NUM_KEY)) chartDatasBmsMinMaxCellVolt.push(chartBmsMinMaxCellVoltMaxVoltCellNum);
        if (selectedBmsMinMaxCellVolt.includes(Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_VOLT_CELL_PACK_NUM_KEY)) chartDatasBmsMinMaxCellVolt.push(chartBmsMinMaxCellVoltMaxVoltCellPackNum);

        setSeriesChartDatasBmsMinMaxCellVolt(chartDatasBmsMinMaxCellVolt);
    }, [selectedBmsMinMaxCellVolt, chartBmsMinMaxCellVoltMinCellVolt, chartBmsMinMaxCellVoltMinVoltCellNum, chartBmsMinMaxCellVoltMinVoltCellPackNum, chartBmsMinMaxCellVoltMaxCellVolt, chartBmsMinMaxCellVoltMaxVoltCellNum, chartBmsMinMaxCellVoltMaxVoltCellPackNum]);

    const tableDataBmsMinMaxCellVolt: CanTableType[] = [
        {
            key: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_CELL_VOLT_KEY,
            name: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_CELL_VOLT_NAME,
            value: getBmsMinMaxCellVoltMinCellVoltValue(),
        },
        {
            key: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_VOLT_CELL_NUM_KEY,
            name: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_VOLT_CELL_NUM_NAME,
            value: getBmsMinMaxCellVoltMinVoltCellNumValue(),
        },
        {
            key: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_VOLT_CELL_PACK_NUM_KEY,
            name: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_VOLT_CELL_PACK_NUM_NAME,
            value: getBmsMinMaxCellVoltMinVoltCellPackNumValue(),
        },
        {
            key: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_CELL_VOLT_KEY,
            name: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_CELL_VOLT_NAME,
            value: getBmsMinMaxCellVoltMaxCellVoltValue(),
        },
        {
            key: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_VOLT_CELL_NUM_KEY,
            name: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_VOLT_CELL_NUM_NAME,
            value: getBmsMinMaxCellVoltMaxVoltCellNumValue(),
        },
        {
            key: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_VOLT_CELL_PACK_NUM_KEY,
            name: Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_VOLT_CELL_PACK_NUM_NAME,
            value: getBmsMinMaxCellVoltMaxVoltCellPackNumValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region BMS_Min_Max_CellTemp
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bmsMinMaxCellTempPanelOpen, setBmsMinMaxCellTempPanelOpen] = useState(false);
    const [bmsMinMaxCellTempChartMounted, setBmsMinMaxCellTempChartMounted] = useState(false);
    const [selectedBmsMinMaxCellTemp, setSelectedBmsMinMaxCellTemp] = useState<Array<React.Key>>([]);
    const [seriesChartDatasBmsMinMaxCellTemp, setSeriesChartDatasBmsMinMaxCellTemp] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBmsMinMaxCellTempBattMinTemp, setChartBmsMinMaxCellTempBattMinTemp] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_BATT_MIN_TEMP_NAME,
        data: [],
    });

    const [chartBmsMinMaxCellTempMinTempPackNum, setChartBmsMinMaxCellTempMinTempPackNum] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MIN_TEMP_PACK_NUM_NAME,
        data: [],
    });

    const [chartBmsMinMaxCellTempMinTempSnsNum, setChartBmsMinMaxCellTempMinTempSnsNum] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MIN_TEMP_SNS_NUM_NAME,
        data: [],
    });

    const [chartBmsMinMaxCellTempBnttMaxTemp, setChartBmsMinMaxCellTempBnttMaxTemp] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_BNTT_MAX_TEMP_NAME,
        data: [],
    });

    const [chartBmsMinMaxCellTempMaxTempPackNum, setChartBmsMinMaxCellTempMaxTempPackNum] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MAX_TEMP_PACK_NUM_NAME,
        data: [],
    });

    const [chartBmsMinMaxCellTempMaxTempSnsNum, setChartBmsMinMaxCellTempMaxTempSnsNum] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MAX_TEMP_SNS_NUM_NAME,
        data: [],
    });

    const [chartBmsMinMaxCellTempCellAvgTemp, setChartBmsMinMaxCellTempCellAvgTemp] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_CELL_AVG_TEMP_NAME,
        data: [],
    });

    const getTableTooltipBmsMinMaxCellTemp = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_BATT_MIN_TEMP_KEY:
                return (
                    <>
                        <p>
                            BMS_Min_Max_CellTemp
                            <br />
                            CAN ID: 0x18FA48F4
                            <br />
                            Name: BMS_BattMinTemp
                        </p>
                        <p>StartBit: 0, Length: 8; Unit: °C; Offset: -40</p>
                    </>
                );
            case Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MIN_TEMP_PACK_NUM_KEY:
                return (
                    <>
                        <p>
                            BMS_Min_Max_CellTemp
                            <br />
                            CAN ID: 0x18FA48F4
                            <br />
                            Name: BMS_MinTempPackNum
                        </p>
                        <p>StartBit: 8, Length: 8; Unit: 箱; Offset: 1</p>
                    </>
                );
            case Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MIN_TEMP_SNS_NUM_KEY:
                return (
                    <>
                        <p>
                            BMS_Min_Max_CellTemp
                            <br />
                            CAN ID: 0x18FA48F4
                            <br />
                            Name: BMS_MinTempSnsNum
                        </p>
                        <p>StartBit: 16, Length: 8; Unit: bit; Offset: 1</p>
                    </>
                );
            case Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_BNTT_MAX_TEMP_KEY:
                return (
                    <>
                        <p>
                            BMS_Min_Max_CellTemp
                            <br />
                            CAN ID: 0x18FA48F4
                            <br />
                            Name: BMS_BnttMaxTemp
                        </p>
                        <p>StartBit: 24, Length: 8; Unit: °C; Offset: -40</p>
                    </>
                );
            case Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MAX_TEMP_PACK_NUM_KEY:
                return (
                    <>
                        <p>
                            BMS_Min_Max_CellTemp
                            <br />
                            CAN ID: 0x18FA48F4
                            <br />
                            Name: BMS_MaxTempPackNum
                        </p>
                        <p>StartBit: 32, Length: 8; Unit: 箱; Offset: 1</p>
                    </>
                );
            case Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MAX_TEMP_SNS_NUM_KEY:
                return (
                    <>
                        <p>
                            BMS_Min_Max_CellTemp
                            <br />
                            CAN ID: 0x18FA48F4
                            <br />
                            Name: BMS_MaxTempSnsNum
                        </p>
                        <p>StartBit: 40, Length: 8; Unit: 箱; Offset: 1</p>
                    </>
                );
            case Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_CELL_AVG_TEMP_KEY:
                return (
                    <>
                        <p>
                            BMS_Min_Max_CellTemp
                            <br />
                            CAN ID: 0x18FA48F4
                            <br />
                            Name: BMS_Cell_Avg_Temp
                        </p>
                        <p>StartBit: 48, Length: 8; Unit: °C; Offset: -40</p>
                    </>
                );
        }
        return null;
    };

    const getBmsMinMaxCellTempBattMinTempValue = () => {
        if (selectedBmsMinMaxCellTemp.includes(Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_BATT_MIN_TEMP_KEY) && currentCanData?.bmsMinMaxCellTemp) {
            return convertRemarkWithUnit(currentCanData.bmsMinMaxCellTemp.battMinTemp, Common.UNIT_CELSIUS);
        }
        return "";
    };

    const getBmsMinMaxCellTempMinTempPackNumValue = () => {
        if (selectedBmsMinMaxCellTemp.includes(Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MIN_TEMP_PACK_NUM_KEY) && currentCanData?.bmsMinMaxCellTemp) {
            return convertRemarkString(currentCanData.bmsMinMaxCellTemp.minTempPackNum);
        }
        return "";
    };

    const getBmsMinMaxCellTempMinTempSnsNumValue = () => {
        if (selectedBmsMinMaxCellTemp.includes(Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MIN_TEMP_SNS_NUM_KEY) && currentCanData?.bmsMinMaxCellTemp) {
            return convertRemarkString(currentCanData.bmsMinMaxCellTemp.minTempSnsNum);
        }
        return "";
    };

    const getBmsMinMaxCellTempBnttMaxTempValue = () => {
        if (selectedBmsMinMaxCellTemp.includes(Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_BNTT_MAX_TEMP_KEY) && currentCanData?.bmsMinMaxCellTemp) {
            return convertRemarkWithUnit(currentCanData.bmsMinMaxCellTemp.bnttMaxTemp, Common.UNIT_CELSIUS);
        }
        return "";
    };

    const getBmsMinMaxCellTempMaxTempPackNumValue = () => {
        if (selectedBmsMinMaxCellTemp.includes(Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MAX_TEMP_PACK_NUM_KEY) && currentCanData?.bmsMinMaxCellTemp) {
            return convertRemarkString(currentCanData.bmsMinMaxCellTemp.maxTempPackNum);
        }
        return "";
    };

    const getBmsMinMaxCellTempMaxTempSnsNumValue = () => {
        if (selectedBmsMinMaxCellTemp.includes(Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MAX_TEMP_SNS_NUM_KEY) && currentCanData?.bmsMinMaxCellTemp) {
            return convertRemarkString(currentCanData.bmsMinMaxCellTemp.maxTempSnsNum);
        }
        return "";
    };

    const getBmsMinMaxCellTempCellAvgTempValue = () => {
        if (selectedBmsMinMaxCellTemp.includes(Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_CELL_AVG_TEMP_KEY) && currentCanData?.bmsMinMaxCellTemp) {
            return convertRemarkWithUnit(currentCanData.bmsMinMaxCellTemp.cellAvgTemp, Common.UNIT_CELSIUS);
        }
        return "";
    };

    const onChangeBmsMinMaxCellTemp = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBmsMinMaxCellTemp(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBmsMinMaxCellTemp: Array<TypeUtils.ChartData> = [];

        if (selectedBmsMinMaxCellTemp.includes(Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_BATT_MIN_TEMP_KEY)) chartDatasBmsMinMaxCellTemp.push(chartBmsMinMaxCellTempBattMinTemp);
        if (selectedBmsMinMaxCellTemp.includes(Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MIN_TEMP_PACK_NUM_KEY)) chartDatasBmsMinMaxCellTemp.push(chartBmsMinMaxCellTempMinTempPackNum);
        if (selectedBmsMinMaxCellTemp.includes(Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MIN_TEMP_SNS_NUM_KEY)) chartDatasBmsMinMaxCellTemp.push(chartBmsMinMaxCellTempMinTempSnsNum);
        if (selectedBmsMinMaxCellTemp.includes(Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_BNTT_MAX_TEMP_KEY)) chartDatasBmsMinMaxCellTemp.push(chartBmsMinMaxCellTempBnttMaxTemp);
        if (selectedBmsMinMaxCellTemp.includes(Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MAX_TEMP_PACK_NUM_KEY)) chartDatasBmsMinMaxCellTemp.push(chartBmsMinMaxCellTempMaxTempPackNum);
        if (selectedBmsMinMaxCellTemp.includes(Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MAX_TEMP_SNS_NUM_KEY)) chartDatasBmsMinMaxCellTemp.push(chartBmsMinMaxCellTempMaxTempSnsNum);
        if (selectedBmsMinMaxCellTemp.includes(Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_CELL_AVG_TEMP_KEY)) chartDatasBmsMinMaxCellTemp.push(chartBmsMinMaxCellTempCellAvgTemp);

        setSeriesChartDatasBmsMinMaxCellTemp(chartDatasBmsMinMaxCellTemp);
    }, [selectedBmsMinMaxCellTemp, chartBmsMinMaxCellTempBattMinTemp, chartBmsMinMaxCellTempMinTempPackNum, chartBmsMinMaxCellTempMinTempSnsNum, chartBmsMinMaxCellTempBnttMaxTemp, chartBmsMinMaxCellTempMaxTempPackNum, chartBmsMinMaxCellTempMaxTempSnsNum, chartBmsMinMaxCellTempCellAvgTemp]);

    const tableDataBmsMinMaxCellTemp: CanTableType[] = [
        {
            key: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_BATT_MIN_TEMP_KEY,
            name: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_BATT_MIN_TEMP_NAME,
            value: getBmsMinMaxCellTempBattMinTempValue(),
        },
        {
            key: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MIN_TEMP_PACK_NUM_KEY,
            name: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MIN_TEMP_PACK_NUM_NAME,
            value: getBmsMinMaxCellTempMinTempPackNumValue(),
        },
        {
            key: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MIN_TEMP_SNS_NUM_KEY,
            name: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MIN_TEMP_SNS_NUM_NAME,
            value: getBmsMinMaxCellTempMinTempSnsNumValue(),
        },
        {
            key: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_BNTT_MAX_TEMP_KEY,
            name: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_BNTT_MAX_TEMP_NAME,
            value: getBmsMinMaxCellTempBnttMaxTempValue(),
        },
        {
            key: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MAX_TEMP_PACK_NUM_KEY,
            name: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MAX_TEMP_PACK_NUM_NAME,
            value: getBmsMinMaxCellTempMaxTempPackNumValue(),
        },
        {
            key: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MAX_TEMP_SNS_NUM_KEY,
            name: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_MAX_TEMP_SNS_NUM_NAME,
            value: getBmsMinMaxCellTempMaxTempSnsNumValue(),
        },
        {
            key: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_CELL_AVG_TEMP_KEY,
            name: Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_CELL_AVG_TEMP_NAME,
            value: getBmsMinMaxCellTempCellAvgTempValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region MCU_MotorAlarmInfo
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [mcuMotorAlarmInfoPanelOpen, setMcuMotorAlarmInfoPanelOpen] = useState(false);
    const [mcuMotorAlarmInfoChartMounted, setMcuMotorAlarmInfoChartMounted] = useState(false);
    const [selectedMcuMotorAlarmInfo, setSelectedMcuMotorAlarmInfo] = useState<Array<React.Key>>([]);
    const [seriesChartDatasMcuMotorAlarmInfo, setSeriesChartDatasMcuMotorAlarmInfo] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartMcuMotorAlarmInfoMotorTempHighAlarm, setChartMcuMotorAlarmInfoMotorTempHighAlarm] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_TEMP_HIGH_ALARM_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoMcuTempHighAlarm, setChartMcuMotorAlarmInfoMcuTempHighAlarm] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_TEMP_HIGH_ALARM_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoMotorSpdHighAlarm, setChartMcuMotorAlarmInfoMotorSpdHighAlarm] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_SPD_HIGH_ALARM_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoCanCommFlt, setChartMcuMotorAlarmInfoCanCommFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_CAN_COMM_FLT_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoMcuMemoryFlt, setChartMcuMotorAlarmInfoMcuMemoryFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_MEMORY_FLT_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoDchvCurrSensorFlt, setChartMcuMotorAlarmInfoDchvCurrSensorFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_DCHV_CURR_SENSOR_FLT_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoMotorUCurrSensorFlt, setChartMcuMotorAlarmInfoMotorUCurrSensorFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_U_CURR_SENSOR_FLT_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoMotorVCurrSensorFlt, setChartMcuMotorAlarmInfoMotorVCurrSensorFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_V_CURR_SENSOR_FLT_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoMotorFltLevel, setChartMcuMotorAlarmInfoMotorFltLevel] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_FLT_LEVEL_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoMcurtcUcedPwrRunErr, setChartMcuMotorAlarmInfoMcurtcUcedPwrRunErr] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCURTC_UCED_PWR_RUN_ERR_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoActiveDischgFlt, setChartMcuMotorAlarmInfoActiveDischgFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_ACTIVE_DISCHG_FLT_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoSoftwareCapOverVolt, setChartMcuMotorAlarmInfoSoftwareCapOverVolt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_SOFTWARE_CAP_OVER_VOLT_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoHardwareCapOverVolt, setChartMcuMotorAlarmInfoHardwareCapOverVolt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_HARDWARE_CAP_OVER_VOLT_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoBusVoltErr, setChartMcuMotorAlarmInfoBusVoltErr] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_BUS_VOLT_ERR_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoMotorLockRotErr, setChartMcuMotorAlarmInfoMotorLockRotErr] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_LOCK_ROT_ERR_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoMcuTempSensorErr, setChartMcuMotorAlarmInfoMcuTempSensorErr] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_TEMP_SENSOR_ERR_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoMotorTempSensorErr, setChartMcuMotorAlarmInfoMotorTempSensorErr] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_TEMP_SENSOR_ERR_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoSysFltCode, setChartMcuMotorAlarmInfoSysFltCode] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_SYS_FLT_CODE_NAME,
        data: [],
    });

    const [chartMcuMotorAlarmInfoMotorSN, setChartMcuMotorAlarmInfoMotorSN] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_SN_NAME,
        data: [],
    });

    const getTableTooltipMcuMotorAlarmInfo = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_TEMP_HIGH_ALARM_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_MotorTempHighAlarm
                        </p>
                        <p>StartBit: 10, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_TEMP_HIGH_ALARM_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_MCUTempHighAlarm
                        </p>
                        <p>StartBit: 12, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_SPD_HIGH_ALARM_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_MotorSpdHighAlarm
                        </p>
                        <p>StartBit: 14, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_CAN_COMM_FLT_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_CANCommFlt
                        </p>
                        <p>StartBit: 18, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_MEMORY_FLT_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_MCUMemoryFlt
                        </p>
                        <p>StartBit: 20, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_DCHV_CURR_SENSOR_FLT_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_DCHVCurrSensorFlt
                        </p>
                        <p>StartBit: 24, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_U_CURR_SENSOR_FLT_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_MotorUCurrSensorFlt
                        </p>
                        <p>StartBit: 26, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_V_CURR_SENSOR_FLT_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_MotorVCurrSensorFlt
                        </p>
                        <p>StartBit: 28, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_FLT_LEVEL_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_MotorFltLevel
                        </p>
                        <p>StartBit: 30, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCURTC_UCED_PWR_RUN_ERR_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_MCURTCUcedPwrRunErr
                        </p>
                        <p>StartBit: 32, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_ACTIVE_DISCHG_FLT_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_ActiveDischgFlt
                        </p>
                        <p>StartBit: 34, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_SOFTWARE_CAP_OVER_VOLT_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_SoftwareCapOverVolt
                        </p>
                        <p>StartBit: 36, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_HARDWARE_CAP_OVER_VOLT_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_HardwareCapOverVolt
                        </p>
                        <p>StartBit: 38, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_BUS_VOLT_ERR_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_BusVoltErr
                        </p>
                        <p>StartBit: 40, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_LOCK_ROT_ERR_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_MotorLockRotErr
                        </p>
                        <p>StartBit: 42, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_TEMP_SENSOR_ERR_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_MCUTempSensorErr
                        </p>
                        <p>StartBit: 44, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_TEMP_SENSOR_ERR_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_MotorTempSensorErr
                        </p>
                        <p>StartBit: 46, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_SYS_FLT_CODE_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_SysFltCode
                        </p>
                        <p>StartBit: 48, Length: 8; Unit: bit; Offset: 1</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_SN_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02EF
                            <br />
                            Name: MCU_MotorSN
                        </p>
                        <p>StartBit: 60, Length: 4; Unit: bit; Offset: 1</p>
                    </>
                );
        }
        return null;
    };

    const getMcuMotorAlarmInfoMotorTempHighAlarmValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_TEMP_HIGH_ALARM_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.motorTempHighAlarm);
        }
        return "";
    };

    const getMcuMotorAlarmInfoMcuTempHighAlarmValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_TEMP_HIGH_ALARM_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.mcuTempHighAlarm);
        }
        return "";
    };

    const getMcuMotorAlarmInfoMotorSpdHighAlarmValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_SPD_HIGH_ALARM_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.motorSpdHighAlarm);
        }
        return "";
    };

    const getMcuMotorAlarmInfoCanCommFltValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_CAN_COMM_FLT_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.canCommFlt);
        }
        return "";
    };

    const getMcuMotorAlarmInfoMcuMemoryFltValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_MEMORY_FLT_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.mcuMemoryFlt);
        }
        return "";
    };

    const getMcuMotorAlarmInfoDchvCurrSensorFltValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_DCHV_CURR_SENSOR_FLT_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.dchvCurrSensorFlt);
        }
        return "";
    };

    const getMcuMotorAlarmInfoMotorUCurrSensorFltValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_U_CURR_SENSOR_FLT_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.motorUCurrSensorFlt);
        }
        return "";
    };

    const getMcuMotorAlarmInfoMotorVCurrSensorFltValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_V_CURR_SENSOR_FLT_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.motorVCurrSensorFlt);
        }
        return "";
    };

    const getMcuMotorAlarmInfoMotorFltLevelValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_FLT_LEVEL_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.motorFltLevel);
        }
        return "";
    };

    const getMcuMotorAlarmInfoMcurtcUcedPwrRunErrValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCURTC_UCED_PWR_RUN_ERR_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.mcurtcUcedPwrRunErr);
        }
        return "";
    };

    const getMcuMotorAlarmInfoActiveDischgFltValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_ACTIVE_DISCHG_FLT_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.activeDischgFlt);
        }
        return "";
    };

    const getMcuMotorAlarmInfoSoftwareCapOverVoltValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_SOFTWARE_CAP_OVER_VOLT_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.softwareCapOverVolt);
        }
        return "";
    };

    const getMcuMotorAlarmInfoHardwareCapOverVoltValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_HARDWARE_CAP_OVER_VOLT_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.hardwareCapOverVolt);
        }
        return "";
    };

    const getMcuMotorAlarmInfoBusVoltErrValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_BUS_VOLT_ERR_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.busVoltErr);
        }
        return "";
    };

    const getMcuMotorAlarmInfoMotorLockRotErrValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_LOCK_ROT_ERR_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.motorLockRotErr);
        }
        return "";
    };

    const getMcuMotorAlarmInfoMcuTempSensorErrValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_TEMP_SENSOR_ERR_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.mcuTempSensorErr);
        }
        return "";
    };

    const getMcuMotorAlarmInfoMotorTempSensorErrValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_TEMP_SENSOR_ERR_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.motorTempSensorErr);
        }
        return "";
    };

    const getMcuMotorAlarmInfoSysFltCodeValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_SYS_FLT_CODE_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.sysFltCode);
        }
        return "";
    };

    const getMcuMotorAlarmInfoMotorSNValue = () => {
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_SN_KEY) && currentCanData?.mcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.mcuMotorAlarmInfo.motorSN);
        }
        return "";
    };

    const onChangeMcuMotorAlarmInfo = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedMcuMotorAlarmInfo(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasMcuMotorAlarmInfo: Array<TypeUtils.ChartData> = [];

        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_TEMP_HIGH_ALARM_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoMotorTempHighAlarm);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_TEMP_HIGH_ALARM_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoMcuTempHighAlarm);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_SPD_HIGH_ALARM_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoMotorSpdHighAlarm);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_CAN_COMM_FLT_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoCanCommFlt);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_MEMORY_FLT_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoMcuMemoryFlt);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_DCHV_CURR_SENSOR_FLT_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoDchvCurrSensorFlt);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_U_CURR_SENSOR_FLT_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoMotorUCurrSensorFlt);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_V_CURR_SENSOR_FLT_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoMotorVCurrSensorFlt);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_FLT_LEVEL_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoMotorFltLevel);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCURTC_UCED_PWR_RUN_ERR_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoMcurtcUcedPwrRunErr);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_ACTIVE_DISCHG_FLT_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoActiveDischgFlt);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_SOFTWARE_CAP_OVER_VOLT_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoSoftwareCapOverVolt);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_HARDWARE_CAP_OVER_VOLT_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoHardwareCapOverVolt);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_BUS_VOLT_ERR_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoBusVoltErr);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_LOCK_ROT_ERR_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoMotorLockRotErr);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_TEMP_SENSOR_ERR_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoMcuTempSensorErr);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_TEMP_SENSOR_ERR_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoMotorTempSensorErr);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_SYS_FLT_CODE_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoSysFltCode);
        if (selectedMcuMotorAlarmInfo.includes(Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_SN_KEY)) chartDatasMcuMotorAlarmInfo.push(chartMcuMotorAlarmInfoMotorSN);

        setSeriesChartDatasMcuMotorAlarmInfo(chartDatasMcuMotorAlarmInfo);
    }, [selectedMcuMotorAlarmInfo, chartMcuMotorAlarmInfoMotorTempHighAlarm, chartMcuMotorAlarmInfoMcuTempHighAlarm, chartMcuMotorAlarmInfoMotorSpdHighAlarm, chartMcuMotorAlarmInfoCanCommFlt, chartMcuMotorAlarmInfoMcuMemoryFlt, chartMcuMotorAlarmInfoDchvCurrSensorFlt, chartMcuMotorAlarmInfoMotorUCurrSensorFlt, chartMcuMotorAlarmInfoMotorVCurrSensorFlt, chartMcuMotorAlarmInfoMotorFltLevel, chartMcuMotorAlarmInfoMcurtcUcedPwrRunErr, chartMcuMotorAlarmInfoActiveDischgFlt, chartMcuMotorAlarmInfoSoftwareCapOverVolt, chartMcuMotorAlarmInfoHardwareCapOverVolt, chartMcuMotorAlarmInfoBusVoltErr, chartMcuMotorAlarmInfoMotorLockRotErr, chartMcuMotorAlarmInfoMcuTempSensorErr, chartMcuMotorAlarmInfoMotorTempSensorErr, chartMcuMotorAlarmInfoSysFltCode, chartMcuMotorAlarmInfoMotorSN]);

    const tableDataMcuMotorAlarmInfo: CanTableType[] = [
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_TEMP_HIGH_ALARM_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_TEMP_HIGH_ALARM_NAME,
            value: getMcuMotorAlarmInfoMotorTempHighAlarmValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_TEMP_HIGH_ALARM_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_TEMP_HIGH_ALARM_NAME,
            value: getMcuMotorAlarmInfoMcuTempHighAlarmValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_SPD_HIGH_ALARM_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_SPD_HIGH_ALARM_NAME,
            value: getMcuMotorAlarmInfoMotorSpdHighAlarmValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_CAN_COMM_FLT_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_CAN_COMM_FLT_NAME,
            value: getMcuMotorAlarmInfoCanCommFltValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_MEMORY_FLT_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_MEMORY_FLT_NAME,
            value: getMcuMotorAlarmInfoMcuMemoryFltValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_DCHV_CURR_SENSOR_FLT_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_DCHV_CURR_SENSOR_FLT_NAME,
            value: getMcuMotorAlarmInfoDchvCurrSensorFltValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_U_CURR_SENSOR_FLT_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_U_CURR_SENSOR_FLT_NAME,
            value: getMcuMotorAlarmInfoMotorUCurrSensorFltValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_V_CURR_SENSOR_FLT_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_V_CURR_SENSOR_FLT_NAME,
            value: getMcuMotorAlarmInfoMotorVCurrSensorFltValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_FLT_LEVEL_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_FLT_LEVEL_NAME,
            value: getMcuMotorAlarmInfoMotorFltLevelValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCURTC_UCED_PWR_RUN_ERR_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCURTC_UCED_PWR_RUN_ERR_NAME,
            value: getMcuMotorAlarmInfoMcurtcUcedPwrRunErrValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_ACTIVE_DISCHG_FLT_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_ACTIVE_DISCHG_FLT_NAME,
            value: getMcuMotorAlarmInfoActiveDischgFltValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_SOFTWARE_CAP_OVER_VOLT_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_SOFTWARE_CAP_OVER_VOLT_NAME,
            value: getMcuMotorAlarmInfoSoftwareCapOverVoltValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_HARDWARE_CAP_OVER_VOLT_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_HARDWARE_CAP_OVER_VOLT_NAME,
            value: getMcuMotorAlarmInfoHardwareCapOverVoltValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_BUS_VOLT_ERR_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_BUS_VOLT_ERR_NAME,
            value: getMcuMotorAlarmInfoBusVoltErrValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_LOCK_ROT_ERR_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_LOCK_ROT_ERR_NAME,
            value: getMcuMotorAlarmInfoMotorLockRotErrValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_TEMP_SENSOR_ERR_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MCU_TEMP_SENSOR_ERR_NAME,
            value: getMcuMotorAlarmInfoMcuTempSensorErrValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_TEMP_SENSOR_ERR_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_TEMP_SENSOR_ERR_NAME,
            value: getMcuMotorAlarmInfoMotorTempSensorErrValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_SYS_FLT_CODE_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_SYS_FLT_CODE_NAME,
            value: getMcuMotorAlarmInfoSysFltCodeValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_SN_KEY,
            name: Common.YEOUL_MCU_MOTOR_ALARM_INFO_MOTOR_SN_NAME,
            value: getMcuMotorAlarmInfoMotorSNValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region LMCU_MotorAlarmInfo
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [lmcuMotorAlarmInfoPanelOpen, setLmcuMotorAlarmInfoPanelOpen] = useState(false);
    const [lmcuMotorAlarmInfoChartMounted, setLmcuMotorAlarmInfoChartMounted] = useState(false);
    const [selectedLmcuMotorAlarmInfo, setSelectedLmcuMotorAlarmInfo] = useState<Array<React.Key>>([]);
    const [seriesChartDatasLmcuMotorAlarmInfo, setSeriesChartDatasLmcuMotorAlarmInfo] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartLmcuMotorAlarmInfoMotorTempHighAlarm, setChartLmcuMotorAlarmInfoMotorTempHighAlarm] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_TEMP_HIGH_ALARM_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoLmcuTempHighAlarm, setChartLmcuMotorAlarmInfoLmcuTempHighAlarm] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_TEMP_HIGH_ALARM_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoMotorSpdHighAlarm, setChartLmcuMotorAlarmInfoMotorSpdHighAlarm] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_SPD_HIGH_ALARM_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoCanCommFlt, setChartLmcuMotorAlarmInfoCanCommFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_CAN_COMM_FLT_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoLmcuMemoryFlt, setChartLmcuMotorAlarmInfoLmcuMemoryFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_MEMORY_FLT_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoDchvCurrSensorFlt, setChartLmcuMotorAlarmInfoDchvCurrSensorFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_DCHV_CURR_SENSOR_FLT_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoMotorUCurrSensorFlt, setChartLmcuMotorAlarmInfoMotorUCurrSensorFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_U_CURR_SENSOR_FLT_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoMotorVCurrSensorFlt, setChartLmcuMotorAlarmInfoMotorVCurrSensorFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_V_CURR_SENSOR_FLT_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoMotorFltLevel, setChartLmcuMotorAlarmInfoMotorFltLevel] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_FLT_LEVEL_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoLmcurtcUcedPwrRunErr, setChartLmcuMotorAlarmInfoLmcurtcUcedPwrRunErr] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCURTC_UCED_PWR_RUN_ERR_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoActiveDischgFlt, setChartLmcuMotorAlarmInfoActiveDischgFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_ACTIVE_DISCHG_FLT_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoSoftwareCapOverVolt, setChartLmcuMotorAlarmInfoSoftwareCapOverVolt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_SOFTWARE_CAP_OVER_VOLT_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoHardwareCapOverVolt, setChartLmcuMotorAlarmInfoHardwareCapOverVolt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_HARDWARE_CAP_OVER_VOLT_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoBusVoltErr, setChartLmcuMotorAlarmInfoBusVoltErr] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_BUS_VOLT_ERR_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoMotorLockRotErr, setChartLmcuMotorAlarmInfoMotorLockRotErr] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_LOCK_ROT_ERR_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoLmcuTempSensorErr, setChartLmcuMotorAlarmInfoLmcuTempSensorErr] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_TEMP_SENSOR_ERR_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoMotorTempSensorErr, setChartLmcuMotorAlarmInfoMotorTempSensorErr] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_TEMP_SENSOR_ERR_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoSysFltCode, setChartLmcuMotorAlarmInfoSysFltCode] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_SYS_FLT_CODE_NAME,
        data: [],
    });

    const [chartLmcuMotorAlarmInfoMotorSN, setChartLmcuMotorAlarmInfoMotorSN] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_SN_NAME,
        data: [],
    });

    const getTableTooltipLmcuMotorAlarmInfo = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_TEMP_HIGH_ALARM_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_MotorTempHighAlarm
                        </p>
                        <p>StartBit: 10, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_TEMP_HIGH_ALARM_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_LMCUTempHighAlarm
                        </p>
                        <p>StartBit: 12, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_SPD_HIGH_ALARM_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_MotorSpdHighAlarm
                        </p>
                        <p>StartBit: 14, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_CAN_COMM_FLT_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_CANCommFlt
                        </p>
                        <p>StartBit: 18, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_MEMORY_FLT_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_LMCUMemoryFlt
                        </p>
                        <p>StartBit: 20, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_DCHV_CURR_SENSOR_FLT_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_DCHVCurrSensorFlt
                        </p>
                        <p>StartBit: 24, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_U_CURR_SENSOR_FLT_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_MotorUCurrSensorFlt
                        </p>
                        <p>StartBit: 26, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_V_CURR_SENSOR_FLT_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_MotorVCurrSensorFlt
                        </p>
                        <p>StartBit: 28, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_FLT_LEVEL_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_MotorFltLevel
                        </p>
                        <p>StartBit: 30, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCURTC_UCED_PWR_RUN_ERR_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_LMCURTCUcedPwrRunErr
                        </p>
                        <p>StartBit: 32, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_ACTIVE_DISCHG_FLT_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_ActiveDischgFlt
                        </p>
                        <p>StartBit: 34, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_SOFTWARE_CAP_OVER_VOLT_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_SoftwareCapOverVolt
                        </p>
                        <p>StartBit: 36, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_HARDWARE_CAP_OVER_VOLT_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_HardwareCapOverVolt
                        </p>
                        <p>StartBit: 38, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_BUS_VOLT_ERR_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_BusVoltErr
                        </p>
                        <p>StartBit: 40, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_LOCK_ROT_ERR_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_MotorLockRotErr
                        </p>
                        <p>StartBit: 42, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_TEMP_SENSOR_ERR_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_LMCUTempSensorErr
                        </p>
                        <p>StartBit: 44, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_TEMP_SENSOR_ERR_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_MotorTempSensorErr
                        </p>
                        <p>StartBit: 46, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_SYS_FLT_CODE_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_SysFltCode
                        </p>
                        <p>StartBit: 48, Length: 8; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_SN_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorAlarmInfo
                            <br />
                            CAN ID: 0x18FA02F0
                            <br />
                            Name: LMCU_MotorSN
                        </p>
                        <p>StartBit: 60, Length: 4; Unit: bit; Offset: 1</p>
                    </>
                );
        }
        return null;
    };

    const getLmcuMotorAlarmInfoMotorTempHighAlarmValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_TEMP_HIGH_ALARM_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.motorTempHighAlarm);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoLmcuTempHighAlarmValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_TEMP_HIGH_ALARM_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.lmcuTempHighAlarm);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoMotorSpdHighAlarmValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_SPD_HIGH_ALARM_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.motorSpdHighAlarm);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoCanCommFltValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_CAN_COMM_FLT_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.canCommFlt);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoLmcuMemoryFltValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_MEMORY_FLT_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.lmcuMemoryFlt);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoDchvCurrSensorFltValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_DCHV_CURR_SENSOR_FLT_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.dchvCurrSensorFlt);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoMotorUCurrSensorFltValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_U_CURR_SENSOR_FLT_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.motorUCurrSensorFlt);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoMotorVCurrSensorFltValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_V_CURR_SENSOR_FLT_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.motorVCurrSensorFlt);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoMotorFltLevelValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_FLT_LEVEL_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.motorFltLevel);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoLmcurtcUcedPwrRunErrValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCURTC_UCED_PWR_RUN_ERR_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.lmcurtcUcedPwrRunErr);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoActiveDischgFltValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_ACTIVE_DISCHG_FLT_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.activeDischgFlt);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoSoftwareCapOverVoltValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_SOFTWARE_CAP_OVER_VOLT_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.softwareCapOverVolt);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoHardwareCapOverVoltValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_HARDWARE_CAP_OVER_VOLT_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.hardwareCapOverVolt);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoBusVoltErrValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_BUS_VOLT_ERR_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.busVoltErr);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoMotorLockRotErrValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_LOCK_ROT_ERR_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.motorLockRotErr);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoLmcuTempSensorErrValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_TEMP_SENSOR_ERR_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.lmcuTempSensorErr);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoMotorTempSensorErrValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_TEMP_SENSOR_ERR_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.motorTempSensorErr);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoSysFltCodeValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_SYS_FLT_CODE_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.sysFltCode);
        }
        return "";
    };

    const getLmcuMotorAlarmInfoMotorSNValue = () => {
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_SN_KEY) && currentCanData?.lmcuMotorAlarmInfo) {
            return convertRemarkString(currentCanData.lmcuMotorAlarmInfo.motorSN);
        }
        return "";
    };

    const onChangeLmcuMotorAlarmInfo = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedLmcuMotorAlarmInfo(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasLmcuMotorAlarmInfo: Array<TypeUtils.ChartData> = [];

        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_TEMP_HIGH_ALARM_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoMotorTempHighAlarm);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_TEMP_HIGH_ALARM_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoLmcuTempHighAlarm);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_SPD_HIGH_ALARM_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoMotorSpdHighAlarm);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_CAN_COMM_FLT_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoCanCommFlt);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_MEMORY_FLT_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoLmcuMemoryFlt);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_DCHV_CURR_SENSOR_FLT_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoDchvCurrSensorFlt);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_U_CURR_SENSOR_FLT_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoMotorUCurrSensorFlt);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_V_CURR_SENSOR_FLT_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoMotorVCurrSensorFlt);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_FLT_LEVEL_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoMotorFltLevel);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCURTC_UCED_PWR_RUN_ERR_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoLmcurtcUcedPwrRunErr);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_ACTIVE_DISCHG_FLT_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoActiveDischgFlt);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_SOFTWARE_CAP_OVER_VOLT_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoSoftwareCapOverVolt);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_HARDWARE_CAP_OVER_VOLT_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoHardwareCapOverVolt);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_BUS_VOLT_ERR_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoBusVoltErr);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_LOCK_ROT_ERR_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoMotorLockRotErr);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_TEMP_SENSOR_ERR_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoLmcuTempSensorErr);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_TEMP_SENSOR_ERR_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoMotorTempSensorErr);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_SYS_FLT_CODE_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoSysFltCode);
        if (selectedLmcuMotorAlarmInfo.includes(Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_SN_KEY)) chartDatasLmcuMotorAlarmInfo.push(chartLmcuMotorAlarmInfoMotorSN);

        setSeriesChartDatasLmcuMotorAlarmInfo(chartDatasLmcuMotorAlarmInfo);
    }, [selectedLmcuMotorAlarmInfo, chartLmcuMotorAlarmInfoMotorTempHighAlarm, chartLmcuMotorAlarmInfoLmcuTempHighAlarm, chartLmcuMotorAlarmInfoMotorSpdHighAlarm, chartLmcuMotorAlarmInfoCanCommFlt, chartLmcuMotorAlarmInfoLmcuMemoryFlt, chartLmcuMotorAlarmInfoDchvCurrSensorFlt, chartLmcuMotorAlarmInfoMotorUCurrSensorFlt, chartLmcuMotorAlarmInfoMotorVCurrSensorFlt, chartLmcuMotorAlarmInfoMotorFltLevel, chartLmcuMotorAlarmInfoLmcurtcUcedPwrRunErr, chartLmcuMotorAlarmInfoActiveDischgFlt, chartLmcuMotorAlarmInfoSoftwareCapOverVolt, chartLmcuMotorAlarmInfoHardwareCapOverVolt, chartLmcuMotorAlarmInfoBusVoltErr, chartLmcuMotorAlarmInfoMotorLockRotErr, chartLmcuMotorAlarmInfoLmcuTempSensorErr, chartLmcuMotorAlarmInfoMotorTempSensorErr, chartLmcuMotorAlarmInfoSysFltCode, chartLmcuMotorAlarmInfoMotorSN]);

    const tableDataLmcuMotorAlarmInfo: CanTableType[] = [
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_TEMP_HIGH_ALARM_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_TEMP_HIGH_ALARM_NAME,
            value: getLmcuMotorAlarmInfoMotorTempHighAlarmValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_TEMP_HIGH_ALARM_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_TEMP_HIGH_ALARM_NAME,
            value: getLmcuMotorAlarmInfoLmcuTempHighAlarmValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_SPD_HIGH_ALARM_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_SPD_HIGH_ALARM_NAME,
            value: getLmcuMotorAlarmInfoMotorSpdHighAlarmValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_CAN_COMM_FLT_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_CAN_COMM_FLT_NAME,
            value: getLmcuMotorAlarmInfoCanCommFltValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_MEMORY_FLT_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_MEMORY_FLT_NAME,
            value: getLmcuMotorAlarmInfoLmcuMemoryFltValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_DCHV_CURR_SENSOR_FLT_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_DCHV_CURR_SENSOR_FLT_NAME,
            value: getLmcuMotorAlarmInfoDchvCurrSensorFltValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_U_CURR_SENSOR_FLT_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_U_CURR_SENSOR_FLT_NAME,
            value: getLmcuMotorAlarmInfoMotorUCurrSensorFltValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_V_CURR_SENSOR_FLT_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_V_CURR_SENSOR_FLT_NAME,
            value: getLmcuMotorAlarmInfoMotorVCurrSensorFltValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_FLT_LEVEL_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_FLT_LEVEL_NAME,
            value: getLmcuMotorAlarmInfoMotorFltLevelValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCURTC_UCED_PWR_RUN_ERR_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCURTC_UCED_PWR_RUN_ERR_NAME,
            value: getLmcuMotorAlarmInfoLmcurtcUcedPwrRunErrValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_ACTIVE_DISCHG_FLT_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_ACTIVE_DISCHG_FLT_NAME,
            value: getLmcuMotorAlarmInfoActiveDischgFltValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_SOFTWARE_CAP_OVER_VOLT_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_SOFTWARE_CAP_OVER_VOLT_NAME,
            value: getLmcuMotorAlarmInfoSoftwareCapOverVoltValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_HARDWARE_CAP_OVER_VOLT_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_HARDWARE_CAP_OVER_VOLT_NAME,
            value: getLmcuMotorAlarmInfoHardwareCapOverVoltValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_BUS_VOLT_ERR_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_BUS_VOLT_ERR_NAME,
            value: getLmcuMotorAlarmInfoBusVoltErrValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_LOCK_ROT_ERR_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_LOCK_ROT_ERR_NAME,
            value: getLmcuMotorAlarmInfoMotorLockRotErrValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_TEMP_SENSOR_ERR_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_LMCU_TEMP_SENSOR_ERR_NAME,
            value: getLmcuMotorAlarmInfoLmcuTempSensorErrValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_TEMP_SENSOR_ERR_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_TEMP_SENSOR_ERR_NAME,
            value: getLmcuMotorAlarmInfoMotorTempSensorErrValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_SYS_FLT_CODE_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_SYS_FLT_CODE_NAME,
            value: getLmcuMotorAlarmInfoSysFltCodeValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_SN_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ALARM_INFO_MOTOR_SN_NAME,
            value: getLmcuMotorAlarmInfoMotorSNValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region BMS_HVIsolationInfo
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bmsHvIsolationInfoPanelOpen, setBmsHvIsolationInfoPanelOpen] = useState(false);
    const [bmsHvIsolationInfoChartMounted, setBmsHvIsolationInfoChartMounted] = useState(false);
    const [selectedBmsHvIsolationInfo, setSelectedBmsHvIsolationInfo] = useState<Array<React.Key>>([]);
    const [seriesChartDatasBmsHvIsolationInfo, setSeriesChartDatasBmsHvIsolationInfo] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBmsHvIsolationInfoPosIsolationRes, setChartBmsHvIsolationInfoPosIsolationRes] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_HV_ISOLATION_INFO_POS_ISOLATION_RES_NAME,
        data: [],
    });

    const [chartBmsHvIsolationInfoNegIsolationRes, setChartBmsHvIsolationInfoNegIsolationRes] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_HV_ISOLATION_INFO_NEG_ISOLATION_RES_NAME,
        data: [],
    });

    const [chartBmsHvIsolationInfoHvIsolationSts, setChartBmsHvIsolationInfoHvIsolationSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_HV_ISOLATION_INFO_HV_ISOLATION_STS_NAME,
        data: [],
    });

    const [chartBmsHvIsolationInfoIsolationFault, setChartBmsHvIsolationInfoIsolationFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_HV_ISOLATION_INFO_ISOLATION_FAULT_NAME,
        data: [],
    });

    const [chartBmsHvIsolationInfoBattFireFault, setChartBmsHvIsolationInfoBattFireFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_HV_ISOLATION_INFO_BATT_FIRE_FAULT_NAME,
        data: [],
    });

    const getTableTooltipBmsHvIsolationInfo = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_BMS_HV_ISOLATION_INFO_POS_ISOLATION_RES_KEY:
                return (
                    <>
                        <p>
                            BMS_HVIsolationInfo
                            <br />
                            CAN ID: 0x18FA41F4
                            <br />
                            Name: BMS_PosIsolationRes
                        </p>
                        <p>StartBit: 0, Length: 16; Unit: kΩ</p>
                    </>
                );
            case Common.YEOUL_BMS_HV_ISOLATION_INFO_NEG_ISOLATION_RES_KEY:
                return (
                    <>
                        <p>
                            BMS_HVIsolationInfo
                            <br />
                            CAN ID: 0x18FA41F4
                            <br />
                            Name: BMS_NegIsolationRes
                        </p>
                        <p>StartBit: 16, Length: 16; Unit: kΩ</p>
                    </>
                );
            case Common.YEOUL_BMS_HV_ISOLATION_INFO_HV_ISOLATION_STS_KEY:
                return (
                    <>
                        <p>
                            BMS_HVIsolationInfo
                            <br />
                            CAN ID: 0x18FA41F4
                            <br />
                            Name: BMS_HVIsolationSts
                        </p>
                        <p>StartBit: 32, Length: 3; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_HV_ISOLATION_INFO_ISOLATION_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_HVIsolationInfo
                            <br />
                            CAN ID: 0x18FA41F4
                            <br />
                            Name: BMS_IsolationFault
                        </p>
                        <p>StartBit: 35, Length: 5; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_HV_ISOLATION_INFO_BATT_FIRE_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_HVIsolationInfo
                            <br />
                            CAN ID: 0x18FA41F4
                            <br />
                            Name: BMS_BattFireFault
                        </p>
                        <p>StartBit: 40, Length: 2; Unit: bit</p>
                    </>
                );
        }
        return null;
    };

    const getBmsHvIsolationInfoPosIsolationResValue = () => {
        if (selectedBmsHvIsolationInfo.includes(Common.YEOUL_BMS_HV_ISOLATION_INFO_POS_ISOLATION_RES_KEY) && currentCanData?.bmsHvIsolationInfo) {
            return convertRemarkString(currentCanData.bmsHvIsolationInfo.posIsolationRes);
        }
        return "";
    };

    const getBmsHvIsolationInfoNegIsolationResValue = () => {
        if (selectedBmsHvIsolationInfo.includes(Common.YEOUL_BMS_HV_ISOLATION_INFO_NEG_ISOLATION_RES_KEY) && currentCanData?.bmsHvIsolationInfo) {
            return convertRemarkString(currentCanData.bmsHvIsolationInfo.negIsolationRes);
        }
        return "";
    };

    const getBmsHvIsolationInfoHvIsolationStsValue = () => {
        if (selectedBmsHvIsolationInfo.includes(Common.YEOUL_BMS_HV_ISOLATION_INFO_HV_ISOLATION_STS_KEY) && currentCanData?.bmsHvIsolationInfo) {
            return convertRemarkString(currentCanData.bmsHvIsolationInfo.hvIsolationSts);
        }
        return "";
    };

    const getBmsHvIsolationInfoIsolationFaultValue = () => {
        if (selectedBmsHvIsolationInfo.includes(Common.YEOUL_BMS_HV_ISOLATION_INFO_ISOLATION_FAULT_KEY) && currentCanData?.bmsHvIsolationInfo) {
            return convertRemarkString(currentCanData.bmsHvIsolationInfo.isolationFault);
        }
        return "";
    };

    const getBmsHvIsolationInfoBattFireFaultValue = () => {
        if (selectedBmsHvIsolationInfo.includes(Common.YEOUL_BMS_HV_ISOLATION_INFO_BATT_FIRE_FAULT_KEY) && currentCanData?.bmsHvIsolationInfo) {
            return convertRemarkString(currentCanData.bmsHvIsolationInfo.battFireFault);
        }
        return "";
    };

    const onChangeBmsHvIsolationInfo = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBmsHvIsolationInfo(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBmsHvIsolationInfo: Array<TypeUtils.ChartData> = [];

        if (selectedBmsHvIsolationInfo.includes(Common.YEOUL_BMS_HV_ISOLATION_INFO_POS_ISOLATION_RES_KEY)) chartDatasBmsHvIsolationInfo.push(chartBmsHvIsolationInfoPosIsolationRes);
        if (selectedBmsHvIsolationInfo.includes(Common.YEOUL_BMS_HV_ISOLATION_INFO_NEG_ISOLATION_RES_KEY)) chartDatasBmsHvIsolationInfo.push(chartBmsHvIsolationInfoNegIsolationRes);
        if (selectedBmsHvIsolationInfo.includes(Common.YEOUL_BMS_HV_ISOLATION_INFO_HV_ISOLATION_STS_KEY)) chartDatasBmsHvIsolationInfo.push(chartBmsHvIsolationInfoHvIsolationSts);
        if (selectedBmsHvIsolationInfo.includes(Common.YEOUL_BMS_HV_ISOLATION_INFO_ISOLATION_FAULT_KEY)) chartDatasBmsHvIsolationInfo.push(chartBmsHvIsolationInfoIsolationFault);
        if (selectedBmsHvIsolationInfo.includes(Common.YEOUL_BMS_HV_ISOLATION_INFO_BATT_FIRE_FAULT_KEY)) chartDatasBmsHvIsolationInfo.push(chartBmsHvIsolationInfoBattFireFault);

        setSeriesChartDatasBmsHvIsolationInfo(chartDatasBmsHvIsolationInfo);
    }, [selectedBmsHvIsolationInfo, chartBmsHvIsolationInfoPosIsolationRes, chartBmsHvIsolationInfoNegIsolationRes, chartBmsHvIsolationInfoHvIsolationSts, chartBmsHvIsolationInfoIsolationFault, chartBmsHvIsolationInfoBattFireFault]);

    const tableDataBmsHvIsolationInfo: CanTableType[] = [
        {
            key: Common.YEOUL_BMS_HV_ISOLATION_INFO_POS_ISOLATION_RES_KEY,
            name: Common.YEOUL_BMS_HV_ISOLATION_INFO_POS_ISOLATION_RES_NAME,
            value: getBmsHvIsolationInfoPosIsolationResValue(),
        },
        {
            key: Common.YEOUL_BMS_HV_ISOLATION_INFO_NEG_ISOLATION_RES_KEY,
            name: Common.YEOUL_BMS_HV_ISOLATION_INFO_NEG_ISOLATION_RES_NAME,
            value: getBmsHvIsolationInfoNegIsolationResValue(),
        },
        {
            key: Common.YEOUL_BMS_HV_ISOLATION_INFO_HV_ISOLATION_STS_KEY,
            name: Common.YEOUL_BMS_HV_ISOLATION_INFO_HV_ISOLATION_STS_NAME,
            value: getBmsHvIsolationInfoHvIsolationStsValue(),
        },
        {
            key: Common.YEOUL_BMS_HV_ISOLATION_INFO_ISOLATION_FAULT_KEY,
            name: Common.YEOUL_BMS_HV_ISOLATION_INFO_ISOLATION_FAULT_NAME,
            value: getBmsHvIsolationInfoIsolationFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_HV_ISOLATION_INFO_BATT_FIRE_FAULT_KEY,
            name: Common.YEOUL_BMS_HV_ISOLATION_INFO_BATT_FIRE_FAULT_NAME,
            value: getBmsHvIsolationInfoBattFireFaultValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region TCU_Info1
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [tcuInfo1PanelOpen, setTcuInfo1PanelOpen] = useState(false);
    const [tcuInfo1ChartMounted, setTcuInfo1ChartMounted] = useState(false);
    const [selectedTcuInfo1, setSelectedTcuInfo1] = useState<Array<React.Key>>([]);
    const [seriesChartDatasTcuInfo1, setSeriesChartDatasTcuInfo1] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartTcuInfo1Currentgear, setChartTcuInfo1Currentgear] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_TCU_INFO1_CURRENTGEAR_NAME,
        data: [],
    });

    const [chartTcuInfo1GearState, setChartTcuInfo1GearState] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_TCU_INFO1_GEAR_STATE_NAME,
        data: [],
    });

    const [chartTcuInfo1FultGrd, setChartTcuInfo1FultGrd] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_TCU_INFO1_FULT_GRD_NAME,
        data: [],
    });

    const getTableTooltipTcuInfo1 = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_TCU_INFO1_CURRENTGEAR_KEY:
                return (
                    <>
                        <p>
                            TCU_Info1
                            <br />
                            CAN ID: 0x18FF0A03
                            <br />
                            Name: TCU_Currentgear
                        </p>
                        <p>StartBit: 0, Length: 4; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_TCU_INFO1_GEAR_STATE_KEY:
                return (
                    <>
                        <p>
                            TCU_Info1
                            <br />
                            CAN ID: 0x18FF0A03
                            <br />
                            Name: TCU_GearState
                        </p>
                        <p>StartBit: 4, Length: 4; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_TCU_INFO1_FULT_GRD_KEY:
                return (
                    <>
                        <p>
                            TCU_Info1
                            <br />
                            CAN ID: 0x18FF0A03
                            <br />
                            Name: TCU_FultGrd
                        </p>
                        <p>StartBit: 8, Length: 2; Unit: bit</p>
                    </>
                );
        }
        return null;
    };

    const getTcuInfo1CurrentgearValue = () => {
        if (selectedTcuInfo1.includes(Common.YEOUL_TCU_INFO1_CURRENTGEAR_KEY) && currentCanData?.tcuInfo1) {
            return convertRemarkString(currentCanData.tcuInfo1.currentgear);
        }
        return "";
    };

    const getTcuInfo1GearStateValue = () => {
        if (selectedTcuInfo1.includes(Common.YEOUL_TCU_INFO1_GEAR_STATE_KEY) && currentCanData?.tcuInfo1) {
            return convertRemarkString(currentCanData.tcuInfo1.gearState);
        }
        return "";
    };

    const getTcuInfo1FultGrdValue = () => {
        if (selectedTcuInfo1.includes(Common.YEOUL_TCU_INFO1_FULT_GRD_KEY) && currentCanData?.tcuInfo1) {
            return convertRemarkString(currentCanData.tcuInfo1.fultGrd);
        }
        return "";
    };

    const onChangeTcuInfo1 = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedTcuInfo1(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasTcuInfo1: Array<TypeUtils.ChartData> = [];

        if (selectedTcuInfo1.includes(Common.YEOUL_TCU_INFO1_CURRENTGEAR_KEY)) chartDatasTcuInfo1.push(chartTcuInfo1Currentgear);
        if (selectedTcuInfo1.includes(Common.YEOUL_TCU_INFO1_GEAR_STATE_KEY)) chartDatasTcuInfo1.push(chartTcuInfo1GearState);
        if (selectedTcuInfo1.includes(Common.YEOUL_TCU_INFO1_FULT_GRD_KEY)) chartDatasTcuInfo1.push(chartTcuInfo1FultGrd);

        setSeriesChartDatasTcuInfo1(chartDatasTcuInfo1);
    }, [selectedTcuInfo1, chartTcuInfo1Currentgear, chartTcuInfo1GearState, chartTcuInfo1FultGrd]);

    const tableDataTcuInfo1: CanTableType[] = [
        {
            key: Common.YEOUL_TCU_INFO1_CURRENTGEAR_KEY,
            name: Common.YEOUL_TCU_INFO1_CURRENTGEAR_NAME,
            value: getTcuInfo1CurrentgearValue(),
        },
        {
            key: Common.YEOUL_TCU_INFO1_GEAR_STATE_KEY,
            name: Common.YEOUL_TCU_INFO1_GEAR_STATE_NAME,
            value: getTcuInfo1GearStateValue(),
        },
        {
            key: Common.YEOUL_TCU_INFO1_FULT_GRD_KEY,
            name: Common.YEOUL_TCU_INFO1_FULT_GRD_NAME,
            value: getTcuInfo1FultGrdValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region DCDC_StatusInfo
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [dcdcStatusInfoPanelOpen, setDcdcStatusInfoPanelOpen] = useState(false);
    const [dcdcStatusInfoChartMounted, setDcdcStatusInfoChartMounted] = useState(false);
    const [selectedDcdcStatusInfo, setSelectedDcdcStatusInfo] = useState<Array<React.Key>>([]);
    const [seriesChartDatasDcdcStatusInfo, setSeriesChartDatasDcdcStatusInfo] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartDcdcStatusInfoFaultLevel, setChartDcdcStatusInfoFaultLevel] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_DCDC_STATUS_INFO_FAULT_LEVEL_NAME,
        data: [],
    });

    const getTableTooltipDcdcStatusInfo = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_DCDC_STATUS_INFO_FAULT_LEVEL_KEY:
                return (
                    <>
                        <p>
                            DCDC_StatusInfo
                            <br />
                            CAN ID: 0x18FA8098
                            <br />
                            Name: DCDC_FaultLevel
                        </p>
                        <p>StartBit: 30, Length: 2; Unit: bit</p>
                    </>
                );
        }
        return null;
    };

    const getDcdcStatusInfoFaultLevelValue = () => {
        if (selectedDcdcStatusInfo.includes(Common.YEOUL_DCDC_STATUS_INFO_FAULT_LEVEL_KEY) && currentCanData?.dcdcStatusInfo) {
            return convertRemarkString(currentCanData.dcdcStatusInfo.faultLevel);
        }
        return "";
    };

    const onChangeDcdcStatusInfo = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedDcdcStatusInfo(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasDcdcStatusInfo: Array<TypeUtils.ChartData> = [];

        if (selectedDcdcStatusInfo.includes(Common.YEOUL_DCDC_STATUS_INFO_FAULT_LEVEL_KEY)) chartDatasDcdcStatusInfo.push(chartDcdcStatusInfoFaultLevel);

        setSeriesChartDatasDcdcStatusInfo(chartDatasDcdcStatusInfo);
    }, [selectedDcdcStatusInfo, chartDcdcStatusInfoFaultLevel]);

    const tableDataDcdcStatusInfo: CanTableType[] = [
        {
            key: Common.YEOUL_DCDC_STATUS_INFO_FAULT_LEVEL_KEY,
            name: Common.YEOUL_DCDC_STATUS_INFO_FAULT_LEVEL_NAME,
            value: getDcdcStatusInfoFaultLevelValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region SDCAC_StatusInfo
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [sdcacStatusInfoPanelOpen, setSdcacStatusInfoPanelOpen] = useState(false);
    const [sdcacStatusInfoChartMounted, setSdcacStatusInfoChartMounted] = useState(false);
    const [selectedSdcacStatusInfo, setSelectedSdcacStatusInfo] = useState<Array<React.Key>>([]);
    const [seriesChartDatasSdcacStatusInfo, setSeriesChartDatasSdcacStatusInfo] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartSdcacStatusInfoFaultLevel, setChartSdcacStatusInfoFaultLevel] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_SDCAC_STATUS_INFO_FAULT_LEVEL_NAME,
        data: [],
    });

    const getTableTooltipSdcacStatusInfo = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_SDCAC_STATUS_INFO_FAULT_LEVEL_KEY:
                return (
                    <>
                        <p>
                            SDCAC_StatusInfo
                            <br />
                            CAN ID: 0x0CFA8197
                            <br />
                            Name: SDCAC_FaultLevel
                        </p>
                        <p>StartBit: 30, Length: 2; Unit: bit</p>
                    </>
                );
        }
        return null;
    };

    const getSdcacStatusInfoFaultLevelValue = () => {
        if (selectedSdcacStatusInfo.includes(Common.YEOUL_SDCAC_STATUS_INFO_FAULT_LEVEL_KEY) && currentCanData?.sdcacStatusInfo) {
            return convertRemarkString(currentCanData.sdcacStatusInfo.faultLevel);
        }
        return "";
    };

    const onChangeSdcacStatusInfo = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedSdcacStatusInfo(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasSdcacStatusInfo: Array<TypeUtils.ChartData> = [];

        if (selectedSdcacStatusInfo.includes(Common.YEOUL_SDCAC_STATUS_INFO_FAULT_LEVEL_KEY)) chartDatasSdcacStatusInfo.push(chartSdcacStatusInfoFaultLevel);

        setSeriesChartDatasSdcacStatusInfo(chartDatasSdcacStatusInfo);
    }, [selectedSdcacStatusInfo, chartSdcacStatusInfoFaultLevel]);

    const tableDataSdcacStatusInfo: CanTableType[] = [
        {
            key: Common.YEOUL_SDCAC_STATUS_INFO_FAULT_LEVEL_KEY,
            name: Common.YEOUL_SDCAC_STATUS_INFO_FAULT_LEVEL_NAME,
            value: getSdcacStatusInfoFaultLevelValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region BDCAC_StatusInfo
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bdcacStatusInfoPanelOpen, setBdcacStatusInfoPanelOpen] = useState(false);
    const [bdcacStatusInfoChartMounted, setBdcacStatusInfoChartMounted] = useState(false);
    const [selectedBdcacStatusInfo, setSelectedBdcacStatusInfo] = useState<Array<React.Key>>([]);
    const [seriesChartDatasBdcacStatusInfo, setSeriesChartDatasBdcacStatusInfo] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBdcacStatusInfoFaultLevel, setChartBdcacStatusInfoFaultLevel] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BDCAC_STATUS_INFO_FAULT_LEVEL_NAME,
        data: [],
    });

    const getTableTooltipBdcacStatusInfo = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_BDCAC_STATUS_INFO_FAULT_LEVEL_KEY:
                return (
                    <>
                        <p>
                            BDCAC_StatusInfo
                            <br />
                            CAN ID: 0x18FA8396
                            <br />
                            Name: BDCAC_FaultLevel
                        </p>
                        <p>StartBit: 30, Length: 2; Unit: bit</p>
                    </>
                );
        }
        return null;
    };

    const getBdcacStatusInfoFaultLevelValue = () => {
        if (selectedBdcacStatusInfo.includes(Common.YEOUL_BDCAC_STATUS_INFO_FAULT_LEVEL_KEY) && currentCanData?.bdcacStatusInfo) {
            return convertRemarkString(currentCanData.bdcacStatusInfo.faultLevel);
        }
        return "";
    };

    const onChangeBdcacStatusInfo = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBdcacStatusInfo(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBdcacStatusInfo: Array<TypeUtils.ChartData> = [];

        if (selectedBdcacStatusInfo.includes(Common.YEOUL_BDCAC_STATUS_INFO_FAULT_LEVEL_KEY)) chartDatasBdcacStatusInfo.push(chartBdcacStatusInfoFaultLevel);

        setSeriesChartDatasBdcacStatusInfo(chartDatasBdcacStatusInfo);
    }, [selectedBdcacStatusInfo, chartBdcacStatusInfoFaultLevel]);

    const tableDataBdcacStatusInfo: CanTableType[] = [
        {
            key: Common.YEOUL_BDCAC_STATUS_INFO_FAULT_LEVEL_KEY,
            name: Common.YEOUL_BDCAC_STATUS_INFO_FAULT_LEVEL_NAME,
            value: getBdcacStatusInfoFaultLevelValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region HCM_WorkInfo
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [hcmWorkInfoPanelOpen, setHcmWorkInfoPanelOpen] = useState(false);
    const [hcmWorkInfoChartMounted, setHcmWorkInfoChartMounted] = useState(false);
    const [selectedHcmWorkInfo, setSelectedHcmWorkInfo] = useState<Array<React.Key>>([]);
    const [seriesChartDatasHcmWorkInfo, setSeriesChartDatasHcmWorkInfo] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartHcmWorkInfoWorkSts, setChartHcmWorkInfoWorkSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_WORK_STS_NAME,
        data: [],
    });

    const [chartHcmWorkInfoAssistPosConnSts, setChartHcmWorkInfoAssistPosConnSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_ASSIST_POS_CONN_STS_NAME,
        data: [],
    });

    const [chartHcmWorkInfoSelfChkSts, setChartHcmWorkInfoSelfChkSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_SELF_CHK_STS_NAME,
        data: [],
    });

    const [chartHcmWorkInfoFaultLevel, setChartHcmWorkInfoFaultLevel] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_FAULT_LEVEL_NAME,
        data: [],
    });

    const [chartHcmWorkInfoEmergCutOffHV, setChartHcmWorkInfoEmergCutOffHV] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_EMERG_CUT_OFF_HV_NAME,
        data: [],
    });

    const [chartHcmWorkInfoCutOffLvFb, setChartHcmWorkInfoCutOffLvFb] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_CUT_OFF_LV_FB_NAME,
        data: [],
    });

    const [chartHcmWorkInfoMainPosConnSts, setChartHcmWorkInfoMainPosConnSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_MAIN_POS_CONN_STS_NAME,
        data: [],
    });

    const [chartHcmWorkInfoPreChgConnSts, setChartHcmWorkInfoPreChgConnSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_PRE_CHG_CONN_STS_NAME,
        data: [],
    });

    const [chartHcmWorkInfoPtcConnStsFb, setChartHcmWorkInfoPtcConnStsFb] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_PTC_CONN_STS_FB_NAME,
        data: [],
    });

    const [chartHcmWorkInfoFastChgConnStsFb, setChartHcmWorkInfoFastChgConnStsFb] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_FAST_CHG_CONN_STS_FB_NAME,
        data: [],
    });

    const [chartHcmWorkInfoSlowChgConnStsFb, setChartHcmWorkInfoSlowChgConnStsFb] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_SLOW_CHG_CONN_STS_FB_NAME,
        data: [],
    });

    const [chartHcmWorkInfoInterLockLoopSts, setChartHcmWorkInfoInterLockLoopSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_INTER_LOCK_LOOP_STS_NAME,
        data: [],
    });

    const [chartHcmWorkInfoOverTemp, setChartHcmWorkInfoOverTemp] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_OVER_TEMP_NAME,
        data: [],
    });

    const [chartHcmWorkInfoCanComFault, setChartHcmWorkInfoCanComFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_CAN_COM_FAULT_NAME,
        data: [],
    });

    const [chartHcmWorkInfoHvLoopFault, setChartHcmWorkInfoHvLoopFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_HV_LOOP_FAULT_NAME,
        data: [],
    });

    const [chartHcmWorkInfoSupplyVolFault, setChartHcmWorkInfoSupplyVolFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_SUPPLY_VOL_FAULT_NAME,
        data: [],
    });

    const [chartHcmWorkInfoHvLoopWorkSts, setChartHcmWorkInfoHvLoopWorkSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_HV_LOOP_WORK_STS_NAME,
        data: [],
    });

    const [chartHcmWorkInfoMainNegConnSts, setChartHcmWorkInfoMainNegConnSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_MAIN_NEG_CONN_STS_NAME,
        data: [],
    });

    const [chartHcmWorkInfoMainPosRalayFlt, setChartHcmWorkInfoMainPosRalayFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_MAIN_POS_RALAY_FLT_NAME,
        data: [],
    });

    const [chartHcmWorkInfoPreChgRelayFlt, setChartHcmWorkInfoPreChgRelayFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_PRE_CHG_RELAY_FLT_NAME,
        data: [],
    });

    const [chartHcmWorkInfoFastChgRelayFlt, setChartHcmWorkInfoFastChgRelayFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_FAST_CHG_RELAY_FLT_NAME,
        data: [],
    });

    const [chartHcmWorkInfoPtcRelayFlt, setChartHcmWorkInfoPtcRelayFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_PTC_RELAY_FLT_NAME,
        data: [],
    });

    const [chartHcmWorkInfoSlowChgRelayFlt, setChartHcmWorkInfoSlowChgRelayFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_SLOW_CHG_RELAY_FLT_NAME,
        data: [],
    });

    const [chartHcmWorkInfoAssistPosRelayFlt, setChartHcmWorkInfoAssistPosRelayFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_ASSIST_POS_RELAY_FLT_NAME,
        data: [],
    });

    const [chartHcmWorkInfoMainNegRelayFlt, setChartHcmWorkInfoMainNegRelayFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_MAIN_NEG_RELAY_FLT_NAME,
        data: [],
    });

    const [chartHcmWorkInfoAssitPreChgConnSts, setChartHcmWorkInfoAssitPreChgConnSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_ASSIT_PRE_CHG_CONN_STS_NAME,
        data: [],
    });

    const [chartHcmWorkInfoAssistPreChgRelayFlt, setChartHcmWorkInfoAssistPreChgRelayFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_ASSIST_PRE_CHG_RELAY_FLT_NAME,
        data: [],
    });

    const [chartHcmWorkInfoWorkInfAliveCnt, setChartHcmWorkInfoWorkInfAliveCnt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_HCM_WORK_INFO_WORK_INF_ALIVE_CNT_NAME,
        data: [],
    });

    const getTableTooltipHcmWorkInfo = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_HCM_WORK_INFO_WORK_STS_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_WorkSts
                        </p>
                        <p>StartBit: 0, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_ASSIST_POS_CONN_STS_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_AssistPosConnSts
                        </p>
                        <p>StartBit: 2, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_SELF_CHK_STS_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_SelfChkSts
                        </p>
                        <p>StartBit: 4, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_FAULT_LEVEL_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_FaultLevel
                        </p>
                        <p>StartBit: 6, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_EMERG_CUT_OFF_HV_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_EmergCutOffHV
                        </p>
                        <p>StartBit: 8, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_CUT_OFF_LV_FB_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_CutOffLVFb
                        </p>
                        <p>StartBit: 10, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_MAIN_POS_CONN_STS_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_MainPosConnSts
                        </p>
                        <p>StartBit: 12, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_PRE_CHG_CONN_STS_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_PreChgConnSts
                        </p>
                        <p>StartBit: 14, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_PTC_CONN_STS_FB_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_PTCConnStsFb
                        </p>
                        <p>StartBit: 16, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_FAST_CHG_CONN_STS_FB_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_FastChgConnStsFb
                        </p>
                        <p>StartBit: 18, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_SLOW_CHG_CONN_STS_FB_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_SlowChgConnStsFb
                        </p>
                        <p>StartBit: 20, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_INTER_LOCK_LOOP_STS_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_InterLockLoopSts
                        </p>
                        <p>StartBit: 22, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_OVER_TEMP_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_OverTemp
                        </p>
                        <p>StartBit: 24, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_CAN_COM_FAULT_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_CANComFault
                        </p>
                        <p>StartBit: 26, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_HV_LOOP_FAULT_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_HVLoopFault
                        </p>
                        <p>StartBit: 28, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_SUPPLY_VOL_FAULT_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_SupplyVolFault
                        </p>
                        <p>StartBit: 30, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_HV_LOOP_WORK_STS_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_HVLoopWorkSts
                        </p>
                        <p>StartBit: 32, Length: 3; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_MAIN_NEG_CONN_STS_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_MainNegConnSts
                        </p>
                        <p>StartBit: 35, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_MAIN_POS_RALAY_FLT_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_MainPosRalayFlt
                        </p>
                        <p>StartBit: 38, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_PRE_CHG_RELAY_FLT_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_PreChgRelayFlt
                        </p>
                        <p>StartBit: 40, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_FAST_CHG_RELAY_FLT_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_FastChgRelayFlt
                        </p>
                        <p>StartBit: 42, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_PTC_RELAY_FLT_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_PTCRelayFlt
                        </p>
                        <p>StartBit: 44, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_SLOW_CHG_RELAY_FLT_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_SlowChgRelayFlt
                        </p>
                        <p>StartBit: 46, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_ASSIST_POS_RELAY_FLT_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_AssistPosRelayFlt
                        </p>
                        <p>StartBit: 48, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_MAIN_NEG_RELAY_FLT_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_MainNegRelayFlt
                        </p>
                        <p>StartBit: 50, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_ASSIT_PRE_CHG_CONN_STS_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_AssitPreChgConnSts
                        </p>
                        <p>StartBit: 52, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_ASSIST_PRE_CHG_RELAY_FLT_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_AssistPreChgRelayFlt
                        </p>
                        <p>StartBit: 54, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_HCM_WORK_INFO_WORK_INF_ALIVE_CNT_KEY:
                return (
                    <>
                        <p>
                            HCM_WorkInfo
                            <br />
                            CAN ID: 0x0CFA851E
                            <br />
                            Name: HCM_WorkInf_AliveCnt
                        </p>
                        <p>StartBit: 56, Length: 8; Unit: bit</p>
                    </>
                );
        }
        return null;
    };

    const getHcmWorkInfoWorkStsValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_WORK_STS_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.workSts);
        }
        return "";
    };

    const getHcmWorkInfoAssistPosConnStsValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_ASSIST_POS_CONN_STS_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.assistPosConnSts);
        }
        return "";
    };

    const getHcmWorkInfoSelfChkStsValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_SELF_CHK_STS_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.selfChkSts);
        }
        return "";
    };

    const getHcmWorkInfoFaultLevelValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_FAULT_LEVEL_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.faultLevel);
        }
        return "";
    };

    const getHcmWorkInfoEmergCutOffHVValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_EMERG_CUT_OFF_HV_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.emergCutOffHV);
        }
        return "";
    };

    const getHcmWorkInfoCutOffLvFbValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_CUT_OFF_LV_FB_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.cutOffLvFb);
        }
        return "";
    };

    const getHcmWorkInfoMainPosConnStsValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_MAIN_POS_CONN_STS_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.mainPosConnSts);
        }
        return "";
    };

    const getHcmWorkInfoPreChgConnStsValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_PRE_CHG_CONN_STS_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.preChgConnSts);
        }
        return "";
    };

    const getHcmWorkInfoPtcConnStsFbValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_PTC_CONN_STS_FB_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.ptcConnStsFb);
        }
        return "";
    };

    const getHcmWorkInfoFastChgConnStsFbValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_FAST_CHG_CONN_STS_FB_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.fastChgConnStsFb);
        }
        return "";
    };

    const getHcmWorkInfoSlowChgConnStsFbValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_SLOW_CHG_CONN_STS_FB_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.slowChgConnStsFb);
        }
        return "";
    };

    const getHcmWorkInfoInterLockLoopStsValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_INTER_LOCK_LOOP_STS_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.interLockLoopSts);
        }
        return "";
    };

    const getHcmWorkInfoOverTempValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_OVER_TEMP_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.overTemp);
        }
        return "";
    };

    const getHcmWorkInfoCanComFaultValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_CAN_COM_FAULT_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.canComFault);
        }
        return "";
    };

    const getHcmWorkInfoHvLoopFaultValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_HV_LOOP_FAULT_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.hvLoopFault);
        }
        return "";
    };

    const getHcmWorkInfoSupplyVolFaultValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_SUPPLY_VOL_FAULT_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.supplyVolFault);
        }
        return "";
    };

    const getHcmWorkInfoHvLoopWorkStsValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_HV_LOOP_WORK_STS_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.hvLoopWorkSts);
        }
        return "";
    };

    const getHcmWorkInfoMainNegConnStsValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_MAIN_NEG_CONN_STS_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.mainNegConnSts);
        }
        return "";
    };

    const getHcmWorkInfoMainPosRalayFltValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_MAIN_POS_RALAY_FLT_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.mainPosRalayFlt);
        }
        return "";
    };

    const getHcmWorkInfoPreChgRelayFltValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_PRE_CHG_RELAY_FLT_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.preChgRelayFlt);
        }
        return "";
    };

    const getHcmWorkInfoFastChgRelayFltValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_FAST_CHG_RELAY_FLT_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.fastChgRelayFlt);
        }
        return "";
    };

    const getHcmWorkInfoPtcRelayFltValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_PTC_RELAY_FLT_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.ptcRelayFlt);
        }
        return "";
    };

    const getHcmWorkInfoSlowChgRelayFltValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_SLOW_CHG_RELAY_FLT_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.slowChgRelayFlt);
        }
        return "";
    };

    const getHcmWorkInfoAssistPosRelayFltValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_ASSIST_POS_RELAY_FLT_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.assistPosRelayFlt);
        }
        return "";
    };

    const getHcmWorkInfoMainNegRelayFltValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_MAIN_NEG_RELAY_FLT_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.mainNegRelayFlt);
        }
        return "";
    };

    const getHcmWorkInfoAssitPreChgConnStsValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_ASSIT_PRE_CHG_CONN_STS_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.assitPreChgConnSts);
        }
        return "";
    };

    const getHcmWorkInfoAssistPreChgRelayFltValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_ASSIST_PRE_CHG_RELAY_FLT_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.assistPreChgRelayFlt);
        }
        return "";
    };

    const getHcmWorkInfoWorkInfAliveCntValue = () => {
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_WORK_INF_ALIVE_CNT_KEY) && currentCanData?.hcmWorkInfo) {
            return convertRemarkString(currentCanData.hcmWorkInfo.workInfAliveCnt);
        }
        return "";
    };

    const onChangeHcmWorkInfo = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedHcmWorkInfo(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasHcmWorkInfo: Array<TypeUtils.ChartData> = [];

        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_WORK_STS_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoWorkSts);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_ASSIST_POS_CONN_STS_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoAssistPosConnSts);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_SELF_CHK_STS_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoSelfChkSts);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_FAULT_LEVEL_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoFaultLevel);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_EMERG_CUT_OFF_HV_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoEmergCutOffHV);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_CUT_OFF_LV_FB_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoCutOffLvFb);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_MAIN_POS_CONN_STS_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoMainPosConnSts);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_PRE_CHG_CONN_STS_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoPreChgConnSts);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_PTC_CONN_STS_FB_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoPtcConnStsFb);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_FAST_CHG_CONN_STS_FB_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoFastChgConnStsFb);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_SLOW_CHG_CONN_STS_FB_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoSlowChgConnStsFb);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_INTER_LOCK_LOOP_STS_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoInterLockLoopSts);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_OVER_TEMP_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoOverTemp);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_CAN_COM_FAULT_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoCanComFault);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_HV_LOOP_FAULT_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoHvLoopFault);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_SUPPLY_VOL_FAULT_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoSupplyVolFault);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_HV_LOOP_WORK_STS_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoHvLoopWorkSts);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_MAIN_NEG_CONN_STS_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoMainNegConnSts);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_MAIN_POS_RALAY_FLT_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoMainPosRalayFlt);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_PRE_CHG_RELAY_FLT_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoPreChgRelayFlt);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_FAST_CHG_RELAY_FLT_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoFastChgRelayFlt);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_PTC_RELAY_FLT_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoPtcRelayFlt);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_SLOW_CHG_RELAY_FLT_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoSlowChgRelayFlt);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_ASSIST_POS_RELAY_FLT_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoAssistPosRelayFlt);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_MAIN_NEG_RELAY_FLT_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoMainNegRelayFlt);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_ASSIT_PRE_CHG_CONN_STS_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoAssitPreChgConnSts);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_ASSIST_PRE_CHG_RELAY_FLT_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoAssistPreChgRelayFlt);
        if (selectedHcmWorkInfo.includes(Common.YEOUL_HCM_WORK_INFO_WORK_INF_ALIVE_CNT_KEY)) chartDatasHcmWorkInfo.push(chartHcmWorkInfoWorkInfAliveCnt);

        setSeriesChartDatasHcmWorkInfo(chartDatasHcmWorkInfo);
    }, [selectedHcmWorkInfo, chartHcmWorkInfoWorkSts, chartHcmWorkInfoAssistPosConnSts, chartHcmWorkInfoSelfChkSts, chartHcmWorkInfoFaultLevel, chartHcmWorkInfoEmergCutOffHV, chartHcmWorkInfoCutOffLvFb, chartHcmWorkInfoMainPosConnSts, chartHcmWorkInfoPreChgConnSts, chartHcmWorkInfoPtcConnStsFb, chartHcmWorkInfoFastChgConnStsFb, chartHcmWorkInfoSlowChgConnStsFb, chartHcmWorkInfoInterLockLoopSts, chartHcmWorkInfoOverTemp, chartHcmWorkInfoCanComFault, chartHcmWorkInfoHvLoopFault, chartHcmWorkInfoSupplyVolFault, chartHcmWorkInfoHvLoopWorkSts, chartHcmWorkInfoMainNegConnSts, chartHcmWorkInfoMainPosRalayFlt, chartHcmWorkInfoPreChgRelayFlt, chartHcmWorkInfoFastChgRelayFlt, chartHcmWorkInfoPtcRelayFlt, chartHcmWorkInfoSlowChgRelayFlt, chartHcmWorkInfoAssistPosRelayFlt, chartHcmWorkInfoMainNegRelayFlt, chartHcmWorkInfoAssitPreChgConnSts, chartHcmWorkInfoAssistPreChgRelayFlt, chartHcmWorkInfoWorkInfAliveCnt]);

    const tableDataHcmWorkInfo: CanTableType[] = [
        {
            key: Common.YEOUL_HCM_WORK_INFO_WORK_STS_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_WORK_STS_NAME,
            value: getHcmWorkInfoWorkStsValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_ASSIST_POS_CONN_STS_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_ASSIST_POS_CONN_STS_NAME,
            value: getHcmWorkInfoAssistPosConnStsValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_SELF_CHK_STS_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_SELF_CHK_STS_NAME,
            value: getHcmWorkInfoSelfChkStsValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_FAULT_LEVEL_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_FAULT_LEVEL_NAME,
            value: getHcmWorkInfoFaultLevelValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_EMERG_CUT_OFF_HV_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_EMERG_CUT_OFF_HV_NAME,
            value: getHcmWorkInfoEmergCutOffHVValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_CUT_OFF_LV_FB_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_CUT_OFF_LV_FB_NAME,
            value: getHcmWorkInfoCutOffLvFbValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_MAIN_POS_CONN_STS_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_MAIN_POS_CONN_STS_NAME,
            value: getHcmWorkInfoMainPosConnStsValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_PRE_CHG_CONN_STS_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_PRE_CHG_CONN_STS_NAME,
            value: getHcmWorkInfoPreChgConnStsValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_PTC_CONN_STS_FB_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_PTC_CONN_STS_FB_NAME,
            value: getHcmWorkInfoPtcConnStsFbValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_FAST_CHG_CONN_STS_FB_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_FAST_CHG_CONN_STS_FB_NAME,
            value: getHcmWorkInfoFastChgConnStsFbValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_SLOW_CHG_CONN_STS_FB_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_SLOW_CHG_CONN_STS_FB_NAME,
            value: getHcmWorkInfoSlowChgConnStsFbValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_INTER_LOCK_LOOP_STS_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_INTER_LOCK_LOOP_STS_NAME,
            value: getHcmWorkInfoInterLockLoopStsValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_OVER_TEMP_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_OVER_TEMP_NAME,
            value: getHcmWorkInfoOverTempValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_CAN_COM_FAULT_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_CAN_COM_FAULT_NAME,
            value: getHcmWorkInfoCanComFaultValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_HV_LOOP_FAULT_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_HV_LOOP_FAULT_NAME,
            value: getHcmWorkInfoHvLoopFaultValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_SUPPLY_VOL_FAULT_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_SUPPLY_VOL_FAULT_NAME,
            value: getHcmWorkInfoSupplyVolFaultValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_HV_LOOP_WORK_STS_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_HV_LOOP_WORK_STS_NAME,
            value: getHcmWorkInfoHvLoopWorkStsValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_MAIN_NEG_CONN_STS_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_MAIN_NEG_CONN_STS_NAME,
            value: getHcmWorkInfoMainNegConnStsValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_MAIN_POS_RALAY_FLT_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_MAIN_POS_RALAY_FLT_NAME,
            value: getHcmWorkInfoMainPosRalayFltValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_PRE_CHG_RELAY_FLT_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_PRE_CHG_RELAY_FLT_NAME,
            value: getHcmWorkInfoPreChgRelayFltValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_FAST_CHG_RELAY_FLT_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_FAST_CHG_RELAY_FLT_NAME,
            value: getHcmWorkInfoFastChgRelayFltValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_PTC_RELAY_FLT_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_PTC_RELAY_FLT_NAME,
            value: getHcmWorkInfoPtcRelayFltValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_SLOW_CHG_RELAY_FLT_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_SLOW_CHG_RELAY_FLT_NAME,
            value: getHcmWorkInfoSlowChgRelayFltValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_ASSIST_POS_RELAY_FLT_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_ASSIST_POS_RELAY_FLT_NAME,
            value: getHcmWorkInfoAssistPosRelayFltValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_MAIN_NEG_RELAY_FLT_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_MAIN_NEG_RELAY_FLT_NAME,
            value: getHcmWorkInfoMainNegRelayFltValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_ASSIT_PRE_CHG_CONN_STS_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_ASSIT_PRE_CHG_CONN_STS_NAME,
            value: getHcmWorkInfoAssitPreChgConnStsValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_ASSIST_PRE_CHG_RELAY_FLT_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_ASSIST_PRE_CHG_RELAY_FLT_NAME,
            value: getHcmWorkInfoAssistPreChgRelayFltValue(),
        },
        {
            key: Common.YEOUL_HCM_WORK_INFO_WORK_INF_ALIVE_CNT_KEY,
            name: Common.YEOUL_HCM_WORK_INFO_WORK_INF_ALIVE_CNT_NAME,
            value: getHcmWorkInfoWorkInfAliveCntValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region VCU_HVFunctionCtrl
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcuHvFunctionCtrlPanelOpen, setVcuHvFunctionCtrlPanelOpen] = useState(false);
    const [vcuHvFunctionCtrlChartMounted, setVcuHvFunctionCtrlChartMounted] = useState(false);
    const [selectedVcuHvFunctionCtrl, setSelectedVcuHvFunctionCtrl] = useState<Array<React.Key>>([]);
    const [seriesChartDatasVcuHvFunctionCtrl, setSeriesChartDatasVcuHvFunctionCtrl] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcuHvFunctionCtrlMainPosCtrlComnd, setChartVcuHvFunctionCtrlMainPosCtrlComnd] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_MAIN_POS_CTRL_COMND_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlAllowChg, setChartVcuHvFunctionCtrlAllowChg] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_ALLOW_CHG_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlBmshvOnOffReq, setChartVcuHvFunctionCtrlBmshvOnOffReq] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_BMSHV_ON_OFF_REQ_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlTmsoffRequest, setChartVcuHvFunctionCtrlTmsoffRequest] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_TMSOFF_REQUEST_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlDcdcEnableOut, setChartVcuHvFunctionCtrlDcdcEnableOut] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_DCDC_ENABLE_OUT_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlBdcacEnableOut, setChartVcuHvFunctionCtrlBdcacEnableOut] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_BDCAC_ENABLE_OUT_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlSdcacEnableOut, setChartVcuHvFunctionCtrlSdcacEnableOut] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_SDCAC_ENABLE_OUT_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlAssitPosCtrlComnd, setChartVcuHvFunctionCtrlAssitPosCtrlComnd] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_ASSIT_POS_CTRL_COMND_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlHcmCutOffLV, setChartVcuHvFunctionCtrlHcmCutOffLV] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_HCM_CUT_OFF_LV_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlBmsCutOffLV, setChartVcuHvFunctionCtrlBmsCutOffLV] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_BMS_CUT_OFF_LV_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlMcuCutOffLV, setChartVcuHvFunctionCtrlMcuCutOffLV] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_MCU_CUT_OFF_LV_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlPtcCtrlCmd, setChartVcuHvFunctionCtrlPtcCtrlCmd] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_PTC_CTRL_CMD_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlDcdcPwrLmt, setChartVcuHvFunctionCtrlDcdcPwrLmt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_DCDC_PWR_LMT_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlSdcacOutFreq, setChartVcuHvFunctionCtrlSdcacOutFreq] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_SDCAC_OUT_FREQ_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlAssitPos2CtrlCmd, setChartVcuHvFunctionCtrlAssitPos2CtrlCmd] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_ASSIT_POS2_CTRL_CMD_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlMainNegCtrlComnd, setChartVcuHvFunctionCtrlMainNegCtrlComnd] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_MAIN_NEG_CTRL_COMND_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlLsdcacCtrlComnd, setChartVcuHvFunctionCtrlLsdcacCtrlComnd] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_LSDCAC_CTRL_COMND_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlSelfCheckSts, setChartVcuHvFunctionCtrlSelfCheckSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_SELF_CHECK_STS_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlHvFunctionCtrlAliverCounter, setChartVcuHvFunctionCtrlHvFunctionCtrlAliverCounter] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_HV_FUNCTION_CTRL_ALIVER_COUNTER_NAME,
        data: [],
    });

    const [chartVcuHvFunctionCtrlHvFunctionCtrlChecksum, setChartVcuHvFunctionCtrlHvFunctionCtrlChecksum] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_HV_FUNCTION_CTRL_CHECKSUM_NAME,
        data: [],
    });

    const getTableTooltipVcuHvFunctionCtrl = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_MAIN_POS_CTRL_COMND_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_MainPosCtrlComnd
                        </p>
                        <p>StartBit: 0, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_ALLOW_CHG_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_AllowChg
                        </p>
                        <p>StartBit: 2, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_BMSHV_ON_OFF_REQ_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_BMSHVOnOffReq
                        </p>
                        <p>StartBit: 4, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_TMSOFF_REQUEST_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_TMSOFF_Request
                        </p>
                        <p>StartBit: 6, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_DCDC_ENABLE_OUT_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_DCDCEnableOut
                        </p>
                        <p>StartBit: 8, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_BDCAC_ENABLE_OUT_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_BDCACEnableOut
                        </p>
                        <p>StartBit: 10, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_SDCAC_ENABLE_OUT_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_SDCACEnableOut
                        </p>
                        <p>StartBit: 12, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_ASSIT_POS_CTRL_COMND_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_AssitPosCtrlComnd
                        </p>
                        <p>StartBit: 14, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_HCM_CUT_OFF_LV_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_HCMCutOffLV
                        </p>
                        <p>StartBit: 16, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_BMS_CUT_OFF_LV_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_BMSCutOffLV
                        </p>
                        <p>StartBit: 18, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_MCU_CUT_OFF_LV_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_MCUCutOffLV
                        </p>
                        <p>StartBit: 20, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_PTC_CTRL_CMD_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_PTCCtrlCmd
                        </p>
                        <p>StartBit: 22, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_DCDC_PWR_LMT_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_DCDCPwrLmt
                        </p>
                        <p>StartBit: 24, Length: 8; Unit: ％; Factor: 0.4</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_SDCAC_OUT_FREQ_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_SDCACOutFreq
                        </p>
                        <p>StartBit: 32, Length: 8; Unit: Hz</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_ASSIT_POS2_CTRL_CMD_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_AssitPos2CtrlCmd
                        </p>
                        <p>StartBit: 44, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_MAIN_NEG_CTRL_COMND_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_MainNegCtrlComnd
                        </p>
                        <p>StartBit: 46, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_LSDCAC_CTRL_COMND_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_LSDCACCtrlComnd
                        </p>
                        <p>StartBit: 48, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_SELF_CHECK_STS_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_SelfCheckSts
                        </p>
                        <p>StartBit: 50, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_HV_FUNCTION_CTRL_ALIVER_COUNTER_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_HVFunctionCtrl_AliverCounter
                        </p>
                        <p>StartBit: 52, Length: 4; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_HV_FUNCTION_CTRL_CHECKSUM_KEY:
                return (
                    <>
                        <p>
                            VCU_HVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8627
                            <br />
                            Name: VCU_HVFunctionCtrl_Checksum
                        </p>
                        <p>StartBit: 56, Length: 8; Unit: bit</p>
                    </>
                );
        }
        return null;
    };

    const getVcuHvFunctionCtrlMainPosCtrlComndValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_MAIN_POS_CTRL_COMND_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.mainPosCtrlComnd);
        }
        return "";
    };

    const getVcuHvFunctionCtrlAllowChgValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_ALLOW_CHG_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.allowChg);
        }
        return "";
    };

    const getVcuHvFunctionCtrlBmshvOnOffReqValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_BMSHV_ON_OFF_REQ_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.bmshvOnOffReq);
        }
        return "";
    };

    const getVcuHvFunctionCtrlTmsoffRequestValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_TMSOFF_REQUEST_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.tmsoffRequest);
        }
        return "";
    };

    const getVcuHvFunctionCtrlDcdcEnableOutValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_DCDC_ENABLE_OUT_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.dcdcEnableOut);
        }
        return "";
    };

    const getVcuHvFunctionCtrlBdcacEnableOutValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_BDCAC_ENABLE_OUT_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.bdcacEnableOut);
        }
        return "";
    };

    const getVcuHvFunctionCtrlSdcacEnableOutValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_SDCAC_ENABLE_OUT_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.sdcacEnableOut);
        }
        return "";
    };

    const getVcuHvFunctionCtrlAssitPosCtrlComndValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_ASSIT_POS_CTRL_COMND_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.assitPosCtrlComnd);
        }
        return "";
    };

    const getVcuHvFunctionCtrlHcmCutOffLVValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_HCM_CUT_OFF_LV_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.hcmCutOffLV);
        }
        return "";
    };

    const getVcuHvFunctionCtrlBmsCutOffLVValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_BMS_CUT_OFF_LV_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.bmsCutOffLV);
        }
        return "";
    };

    const getVcuHvFunctionCtrlMcuCutOffLVValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_MCU_CUT_OFF_LV_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.mcuCutOffLV);
        }
        return "";
    };

    const getVcuHvFunctionCtrlPtcCtrlCmdValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_PTC_CTRL_CMD_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.ptcCtrlCmd);
        }
        return "";
    };

    const getVcuHvFunctionCtrlDcdcPwrLmtValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_DCDC_PWR_LMT_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkWithUnit(currentCanData.vcuHvFunctionCtrl.dcdcPwrLmt, "％");
        }
        return "";
    };

    const getVcuHvFunctionCtrlSdcacOutFreqValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_SDCAC_OUT_FREQ_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.sdcacOutFreq);
        }
        return "";
    };

    const getVcuHvFunctionCtrlAssitPos2CtrlCmdValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_ASSIT_POS2_CTRL_CMD_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.assitPos2CtrlCmd);
        }
        return "";
    };

    const getVcuHvFunctionCtrlMainNegCtrlComndValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_MAIN_NEG_CTRL_COMND_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.mainNegCtrlComnd);
        }
        return "";
    };

    const getVcuHvFunctionCtrlLsdcacCtrlComndValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_LSDCAC_CTRL_COMND_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.lsdcacCtrlComnd);
        }
        return "";
    };

    const getVcuHvFunctionCtrlSelfCheckStsValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_SELF_CHECK_STS_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.selfCheckSts);
        }
        return "";
    };

    const getVcuHvFunctionCtrlHvFunctionCtrlAliverCounterValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_HV_FUNCTION_CTRL_ALIVER_COUNTER_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.hvFunctionCtrlAliverCounter);
        }
        return "";
    };

    const getVcuHvFunctionCtrlHvFunctionCtrlChecksumValue = () => {
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_HV_FUNCTION_CTRL_CHECKSUM_KEY) && currentCanData?.vcuHvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuHvFunctionCtrl.hvFunctionCtrlChecksum);
        }
        return "";
    };

    const onChangeVcuHvFunctionCtrl = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcuHvFunctionCtrl(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcuHvFunctionCtrl: Array<TypeUtils.ChartData> = [];

        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_MAIN_POS_CTRL_COMND_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlMainPosCtrlComnd);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_ALLOW_CHG_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlAllowChg);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_BMSHV_ON_OFF_REQ_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlBmshvOnOffReq);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_TMSOFF_REQUEST_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlTmsoffRequest);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_DCDC_ENABLE_OUT_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlDcdcEnableOut);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_BDCAC_ENABLE_OUT_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlBdcacEnableOut);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_SDCAC_ENABLE_OUT_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlSdcacEnableOut);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_ASSIT_POS_CTRL_COMND_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlAssitPosCtrlComnd);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_HCM_CUT_OFF_LV_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlHcmCutOffLV);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_BMS_CUT_OFF_LV_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlBmsCutOffLV);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_MCU_CUT_OFF_LV_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlMcuCutOffLV);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_PTC_CTRL_CMD_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlPtcCtrlCmd);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_DCDC_PWR_LMT_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlDcdcPwrLmt);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_SDCAC_OUT_FREQ_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlSdcacOutFreq);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_ASSIT_POS2_CTRL_CMD_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlAssitPos2CtrlCmd);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_MAIN_NEG_CTRL_COMND_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlMainNegCtrlComnd);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_LSDCAC_CTRL_COMND_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlLsdcacCtrlComnd);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_SELF_CHECK_STS_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlSelfCheckSts);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_HV_FUNCTION_CTRL_ALIVER_COUNTER_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlHvFunctionCtrlAliverCounter);
        if (selectedVcuHvFunctionCtrl.includes(Common.YEOUL_VCU_HV_FUNCTION_CTRL_HV_FUNCTION_CTRL_CHECKSUM_KEY)) chartDatasVcuHvFunctionCtrl.push(chartVcuHvFunctionCtrlHvFunctionCtrlChecksum);

        setSeriesChartDatasVcuHvFunctionCtrl(chartDatasVcuHvFunctionCtrl);
    }, [selectedVcuHvFunctionCtrl, chartVcuHvFunctionCtrlMainPosCtrlComnd, chartVcuHvFunctionCtrlAllowChg, chartVcuHvFunctionCtrlBmshvOnOffReq, chartVcuHvFunctionCtrlTmsoffRequest, chartVcuHvFunctionCtrlDcdcEnableOut, chartVcuHvFunctionCtrlBdcacEnableOut, chartVcuHvFunctionCtrlSdcacEnableOut, chartVcuHvFunctionCtrlAssitPosCtrlComnd, chartVcuHvFunctionCtrlHcmCutOffLV, chartVcuHvFunctionCtrlBmsCutOffLV, chartVcuHvFunctionCtrlMcuCutOffLV, chartVcuHvFunctionCtrlPtcCtrlCmd, chartVcuHvFunctionCtrlDcdcPwrLmt, chartVcuHvFunctionCtrlSdcacOutFreq, chartVcuHvFunctionCtrlAssitPos2CtrlCmd, chartVcuHvFunctionCtrlMainNegCtrlComnd, chartVcuHvFunctionCtrlLsdcacCtrlComnd, chartVcuHvFunctionCtrlSelfCheckSts, chartVcuHvFunctionCtrlHvFunctionCtrlAliverCounter, chartVcuHvFunctionCtrlHvFunctionCtrlChecksum]);

    const tableDataVcuHvFunctionCtrl: CanTableType[] = [
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_MAIN_POS_CTRL_COMND_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_MAIN_POS_CTRL_COMND_NAME,
            value: getVcuHvFunctionCtrlMainPosCtrlComndValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_ALLOW_CHG_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_ALLOW_CHG_NAME,
            value: getVcuHvFunctionCtrlAllowChgValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_BMSHV_ON_OFF_REQ_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_BMSHV_ON_OFF_REQ_NAME,
            value: getVcuHvFunctionCtrlBmshvOnOffReqValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_TMSOFF_REQUEST_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_TMSOFF_REQUEST_NAME,
            value: getVcuHvFunctionCtrlTmsoffRequestValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_DCDC_ENABLE_OUT_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_DCDC_ENABLE_OUT_NAME,
            value: getVcuHvFunctionCtrlDcdcEnableOutValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_BDCAC_ENABLE_OUT_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_BDCAC_ENABLE_OUT_NAME,
            value: getVcuHvFunctionCtrlBdcacEnableOutValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_SDCAC_ENABLE_OUT_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_SDCAC_ENABLE_OUT_NAME,
            value: getVcuHvFunctionCtrlSdcacEnableOutValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_ASSIT_POS_CTRL_COMND_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_ASSIT_POS_CTRL_COMND_NAME,
            value: getVcuHvFunctionCtrlAssitPosCtrlComndValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_HCM_CUT_OFF_LV_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_HCM_CUT_OFF_LV_NAME,
            value: getVcuHvFunctionCtrlHcmCutOffLVValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_BMS_CUT_OFF_LV_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_BMS_CUT_OFF_LV_NAME,
            value: getVcuHvFunctionCtrlBmsCutOffLVValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_MCU_CUT_OFF_LV_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_MCU_CUT_OFF_LV_NAME,
            value: getVcuHvFunctionCtrlMcuCutOffLVValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_PTC_CTRL_CMD_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_PTC_CTRL_CMD_NAME,
            value: getVcuHvFunctionCtrlPtcCtrlCmdValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_DCDC_PWR_LMT_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_DCDC_PWR_LMT_NAME,
            value: getVcuHvFunctionCtrlDcdcPwrLmtValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_SDCAC_OUT_FREQ_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_SDCAC_OUT_FREQ_NAME,
            value: getVcuHvFunctionCtrlSdcacOutFreqValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_ASSIT_POS2_CTRL_CMD_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_ASSIT_POS2_CTRL_CMD_NAME,
            value: getVcuHvFunctionCtrlAssitPos2CtrlCmdValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_MAIN_NEG_CTRL_COMND_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_MAIN_NEG_CTRL_COMND_NAME,
            value: getVcuHvFunctionCtrlMainNegCtrlComndValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_LSDCAC_CTRL_COMND_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_LSDCAC_CTRL_COMND_NAME,
            value: getVcuHvFunctionCtrlLsdcacCtrlComndValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_SELF_CHECK_STS_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_SELF_CHECK_STS_NAME,
            value: getVcuHvFunctionCtrlSelfCheckStsValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_HV_FUNCTION_CTRL_ALIVER_COUNTER_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_HV_FUNCTION_CTRL_ALIVER_COUNTER_NAME,
            value: getVcuHvFunctionCtrlHvFunctionCtrlAliverCounterValue(),
        },
        {
            key: Common.YEOUL_VCU_HV_FUNCTION_CTRL_HV_FUNCTION_CTRL_CHECKSUM_KEY,
            name: Common.YEOUL_VCU_HV_FUNCTION_CTRL_HV_FUNCTION_CTRL_CHECKSUM_NAME,
            value: getVcuHvFunctionCtrlHvFunctionCtrlChecksumValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region VCU_LVFunctionCtrl
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcuLvFunctionCtrlPanelOpen, setVcuLvFunctionCtrlPanelOpen] = useState(false);
    const [vcuLvFunctionCtrlChartMounted, setVcuLvFunctionCtrlChartMounted] = useState(false);
    const [selectedVcuLvFunctionCtrl, setSelectedVcuLvFunctionCtrl] = useState<Array<React.Key>>([]);
    const [seriesChartDatasVcuLvFunctionCtrl, setSeriesChartDatasVcuLvFunctionCtrl] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcuLvFunctionCtrlDefrosterCtrlL, setChartVcuLvFunctionCtrlDefrosterCtrlL] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_LV_FUNCTION_CTRL_DEFROSTER_CTRL_L_NAME,
        data: [],
    });

    const [chartVcuLvFunctionCtrlDefrosterCtrlH, setChartVcuLvFunctionCtrlDefrosterCtrlH] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_LV_FUNCTION_CTRL_DEFROSTER_CTRL_H_NAME,
        data: [],
    });

    const [chartVcuLvFunctionCtrlAcPanelCtrl, setChartVcuLvFunctionCtrlAcPanelCtrl] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_LV_FUNCTION_CTRL_AC_PANEL_CTRL_NAME,
        data: [],
    });

    const [chartVcuLvFunctionCtrlHcmPowerCtrl, setChartVcuLvFunctionCtrlHcmPowerCtrl] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_LV_FUNCTION_CTRL_HCM_POWER_CTRL_NAME,
        data: [],
    });

    const [chartVcuLvFunctionCtrlCehModeCmd, setChartVcuLvFunctionCtrlCehModeCmd] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_MODE_CMD_NAME,
        data: [],
    });

    const [chartVcuLvFunctionCtrlCehPwmCmd, setChartVcuLvFunctionCtrlCehPwmCmd] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_PWM_CMD_NAME,
        data: [],
    });

    const [chartVcuLvFunctionCtrlCehTempCmd, setChartVcuLvFunctionCtrlCehTempCmd] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_TEMP_CMD_NAME,
        data: [],
    });

    const getTableTooltipVcuLvFunctionCtrl = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_VCU_LV_FUNCTION_CTRL_DEFROSTER_CTRL_L_KEY:
                return (
                    <>
                        <p>
                            VCU_LVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8927
                            <br />
                            Name: VCU_DefrosterCtrlL
                        </p>
                        <p>StartBit: 0, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_LV_FUNCTION_CTRL_DEFROSTER_CTRL_H_KEY:
                return (
                    <>
                        <p>
                            VCU_LVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8927
                            <br />
                            Name: VCU_DefrosterCtrlH
                        </p>
                        <p>StartBit: 2, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_LV_FUNCTION_CTRL_AC_PANEL_CTRL_KEY:
                return (
                    <>
                        <p>
                            VCU_LVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8927
                            <br />
                            Name: VCU_AC_PanelCtrl
                        </p>
                        <p>StartBit: 4, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_LV_FUNCTION_CTRL_HCM_POWER_CTRL_KEY:
                return (
                    <>
                        <p>
                            VCU_LVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8927
                            <br />
                            Name: VCU_HCMPowerCtrl
                        </p>
                        <p>StartBit: 12, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_MODE_CMD_KEY:
                return (
                    <>
                        <p>
                            VCU_LVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8927
                            <br />
                            Name: VCU_CEHModeCmd
                        </p>
                        <p>StartBit: 22, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_PWM_CMD_KEY:
                return (
                    <>
                        <p>
                            VCU_LVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8927
                            <br />
                            Name: VCU_CEH_PWMCmd
                        </p>
                        <p>StartBit: 24, Length: 8; Unit: %; Factor: 0.4</p>
                    </>
                );
            case Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_TEMP_CMD_KEY:
                return (
                    <>
                        <p>
                            VCU_LVFunctionCtrl
                            <br />
                            CAN ID: 0x0CFA8927
                            <br />
                            Name: VCU_CEH_TempCmd
                        </p>
                        <p>StartBit: 32, Length: 8; Unit: ℃; Offset: -40</p>
                    </>
                );
        }
        return null;
    };

    const getVcuLvFunctionCtrlDefrosterCtrlLValue = () => {
        if (selectedVcuLvFunctionCtrl.includes(Common.YEOUL_VCU_LV_FUNCTION_CTRL_DEFROSTER_CTRL_L_KEY) && currentCanData?.vcuLvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuLvFunctionCtrl.defrosterCtrlL);
        }
        return "";
    };

    const getVcuLvFunctionCtrlDefrosterCtrlHValue = () => {
        if (selectedVcuLvFunctionCtrl.includes(Common.YEOUL_VCU_LV_FUNCTION_CTRL_DEFROSTER_CTRL_H_KEY) && currentCanData?.vcuLvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuLvFunctionCtrl.defrosterCtrlH);
        }
        return "";
    };

    const getVcuLvFunctionCtrlAcPanelCtrlValue = () => {
        if (selectedVcuLvFunctionCtrl.includes(Common.YEOUL_VCU_LV_FUNCTION_CTRL_AC_PANEL_CTRL_KEY) && currentCanData?.vcuLvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuLvFunctionCtrl.acPanelCtrl);
        }
        return "";
    };

    const getVcuLvFunctionCtrlHcmPowerCtrlValue = () => {
        if (selectedVcuLvFunctionCtrl.includes(Common.YEOUL_VCU_LV_FUNCTION_CTRL_HCM_POWER_CTRL_KEY) && currentCanData?.vcuLvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuLvFunctionCtrl.hcmPowerCtrl);
        }
        return "";
    };

    const getVcuLvFunctionCtrlCehModeCmdValue = () => {
        if (selectedVcuLvFunctionCtrl.includes(Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_MODE_CMD_KEY) && currentCanData?.vcuLvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuLvFunctionCtrl.cehModeCmd);
        }
        return "";
    };

    const getVcuLvFunctionCtrlCehPwmCmdValue = () => {
        if (selectedVcuLvFunctionCtrl.includes(Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_PWM_CMD_KEY) && currentCanData?.vcuLvFunctionCtrl) {
            return convertRemarkWithUnit(currentCanData.vcuLvFunctionCtrl.cehPwmCmd, Common.UNIT_PERCENT);
        }
        return "";
    };

    const getVcuLvFunctionCtrlCehTempCmdValue = () => {
        if (selectedVcuLvFunctionCtrl.includes(Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_TEMP_CMD_KEY) && currentCanData?.vcuLvFunctionCtrl) {
            return convertRemarkString(currentCanData.vcuLvFunctionCtrl.cehTempCmd);
        }
        return "";
    };

    const onChangeVcuLvFunctionCtrl = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcuLvFunctionCtrl(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcuLvFunctionCtrl: Array<TypeUtils.ChartData> = [];

        if (selectedVcuLvFunctionCtrl.includes(Common.YEOUL_VCU_LV_FUNCTION_CTRL_DEFROSTER_CTRL_L_KEY)) chartDatasVcuLvFunctionCtrl.push(chartVcuLvFunctionCtrlDefrosterCtrlL);
        if (selectedVcuLvFunctionCtrl.includes(Common.YEOUL_VCU_LV_FUNCTION_CTRL_DEFROSTER_CTRL_H_KEY)) chartDatasVcuLvFunctionCtrl.push(chartVcuLvFunctionCtrlDefrosterCtrlH);
        if (selectedVcuLvFunctionCtrl.includes(Common.YEOUL_VCU_LV_FUNCTION_CTRL_AC_PANEL_CTRL_KEY)) chartDatasVcuLvFunctionCtrl.push(chartVcuLvFunctionCtrlAcPanelCtrl);
        if (selectedVcuLvFunctionCtrl.includes(Common.YEOUL_VCU_LV_FUNCTION_CTRL_HCM_POWER_CTRL_KEY)) chartDatasVcuLvFunctionCtrl.push(chartVcuLvFunctionCtrlHcmPowerCtrl);
        if (selectedVcuLvFunctionCtrl.includes(Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_MODE_CMD_KEY)) chartDatasVcuLvFunctionCtrl.push(chartVcuLvFunctionCtrlCehModeCmd);
        if (selectedVcuLvFunctionCtrl.includes(Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_PWM_CMD_KEY)) chartDatasVcuLvFunctionCtrl.push(chartVcuLvFunctionCtrlCehPwmCmd);
        if (selectedVcuLvFunctionCtrl.includes(Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_TEMP_CMD_KEY)) chartDatasVcuLvFunctionCtrl.push(chartVcuLvFunctionCtrlCehTempCmd);

        setSeriesChartDatasVcuLvFunctionCtrl(chartDatasVcuLvFunctionCtrl);
    }, [selectedVcuLvFunctionCtrl, chartVcuLvFunctionCtrlDefrosterCtrlL, chartVcuLvFunctionCtrlDefrosterCtrlH, chartVcuLvFunctionCtrlAcPanelCtrl, chartVcuLvFunctionCtrlHcmPowerCtrl, chartVcuLvFunctionCtrlCehModeCmd, chartVcuLvFunctionCtrlCehPwmCmd, chartVcuLvFunctionCtrlCehTempCmd]);

    const tableDataVcuLvFunctionCtrl: CanTableType[] = [
        {
            key: Common.YEOUL_VCU_LV_FUNCTION_CTRL_DEFROSTER_CTRL_L_KEY,
            name: Common.YEOUL_VCU_LV_FUNCTION_CTRL_DEFROSTER_CTRL_L_NAME,
            value: getVcuLvFunctionCtrlDefrosterCtrlLValue(),
        },
        {
            key: Common.YEOUL_VCU_LV_FUNCTION_CTRL_DEFROSTER_CTRL_H_KEY,
            name: Common.YEOUL_VCU_LV_FUNCTION_CTRL_DEFROSTER_CTRL_H_NAME,
            value: getVcuLvFunctionCtrlDefrosterCtrlHValue(),
        },
        {
            key: Common.YEOUL_VCU_LV_FUNCTION_CTRL_AC_PANEL_CTRL_KEY,
            name: Common.YEOUL_VCU_LV_FUNCTION_CTRL_AC_PANEL_CTRL_NAME,
            value: getVcuLvFunctionCtrlAcPanelCtrlValue(),
        },
        {
            key: Common.YEOUL_VCU_LV_FUNCTION_CTRL_HCM_POWER_CTRL_KEY,
            name: Common.YEOUL_VCU_LV_FUNCTION_CTRL_HCM_POWER_CTRL_NAME,
            value: getVcuLvFunctionCtrlHcmPowerCtrlValue(),
        },
        {
            key: Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_MODE_CMD_KEY,
            name: Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_MODE_CMD_NAME,
            value: getVcuLvFunctionCtrlCehModeCmdValue(),
        },
        {
            key: Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_PWM_CMD_KEY,
            name: Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_PWM_CMD_NAME,
            value: getVcuLvFunctionCtrlCehPwmCmdValue(),
        },
        {
            key: Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_TEMP_CMD_KEY,
            name: Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_TEMP_CMD_NAME,
            value: getVcuLvFunctionCtrlCehTempCmdValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region MCU_MotorElePara
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [mcuMotorEleParaPanelOpen, setMcuMotorEleParaPanelOpen] = useState(false);
    const [mcuMotorEleParaChartMounted, setMcuMotorEleParaChartMounted] = useState(false);
    const [selectedMcuMotorElePara, setSelectedMcuMotorElePara] = useState<Array<React.Key>>([]);
    const [seriesChartDatasMcuMotorElePara, setSeriesChartDatasMcuMotorElePara] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartMcuMotorEleParaHvBusVol, setChartMcuMotorEleParaHvBusVol] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_ELE_PARA_HV_BUS_VOL_NAME,
        data: [],
    });

    const getTableTooltipMcuMotorElePara = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_MCU_MOTOR_ELE_PARA_HV_BUS_VOL_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorElePara
                            <br />
                            CAN ID: 0x0CFA01EF
                            <br />
                            Name: MCU_HVBusVol
                        </p>
                        <p>StartBit: 0, Length: 16; Unit: V; Factor: 0.05</p>
                    </>
                );
        }
        return null;
    };

    const getMcuMotorEleParaHvBusVolValue = () => {
        if (selectedMcuMotorElePara.includes(Common.YEOUL_MCU_MOTOR_ELE_PARA_HV_BUS_VOL_KEY) && currentCanData?.mcuMotorElePara) {
            return convertRemarkWithUnit(currentCanData.mcuMotorElePara.hvBusVol, Common.UNIT_VOLTAGE);
        }
        return "";
    };

    const onChangeMcuMotorElePara = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedMcuMotorElePara(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasMcuMotorElePara: Array<TypeUtils.ChartData> = [];

        if (selectedMcuMotorElePara.includes(Common.YEOUL_MCU_MOTOR_ELE_PARA_HV_BUS_VOL_KEY)) chartDatasMcuMotorElePara.push(chartMcuMotorEleParaHvBusVol);

        setSeriesChartDatasMcuMotorElePara(chartDatasMcuMotorElePara);
    }, [selectedMcuMotorElePara, chartMcuMotorEleParaHvBusVol]);

    const tableDataMcuMotorElePara: CanTableType[] = [
        {
            key: Common.YEOUL_MCU_MOTOR_ELE_PARA_HV_BUS_VOL_KEY,
            name: Common.YEOUL_MCU_MOTOR_ELE_PARA_HV_BUS_VOL_NAME,
            value: getMcuMotorEleParaHvBusVolValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region BMS_BatPackLmt
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bmsBatPackLmtPanelOpen, setBmsBatPackLmtPanelOpen] = useState(false);
    const [bmsBatPackLmtChartMounted, setBmsBatPackLmtChartMounted] = useState(false);
    const [selectedBmsBatPackLmt, setSelectedBmsBatPackLmt] = useState<Array<React.Key>>([]);
    const [seriesChartDatasBmsBatPackLmt, setSeriesChartDatasBmsBatPackLmt] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBmsBatPackLmtMaxPmtEnyRecoCurr, setChartBmsBatPackLmtMaxPmtEnyRecoCurr] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_ENY_RECO_CURR_NAME,
        data: [],
    });

    const [chartBmsBatPackLmtMaxPmtDischgCurr, setChartBmsBatPackLmtMaxPmtDischgCurr] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_DISCHG_CURR_NAME,
        data: [],
    });

    const [chartBmsBatPackLmtBattMaxWorkTemp, setChartBmsBatPackLmtBattMaxWorkTemp] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BAT_PACK_LMT_BATT_MAX_WORK_TEMP_NAME,
        data: [],
    });

    const [chartBmsBatPackLmtBattMinWorkTemp, setChartBmsBatPackLmtBattMinWorkTemp] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BAT_PACK_LMT_BATT_MIN_WORK_TEMP_NAME,
        data: [],
    });

    const [chartBmsBatPackLmtMinPmtSOC, setChartBmsBatPackLmtMinPmtSOC] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BAT_PACK_LMT_MIN_PMT_SOC_NAME,
        data: [],
    });

    const [chartBmsBatPackLmtMaxPmtEnyRecoVol, setChartBmsBatPackLmtMaxPmtEnyRecoVol] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_ENY_RECO_VOL_NAME,
        data: [],
    });

    const getTableTooltipBmsBatPackLmt = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_ENY_RECO_CURR_KEY:
                return (
                    <>
                        <p>
                            BMS_BatPackLmt
                            <br />
                            CAN ID: 0x18FA43F4
                            <br />
                            Name: BMS_MaxPmtEnyRecoCurr
                        </p>
                        <p>StartBit: 0, Length: 16; Unit: A; Factor: 0.1; Offset: -1000</p>
                    </>
                );
            case Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_DISCHG_CURR_KEY:
                return (
                    <>
                        <p>
                            BMS_BatPackLmt
                            <br />
                            CAN ID: 0x18FA43F4
                            <br />
                            Name: BMS_MaxPmtDischgCurr
                        </p>
                        <p>StartBit: 16, Length: 16; Unit: A; Factor: 0.1; Offset: -1000</p>
                    </>
                );
            case Common.YEOUL_BMS_BAT_PACK_LMT_BATT_MAX_WORK_TEMP_KEY:
                return (
                    <>
                        <p>
                            BMS_BatPackLmt
                            <br />
                            CAN ID: 0x18FA43F4
                            <br />
                            Name: BMS_BattMaxWorkTemp
                        </p>
                        <p>StartBit: 32, Length: 8; Unit: °C; Offset: -40</p>
                    </>
                );
            case Common.YEOUL_BMS_BAT_PACK_LMT_BATT_MIN_WORK_TEMP_KEY:
                return (
                    <>
                        <p>
                            BMS_BatPackLmt
                            <br />
                            CAN ID: 0x18FA43F4
                            <br />
                            Name: BMS_BattMinWorkTemp
                        </p>
                        <p>StartBit: 40, Length: 8; Unit: °C; Offset: -40</p>
                    </>
                );
            case Common.YEOUL_BMS_BAT_PACK_LMT_MIN_PMT_SOC_KEY:
                return (
                    <>
                        <p>
                            BMS_BatPackLmt
                            <br />
                            CAN ID: 0x18FA43F4
                            <br />
                            Name: BMS_MinPmtSOC
                        </p>
                        <p>StartBit: 48, Length: 8; Unit: ％; Factor: 0.4</p>
                    </>
                );
            case Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_ENY_RECO_VOL_KEY:
                return (
                    <>
                        <p>
                            BMS_BatPackLmt
                            <br />
                            CAN ID: 0x18FA43F4
                            <br />
                            Name: BMS_MaxPmtEnyRecoVol
                        </p>
                        <p>StartBit: 56, Length: 8; Unit: ％; Factor: 0.4</p>
                    </>
                );
        }
        return null;
    };

    const getBmsBatPackLmtMaxPmtEnyRecoCurrValue = () => {
        if (selectedBmsBatPackLmt.includes(Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_ENY_RECO_CURR_KEY) && currentCanData?.bmsBatPackLmt) {
            return convertRemarkWithUnit(currentCanData.bmsBatPackLmt.maxPmtEnyRecoCurr, Common.UNIT_CURRENT);
        }
        return "";
    };

    const getBmsBatPackLmtMaxPmtDischgCurrValue = () => {
        if (selectedBmsBatPackLmt.includes(Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_DISCHG_CURR_KEY) && currentCanData?.bmsBatPackLmt) {
            return convertRemarkWithUnit(currentCanData.bmsBatPackLmt.maxPmtDischgCurr, Common.UNIT_CURRENT);
        }
        return "";
    };

    const getBmsBatPackLmtBattMaxWorkTempValue = () => {
        if (selectedBmsBatPackLmt.includes(Common.YEOUL_BMS_BAT_PACK_LMT_BATT_MAX_WORK_TEMP_KEY) && currentCanData?.bmsBatPackLmt) {
            return convertRemarkWithUnit(currentCanData.bmsBatPackLmt.battMaxWorkTemp, Common.UNIT_CELSIUS);
        }
        return "";
    };

    const getBmsBatPackLmtBattMinWorkTempValue = () => {
        if (selectedBmsBatPackLmt.includes(Common.YEOUL_BMS_BAT_PACK_LMT_BATT_MIN_WORK_TEMP_KEY) && currentCanData?.bmsBatPackLmt) {
            return convertRemarkWithUnit(currentCanData.bmsBatPackLmt.battMinWorkTemp, Common.UNIT_CELSIUS);
        }
        return "";
    };

    const getBmsBatPackLmtMinPmtSOCValue = () => {
        if (selectedBmsBatPackLmt.includes(Common.YEOUL_BMS_BAT_PACK_LMT_MIN_PMT_SOC_KEY) && currentCanData?.bmsBatPackLmt) {
            return convertRemarkWithUnit(currentCanData.bmsBatPackLmt.minPmtSOC, "％");
        }
        return "";
    };

    const getBmsBatPackLmtMaxPmtEnyRecoVolValue = () => {
        if (selectedBmsBatPackLmt.includes(Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_ENY_RECO_VOL_KEY) && currentCanData?.bmsBatPackLmt) {
            return convertRemarkWithUnit(currentCanData.bmsBatPackLmt.maxPmtEnyRecoVol, "％");
        }
        return "";
    };

    const onChangeBmsBatPackLmt = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBmsBatPackLmt(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBmsBatPackLmt: Array<TypeUtils.ChartData> = [];

        if (selectedBmsBatPackLmt.includes(Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_ENY_RECO_CURR_KEY)) chartDatasBmsBatPackLmt.push(chartBmsBatPackLmtMaxPmtEnyRecoCurr);
        if (selectedBmsBatPackLmt.includes(Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_DISCHG_CURR_KEY)) chartDatasBmsBatPackLmt.push(chartBmsBatPackLmtMaxPmtDischgCurr);
        if (selectedBmsBatPackLmt.includes(Common.YEOUL_BMS_BAT_PACK_LMT_BATT_MAX_WORK_TEMP_KEY)) chartDatasBmsBatPackLmt.push(chartBmsBatPackLmtBattMaxWorkTemp);
        if (selectedBmsBatPackLmt.includes(Common.YEOUL_BMS_BAT_PACK_LMT_BATT_MIN_WORK_TEMP_KEY)) chartDatasBmsBatPackLmt.push(chartBmsBatPackLmtBattMinWorkTemp);
        if (selectedBmsBatPackLmt.includes(Common.YEOUL_BMS_BAT_PACK_LMT_MIN_PMT_SOC_KEY)) chartDatasBmsBatPackLmt.push(chartBmsBatPackLmtMinPmtSOC);
        if (selectedBmsBatPackLmt.includes(Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_ENY_RECO_VOL_KEY)) chartDatasBmsBatPackLmt.push(chartBmsBatPackLmtMaxPmtEnyRecoVol);

        setSeriesChartDatasBmsBatPackLmt(chartDatasBmsBatPackLmt);
    }, [selectedBmsBatPackLmt, chartBmsBatPackLmtMaxPmtEnyRecoCurr, chartBmsBatPackLmtMaxPmtDischgCurr, chartBmsBatPackLmtBattMaxWorkTemp, chartBmsBatPackLmtBattMinWorkTemp, chartBmsBatPackLmtMinPmtSOC, chartBmsBatPackLmtMaxPmtEnyRecoVol]);

    const tableDataBmsBatPackLmt: CanTableType[] = [
        {
            key: Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_ENY_RECO_CURR_KEY,
            name: Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_ENY_RECO_CURR_NAME,
            value: getBmsBatPackLmtMaxPmtEnyRecoCurrValue(),
        },
        {
            key: Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_DISCHG_CURR_KEY,
            name: Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_DISCHG_CURR_NAME,
            value: getBmsBatPackLmtMaxPmtDischgCurrValue(),
        },
        {
            key: Common.YEOUL_BMS_BAT_PACK_LMT_BATT_MAX_WORK_TEMP_KEY,
            name: Common.YEOUL_BMS_BAT_PACK_LMT_BATT_MAX_WORK_TEMP_NAME,
            value: getBmsBatPackLmtBattMaxWorkTempValue(),
        },
        {
            key: Common.YEOUL_BMS_BAT_PACK_LMT_BATT_MIN_WORK_TEMP_KEY,
            name: Common.YEOUL_BMS_BAT_PACK_LMT_BATT_MIN_WORK_TEMP_NAME,
            value: getBmsBatPackLmtBattMinWorkTempValue(),
        },
        {
            key: Common.YEOUL_BMS_BAT_PACK_LMT_MIN_PMT_SOC_KEY,
            name: Common.YEOUL_BMS_BAT_PACK_LMT_MIN_PMT_SOC_NAME,
            value: getBmsBatPackLmtMinPmtSOCValue(),
        },
        {
            key: Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_ENY_RECO_VOL_KEY,
            name: Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_ENY_RECO_VOL_NAME,
            value: getBmsBatPackLmtMaxPmtEnyRecoVolValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region BMS_BattaryFltInfo
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bmsBattaryFltInfoPanelOpen, setBmsBattaryFltInfoPanelOpen] = useState(false);
    const [bmsBattaryFltInfoChartMounted, setBmsBattaryFltInfoChartMounted] = useState(false);
    const [selectedBmsBattaryFltInfo, setSelectedBmsBattaryFltInfo] = useState<Array<React.Key>>([]);
    const [seriesChartDatasBmsBattaryFltInfo, setSeriesChartDatasBmsBattaryFltInfo] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBmsBattaryFltInfoBattPackVolFault, setChartBmsBattaryFltInfoBattPackVolFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_PACK_VOL_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoBattCellVolFault, setChartBmsBattaryFltInfoBattCellVolFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_CELL_VOL_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoBattTempFault, setChartBmsBattaryFltInfoBattTempFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_TEMP_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoBattSocFault, setChartBmsBattaryFltInfoBattSocFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_SOC_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoSocJumpFault, setChartBmsBattaryFltInfoSocJumpFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_SOC_JUMP_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoBattEqualizationSts, setChartBmsBattaryFltInfoBattEqualizationSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_EQUALIZATION_STS_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoDischargeCurrFault, setChartBmsBattaryFltInfoDischargeCurrFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_DISCHARGE_CURR_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoChargeCurrFault, setChartBmsBattaryFltInfoChargeCurrFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_CHARGE_CURR_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoBattIsolationSts, setChartBmsBattaryFltInfoBattIsolationSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_ISOLATION_STS_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoCanComFault, setChartBmsBattaryFltInfoCanComFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_CAN_COM_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoBattPackMatchFault, setChartBmsBattaryFltInfoBattPackMatchFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_PACK_MATCH_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoBattConsistencyFlt, setChartBmsBattaryFltInfoBattConsistencyFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_CONSISTENCY_FLT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoCurrSensorFault, setChartBmsBattaryFltInfoCurrSensorFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_CURR_SENSOR_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoMsdFault, setChartBmsBattaryFltInfoMsdFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_MSD_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoHeatPosRelayFault, setChartBmsBattaryFltInfoHeatPosRelayFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_HEAT_POS_RELAY_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoHeatNegRelayFault, setChartBmsBattaryFltInfoHeatNegRelayFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_HEAT_NEG_RELAY_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoOverChgFault, setChartBmsBattaryFltInfoOverChgFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_OVER_CHG_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoSt1FltHw, setChartBmsBattaryFltInfoSt1FltHw] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_ST1_FLT_HW_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoPosRelayFault, setChartBmsBattaryFltInfoPosRelayFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_POS_RELAY_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoNegRelayFault, setChartBmsBattaryFltInfoNegRelayFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_NEG_RELAY_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoSt1FltHvil, setChartBmsBattaryFltInfoSt1FltHvil] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_ST1_FLT_HVIL_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoCellVolDiffFault, setChartBmsBattaryFltInfoCellVolDiffFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_CELL_VOL_DIFF_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoCellTempDiffFault, setChartBmsBattaryFltInfoCellTempDiffFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_CELL_TEMP_DIFF_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoEnyRecoCurrHighFlt, setChartBmsBattaryFltInfoEnyRecoCurrHighFlt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_ENY_RECO_CURR_HIGH_FLT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoPowerActiveMode, setChartBmsBattaryFltInfoPowerActiveMode] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_POWER_ACTIVE_MODE_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoBattFireFault, setChartBmsBattaryFltInfoBattFireFault] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_FIRE_FAULT_NAME,
        data: [],
    });

    const [chartBmsBattaryFltInfoBattFaultInfoAliveCnt, setChartBmsBattaryFltInfoBattFaultInfoAliveCnt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_FAULT_INFO_ALIVE_CNT_NAME,
        data: [],
    });

    const getTableTooltipBmsBattaryFltInfo = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_PACK_VOL_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_BattPackVolFault
                        </p>
                        <p>StartBit: 0, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_CELL_VOL_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_BattCellVolFault
                        </p>
                        <p>StartBit: 2, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_TEMP_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_BattTempFault
                        </p>
                        <p>StartBit: 4, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_SOC_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_BattSOCFault
                        </p>
                        <p>StartBit: 6, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_SOC_JUMP_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_SOCJumpFault
                        </p>
                        <p>StartBit: 8, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_EQUALIZATION_STS_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_BattEqualizationSts
                        </p>
                        <p>StartBit: 10, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_DISCHARGE_CURR_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_DischargeCurrFault
                        </p>
                        <p>StartBit: 12, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_CHARGE_CURR_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_ChargeCurrFault
                        </p>
                        <p>StartBit: 14, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_ISOLATION_STS_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_BattIsolationSts
                        </p>
                        <p>StartBit: 16, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_CAN_COM_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_CANComFault
                        </p>
                        <p>StartBit: 18, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_PACK_MATCH_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_BattPackMatchFault
                        </p>
                        <p>StartBit: 20, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_CONSISTENCY_FLT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_BattConsistencyFlt
                        </p>
                        <p>StartBit: 22, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_CURR_SENSOR_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_CurrSensorFault
                        </p>
                        <p>StartBit: 24, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_MSD_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_MSDFault
                        </p>
                        <p>StartBit: 26, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_HEAT_POS_RELAY_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_HeatPosRelayFault
                        </p>
                        <p>StartBit: 28, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_HEAT_NEG_RELAY_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_HeatNegRelayFault
                        </p>
                        <p>StartBit: 30, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_OVER_CHG_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_OverChgFault
                        </p>
                        <p>StartBit: 32, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_ST1_FLT_HW_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_ST1_Flt_HW
                        </p>
                        <p>StartBit: 34, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_POS_RELAY_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_PosRelayFault
                        </p>
                        <p>StartBit: 36, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_NEG_RELAY_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_NegRelayFault
                        </p>
                        <p>StartBit: 38, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_ST1_FLT_HVIL_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_ST1_Flt_HVIL
                        </p>
                        <p>StartBit: 40, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_CELL_VOL_DIFF_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_CellVolDiffFault
                        </p>
                        <p>StartBit: 42, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_CELL_TEMP_DIFF_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_CellTempDiffFault
                        </p>
                        <p>StartBit: 44, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_ENY_RECO_CURR_HIGH_FLT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_EnyRecoCurrHighFlt
                        </p>
                        <p>StartBit: 46, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_POWER_ACTIVE_MODE_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_PowerActiveMode
                        </p>
                        <p>StartBit: 48, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_FIRE_FAULT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_BattFireFault
                        </p>
                        <p>StartBit: 50, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_FAULT_INFO_ALIVE_CNT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattaryFltInfo
                            <br />
                            CAN ID: 0x18FA42F4
                            <br />
                            Name: BMS_BattFaultInfo_AliveCnt
                        </p>
                        <p>StartBit: 56, Length: 8; Unit: bit</p>
                    </>
                );
        }
        return null;
    };

    const getBmsBattaryFltInfoBattPackVolFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_PACK_VOL_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.battPackVolFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoBattCellVolFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_CELL_VOL_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.battCellVolFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoBattTempFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_TEMP_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.battTempFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoBattSocFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_SOC_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.battSocFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoSocJumpFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_SOC_JUMP_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.socJumpFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoBattEqualizationStsValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_EQUALIZATION_STS_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.battEqualizationSts);
        }
        return "";
    };

    const getBmsBattaryFltInfoDischargeCurrFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_DISCHARGE_CURR_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.dischargeCurrFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoChargeCurrFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_CHARGE_CURR_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.chargeCurrFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoBattIsolationStsValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_ISOLATION_STS_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.battIsolationSts);
        }
        return "";
    };

    const getBmsBattaryFltInfoCanComFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_CAN_COM_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.canComFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoBattPackMatchFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_PACK_MATCH_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.battPackMatchFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoBattConsistencyFltValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_CONSISTENCY_FLT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.battConsistencyFlt);
        }
        return "";
    };

    const getBmsBattaryFltInfoCurrSensorFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_CURR_SENSOR_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.currSensorFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoMsdFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_MSD_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.msdFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoHeatPosRelayFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_HEAT_POS_RELAY_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.heatPosRelayFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoHeatNegRelayFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_HEAT_NEG_RELAY_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.heatNegRelayFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoOverChgFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_OVER_CHG_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.overChgFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoSt1FltHwValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_ST1_FLT_HW_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.st1FltHw);
        }
        return "";
    };

    const getBmsBattaryFltInfoPosRelayFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_POS_RELAY_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.posRelayFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoNegRelayFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_NEG_RELAY_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.negRelayFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoSt1FltHvilValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_ST1_FLT_HVIL_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.st1FltHvil);
        }
        return "";
    };

    const getBmsBattaryFltInfoCellVolDiffFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_CELL_VOL_DIFF_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.cellVolDiffFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoCellTempDiffFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_CELL_TEMP_DIFF_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.cellTempDiffFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoEnyRecoCurrHighFltValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_ENY_RECO_CURR_HIGH_FLT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.enyRecoCurrHighFlt);
        }
        return "";
    };

    const getBmsBattaryFltInfoPowerActiveModeValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_POWER_ACTIVE_MODE_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.powerActiveMode);
        }
        return "";
    };

    const getBmsBattaryFltInfoBattFireFaultValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_FIRE_FAULT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.battFireFault);
        }
        return "";
    };

    const getBmsBattaryFltInfoBattFaultInfoAliveCntValue = () => {
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_FAULT_INFO_ALIVE_CNT_KEY) && currentCanData?.bmsBattaryFltInfo) {
            return convertRemarkString(currentCanData.bmsBattaryFltInfo.battFaultInfoAliveCnt);
        }
        return "";
    };

    const onChangeBmsBattaryFltInfo = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBmsBattaryFltInfo(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBmsBattaryFltInfo: Array<TypeUtils.ChartData> = [];

        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_PACK_VOL_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoBattPackVolFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_CELL_VOL_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoBattCellVolFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_TEMP_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoBattTempFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_SOC_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoBattSocFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_SOC_JUMP_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoSocJumpFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_EQUALIZATION_STS_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoBattEqualizationSts);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_DISCHARGE_CURR_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoDischargeCurrFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_CHARGE_CURR_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoChargeCurrFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_ISOLATION_STS_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoBattIsolationSts);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_CAN_COM_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoCanComFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_PACK_MATCH_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoBattPackMatchFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_CONSISTENCY_FLT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoBattConsistencyFlt);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_CURR_SENSOR_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoCurrSensorFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_MSD_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoMsdFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_HEAT_POS_RELAY_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoHeatPosRelayFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_HEAT_NEG_RELAY_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoHeatNegRelayFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_OVER_CHG_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoOverChgFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_ST1_FLT_HW_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoSt1FltHw);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_POS_RELAY_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoPosRelayFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_NEG_RELAY_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoNegRelayFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_ST1_FLT_HVIL_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoSt1FltHvil);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_CELL_VOL_DIFF_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoCellVolDiffFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_CELL_TEMP_DIFF_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoCellTempDiffFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_ENY_RECO_CURR_HIGH_FLT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoEnyRecoCurrHighFlt);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_POWER_ACTIVE_MODE_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoPowerActiveMode);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_FIRE_FAULT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoBattFireFault);
        if (selectedBmsBattaryFltInfo.includes(Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_FAULT_INFO_ALIVE_CNT_KEY)) chartDatasBmsBattaryFltInfo.push(chartBmsBattaryFltInfoBattFaultInfoAliveCnt);

        setSeriesChartDatasBmsBattaryFltInfo(chartDatasBmsBattaryFltInfo);
    }, [selectedBmsBattaryFltInfo, chartBmsBattaryFltInfoBattPackVolFault, chartBmsBattaryFltInfoBattCellVolFault, chartBmsBattaryFltInfoBattTempFault, chartBmsBattaryFltInfoBattSocFault, chartBmsBattaryFltInfoSocJumpFault, chartBmsBattaryFltInfoBattEqualizationSts, chartBmsBattaryFltInfoDischargeCurrFault, chartBmsBattaryFltInfoChargeCurrFault, chartBmsBattaryFltInfoBattIsolationSts, chartBmsBattaryFltInfoCanComFault, chartBmsBattaryFltInfoBattPackMatchFault, chartBmsBattaryFltInfoBattConsistencyFlt, chartBmsBattaryFltInfoCurrSensorFault, chartBmsBattaryFltInfoMsdFault, chartBmsBattaryFltInfoHeatPosRelayFault, chartBmsBattaryFltInfoHeatNegRelayFault, chartBmsBattaryFltInfoOverChgFault, chartBmsBattaryFltInfoSt1FltHw, chartBmsBattaryFltInfoPosRelayFault, chartBmsBattaryFltInfoNegRelayFault, chartBmsBattaryFltInfoSt1FltHvil, chartBmsBattaryFltInfoCellVolDiffFault, chartBmsBattaryFltInfoCellTempDiffFault, chartBmsBattaryFltInfoEnyRecoCurrHighFlt, chartBmsBattaryFltInfoPowerActiveMode, chartBmsBattaryFltInfoBattFireFault, chartBmsBattaryFltInfoBattFaultInfoAliveCnt]);

    const tableDataBmsBattaryFltInfo: CanTableType[] = [
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_PACK_VOL_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_PACK_VOL_FAULT_NAME,
            value: getBmsBattaryFltInfoBattPackVolFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_CELL_VOL_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_CELL_VOL_FAULT_NAME,
            value: getBmsBattaryFltInfoBattCellVolFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_TEMP_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_TEMP_FAULT_NAME,
            value: getBmsBattaryFltInfoBattTempFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_SOC_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_SOC_FAULT_NAME,
            value: getBmsBattaryFltInfoBattSocFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_SOC_JUMP_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_SOC_JUMP_FAULT_NAME,
            value: getBmsBattaryFltInfoSocJumpFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_EQUALIZATION_STS_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_EQUALIZATION_STS_NAME,
            value: getBmsBattaryFltInfoBattEqualizationStsValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_DISCHARGE_CURR_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_DISCHARGE_CURR_FAULT_NAME,
            value: getBmsBattaryFltInfoDischargeCurrFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_CHARGE_CURR_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_CHARGE_CURR_FAULT_NAME,
            value: getBmsBattaryFltInfoChargeCurrFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_ISOLATION_STS_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_ISOLATION_STS_NAME,
            value: getBmsBattaryFltInfoBattIsolationStsValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_CAN_COM_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_CAN_COM_FAULT_NAME,
            value: getBmsBattaryFltInfoCanComFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_PACK_MATCH_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_PACK_MATCH_FAULT_NAME,
            value: getBmsBattaryFltInfoBattPackMatchFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_CONSISTENCY_FLT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_CONSISTENCY_FLT_NAME,
            value: getBmsBattaryFltInfoBattConsistencyFltValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_CURR_SENSOR_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_CURR_SENSOR_FAULT_NAME,
            value: getBmsBattaryFltInfoCurrSensorFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_MSD_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_MSD_FAULT_NAME,
            value: getBmsBattaryFltInfoMsdFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_HEAT_POS_RELAY_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_HEAT_POS_RELAY_FAULT_NAME,
            value: getBmsBattaryFltInfoHeatPosRelayFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_HEAT_NEG_RELAY_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_HEAT_NEG_RELAY_FAULT_NAME,
            value: getBmsBattaryFltInfoHeatNegRelayFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_OVER_CHG_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_OVER_CHG_FAULT_NAME,
            value: getBmsBattaryFltInfoOverChgFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_ST1_FLT_HW_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_ST1_FLT_HW_NAME,
            value: getBmsBattaryFltInfoSt1FltHwValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_POS_RELAY_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_POS_RELAY_FAULT_NAME,
            value: getBmsBattaryFltInfoPosRelayFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_NEG_RELAY_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_NEG_RELAY_FAULT_NAME,
            value: getBmsBattaryFltInfoNegRelayFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_ST1_FLT_HVIL_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_ST1_FLT_HVIL_NAME,
            value: getBmsBattaryFltInfoSt1FltHvilValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_CELL_VOL_DIFF_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_CELL_VOL_DIFF_FAULT_NAME,
            value: getBmsBattaryFltInfoCellVolDiffFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_CELL_TEMP_DIFF_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_CELL_TEMP_DIFF_FAULT_NAME,
            value: getBmsBattaryFltInfoCellTempDiffFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_ENY_RECO_CURR_HIGH_FLT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_ENY_RECO_CURR_HIGH_FLT_NAME,
            value: getBmsBattaryFltInfoEnyRecoCurrHighFltValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_POWER_ACTIVE_MODE_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_POWER_ACTIVE_MODE_NAME,
            value: getBmsBattaryFltInfoPowerActiveModeValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_FIRE_FAULT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_FIRE_FAULT_NAME,
            value: getBmsBattaryFltInfoBattFireFaultValue(),
        },
        {
            key: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_FAULT_INFO_ALIVE_CNT_KEY,
            name: Common.YEOUL_BMS_BATTARY_FLT_INFO_BATT_FAULT_INFO_ALIVE_CNT_NAME,
            value: getBmsBattaryFltInfoBattFaultInfoAliveCntValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region BMS_CellVoltData
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bmsCellVoltDataPanelOpen, setBmsCellVoltDataPanelOpen] = useState(false);
    const [bmsCellVoltDataChartMounted, setBmsCellVoltDataChartMounted] = useState(false);
    const [selectedBmsCellVoltData, setSelectedBmsCellVoltData] = useState<Array<React.Key>>([]);
    const [seriesChartDatasBmsCellVoltData, setSeriesChartDatasBmsCellVoltData] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBmsCellVoltDataCellVolt1, setChartBmsCellVoltDataCellVolt1] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT1_NAME,
        data: [],
    });

    const [chartBmsCellVoltDataCellVolt2, setChartBmsCellVoltDataCellVolt2] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT2_NAME,
        data: [],
    });

    const [chartBmsCellVoltDataCellVolt3, setChartBmsCellVoltDataCellVolt3] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT3_NAME,
        data: [],
    });

    const [chartBmsCellVoltDataCellVolt4, setChartBmsCellVoltDataCellVolt4] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT4_NAME,
        data: [],
    });

    const getTableTooltipBmsCellVoltData = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT1_KEY:
                return (
                    <>
                        <p>
                            BMS_CellVoltData
                            <br />
                            CAN ID: 0x18FA4EF4
                            <br />
                            Name: BMS_CellVolt1
                        </p>
                        <p>StartBit: 0, Length: 16; Unit: V; Factor: 0.001</p>
                    </>
                );
            case Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT2_KEY:
                return (
                    <>
                        <p>
                            BMS_CellVoltData
                            <br />
                            CAN ID: 0x18FA4EF4
                            <br />
                            Name: BMS_CellVolt2
                        </p>
                        <p>StartBit: 16, Length: 16; Unit: V; Factor: 0.001</p>
                    </>
                );
            case Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT3_KEY:
                return (
                    <>
                        <p>
                            BMS_CellVoltData
                            <br />
                            CAN ID: 0x18FA4EF4
                            <br />
                            Name: BMS_CellVolt3
                        </p>
                        <p>StartBit: 32, Length: 16; Unit: V; Factor: 0.001</p>
                    </>
                );
            case Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT4_KEY:
                return (
                    <>
                        <p>
                            BMS_CellVoltData
                            <br />
                            CAN ID: 0x18FA4EF4
                            <br />
                            Name: BMS_CellVolt4
                        </p>
                        <p>StartBit: 48, Length: 16; Unit: V; Factor: 0.001</p>
                    </>
                );
        }
        return null;
    };

    const getBmsCellVoltDataCellVolt1Value = () => {
        if (selectedBmsCellVoltData.includes(Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT1_KEY) && currentCanData?.bmsCellVoltData) {
            return convertRemarkWithUnit(currentCanData.bmsCellVoltData.cellVolt1, Common.UNIT_VOLTAGE);
        }
        return "";
    };

    const getBmsCellVoltDataCellVolt2Value = () => {
        if (selectedBmsCellVoltData.includes(Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT2_KEY) && currentCanData?.bmsCellVoltData) {
            return convertRemarkWithUnit(currentCanData.bmsCellVoltData.cellVolt2, Common.UNIT_VOLTAGE);
        }
        return "";
    };

    const getBmsCellVoltDataCellVolt3Value = () => {
        if (selectedBmsCellVoltData.includes(Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT3_KEY) && currentCanData?.bmsCellVoltData) {
            return convertRemarkWithUnit(currentCanData.bmsCellVoltData.cellVolt3, Common.UNIT_VOLTAGE);
        }
        return "";
    };

    const getBmsCellVoltDataCellVolt4Value = () => {
        if (selectedBmsCellVoltData.includes(Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT4_KEY) && currentCanData?.bmsCellVoltData) {
            return convertRemarkWithUnit(currentCanData.bmsCellVoltData.cellVolt4, Common.UNIT_VOLTAGE);
        }
        return "";
    };

    const onChangeBmsCellVoltData = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBmsCellVoltData(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBmsCellVoltData: Array<TypeUtils.ChartData> = [];

        if (selectedBmsCellVoltData.includes(Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT1_KEY)) chartDatasBmsCellVoltData.push(chartBmsCellVoltDataCellVolt1);
        if (selectedBmsCellVoltData.includes(Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT2_KEY)) chartDatasBmsCellVoltData.push(chartBmsCellVoltDataCellVolt2);
        if (selectedBmsCellVoltData.includes(Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT3_KEY)) chartDatasBmsCellVoltData.push(chartBmsCellVoltDataCellVolt3);
        if (selectedBmsCellVoltData.includes(Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT4_KEY)) chartDatasBmsCellVoltData.push(chartBmsCellVoltDataCellVolt4);

        setSeriesChartDatasBmsCellVoltData(chartDatasBmsCellVoltData);
    }, [selectedBmsCellVoltData, chartBmsCellVoltDataCellVolt1, chartBmsCellVoltDataCellVolt2, chartBmsCellVoltDataCellVolt3, chartBmsCellVoltDataCellVolt4]);

    const tableDataBmsCellVoltData: CanTableType[] = [
        {
            key: Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT1_KEY,
            name: Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT1_NAME,
            value: getBmsCellVoltDataCellVolt1Value(),
        },
        {
            key: Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT2_KEY,
            name: Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT2_NAME,
            value: getBmsCellVoltDataCellVolt2Value(),
        },
        {
            key: Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT3_KEY,
            name: Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT3_NAME,
            value: getBmsCellVoltDataCellVolt3Value(),
        },
        {
            key: Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT4_KEY,
            name: Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT4_NAME,
            value: getBmsCellVoltDataCellVolt4Value(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region BMS_CellTempData
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bmsCellTempDataPanelOpen, setBmsCellTempDataPanelOpen] = useState(false);
    const [bmsCellTempDataChartMounted, setBmsCellTempDataChartMounted] = useState(false);
    const [selectedBmsCellTempData, setSelectedBmsCellTempData] = useState<Array<React.Key>>([]);
    const [seriesChartDatasBmsCellTempData, setSeriesChartDatasBmsCellTempData] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBmsCellTempDataBattTemp1, setChartBmsCellTempDataBattTemp1] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP1_NAME,
        data: [],
    });

    const [chartBmsCellTempDataBattTemp2, setChartBmsCellTempDataBattTemp2] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP2_NAME,
        data: [],
    });

    const [chartBmsCellTempDataBattTemp3, setChartBmsCellTempDataBattTemp3] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP3_NAME,
        data: [],
    });

    const [chartBmsCellTempDataBattTemp4, setChartBmsCellTempDataBattTemp4] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP4_NAME,
        data: [],
    });

    const [chartBmsCellTempDataBattTemp5, setChartBmsCellTempDataBattTemp5] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP5_NAME,
        data: [],
    });

    const [chartBmsCellTempDataBattTemp6, setChartBmsCellTempDataBattTemp6] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP6_NAME,
        data: [],
    });

    const [chartBmsCellTempDataBattTemp7, setChartBmsCellTempDataBattTemp7] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP7_NAME,
        data: [],
    });

    const [chartBmsCellTempDataBattTemp8, setChartBmsCellTempDataBattTemp8] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP8_NAME,
        data: [],
    });

    const getTableTooltipBmsCellTempData = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP1_KEY:
                return (
                    <>
                        <p>
                            BMS_CellTempData
                            <br />
                            CAN ID: 0x18FA4FF4
                            <br />
                            Name: BMS_BattTemp1
                        </p>
                        <p>StartBit: 0, Length: 8; Unit: °C; Offset: -40</p>
                    </>
                );
            case Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP2_KEY:
                return (
                    <>
                        <p>
                            BMS_CellTempData
                            <br />
                            CAN ID: 0x18FA4FF4
                            <br />
                            Name: BMS_BattTemp2
                        </p>
                        <p>StartBit: 8, Length: 8; Unit: °C; Offset: -40</p>
                    </>
                );
            case Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP3_KEY:
                return (
                    <>
                        <p>
                            BMS_CellTempData
                            <br />
                            CAN ID: 0x18FA4FF4
                            <br />
                            Name: BMS_BattTemp3
                        </p>
                        <p>StartBit: 16, Length: 8; Unit: °C; Offset: -40</p>
                    </>
                );
            case Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP4_KEY:
                return (
                    <>
                        <p>
                            BMS_CellTempData
                            <br />
                            CAN ID: 0x18FA4FF4
                            <br />
                            Name: BMS_BattTemp4
                        </p>
                        <p>StartBit: 24, Length: 8; Unit: °C; Offset: -40</p>
                    </>
                );
            case Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP5_KEY:
                return (
                    <>
                        <p>
                            BMS_CellTempData
                            <br />
                            CAN ID: 0x18FA4FF4
                            <br />
                            Name: BMS_BattTemp5
                        </p>
                        <p>StartBit: 32, Length: 8; Unit: °C; Offset: -40</p>
                    </>
                );
            case Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP6_KEY:
                return (
                    <>
                        <p>
                            BMS_CellTempData
                            <br />
                            CAN ID: 0x18FA4FF4
                            <br />
                            Name: BMS_BattTemp6
                        </p>
                        <p>StartBit: 40, Length: 8; Unit: °C; Offset: -40</p>
                    </>
                );
            case Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP7_KEY:
                return (
                    <>
                        <p>
                            BMS_CellTempData
                            <br />
                            CAN ID: 0x18FA4FF4
                            <br />
                            Name: BMS_BattTemp7
                        </p>
                        <p>StartBit: 48, Length: 8; Unit: °C; Offset: -40</p>
                    </>
                );
            case Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP8_KEY:
                return (
                    <>
                        <p>
                            BMS_CellTempData
                            <br />
                            CAN ID: 0x18FA4FF4
                            <br />
                            Name: BMS_BattTemp8
                        </p>
                        <p>StartBit: 56, Length: 8; Unit: °C; Offset: -40</p>
                    </>
                );
        }
        return null;
    };

    const getBmsCellTempDataBattTemp1Value = () => {
        if (selectedBmsCellTempData.includes(Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP1_KEY) && currentCanData?.bmsCellTempData) {
            return convertRemarkWithUnit(currentCanData.bmsCellTempData.battTemp1, Common.UNIT_CELSIUS);
        }
        return "";
    };

    const getBmsCellTempDataBattTemp2Value = () => {
        if (selectedBmsCellTempData.includes(Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP2_KEY) && currentCanData?.bmsCellTempData) {
            return convertRemarkWithUnit(currentCanData.bmsCellTempData.battTemp2, Common.UNIT_CELSIUS);
        }
        return "";
    };

    const getBmsCellTempDataBattTemp3Value = () => {
        if (selectedBmsCellTempData.includes(Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP3_KEY) && currentCanData?.bmsCellTempData) {
            return convertRemarkWithUnit(currentCanData.bmsCellTempData.battTemp3, Common.UNIT_CELSIUS);
        }
        return "";
    };

    const getBmsCellTempDataBattTemp4Value = () => {
        if (selectedBmsCellTempData.includes(Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP4_KEY) && currentCanData?.bmsCellTempData) {
            return convertRemarkWithUnit(currentCanData.bmsCellTempData.battTemp4, Common.UNIT_CELSIUS);
        }
        return "";
    };

    const getBmsCellTempDataBattTemp5Value = () => {
        if (selectedBmsCellTempData.includes(Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP5_KEY) && currentCanData?.bmsCellTempData) {
            return convertRemarkWithUnit(currentCanData.bmsCellTempData.battTemp5, Common.UNIT_CELSIUS);
        }
        return "";
    };

    const getBmsCellTempDataBattTemp6Value = () => {
        if (selectedBmsCellTempData.includes(Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP6_KEY) && currentCanData?.bmsCellTempData) {
            return convertRemarkWithUnit(currentCanData.bmsCellTempData.battTemp6, Common.UNIT_CELSIUS);
        }
        return "";
    };

    const getBmsCellTempDataBattTemp7Value = () => {
        if (selectedBmsCellTempData.includes(Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP7_KEY) && currentCanData?.bmsCellTempData) {
            return convertRemarkWithUnit(currentCanData.bmsCellTempData.battTemp7, Common.UNIT_CELSIUS);
        }
        return "";
    };

    const getBmsCellTempDataBattTemp8Value = () => {
        if (selectedBmsCellTempData.includes(Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP8_KEY) && currentCanData?.bmsCellTempData) {
            return convertRemarkWithUnit(currentCanData.bmsCellTempData.battTemp8, Common.UNIT_CELSIUS);
        }
        return "";
    };

    const onChangeBmsCellTempData = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBmsCellTempData(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBmsCellTempData: Array<TypeUtils.ChartData> = [];

        if (selectedBmsCellTempData.includes(Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP1_KEY)) chartDatasBmsCellTempData.push(chartBmsCellTempDataBattTemp1);
        if (selectedBmsCellTempData.includes(Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP2_KEY)) chartDatasBmsCellTempData.push(chartBmsCellTempDataBattTemp2);
        if (selectedBmsCellTempData.includes(Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP3_KEY)) chartDatasBmsCellTempData.push(chartBmsCellTempDataBattTemp3);
        if (selectedBmsCellTempData.includes(Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP4_KEY)) chartDatasBmsCellTempData.push(chartBmsCellTempDataBattTemp4);
        if (selectedBmsCellTempData.includes(Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP5_KEY)) chartDatasBmsCellTempData.push(chartBmsCellTempDataBattTemp5);
        if (selectedBmsCellTempData.includes(Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP6_KEY)) chartDatasBmsCellTempData.push(chartBmsCellTempDataBattTemp6);
        if (selectedBmsCellTempData.includes(Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP7_KEY)) chartDatasBmsCellTempData.push(chartBmsCellTempDataBattTemp7);
        if (selectedBmsCellTempData.includes(Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP8_KEY)) chartDatasBmsCellTempData.push(chartBmsCellTempDataBattTemp8);

        setSeriesChartDatasBmsCellTempData(chartDatasBmsCellTempData);
    }, [selectedBmsCellTempData, chartBmsCellTempDataBattTemp1, chartBmsCellTempDataBattTemp2, chartBmsCellTempDataBattTemp3, chartBmsCellTempDataBattTemp4, chartBmsCellTempDataBattTemp5, chartBmsCellTempDataBattTemp6, chartBmsCellTempDataBattTemp7, chartBmsCellTempDataBattTemp8]);

    const tableDataBmsCellTempData: CanTableType[] = [
        {
            key: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP1_KEY,
            name: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP1_NAME,
            value: getBmsCellTempDataBattTemp1Value(),
        },
        {
            key: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP2_KEY,
            name: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP2_NAME,
            value: getBmsCellTempDataBattTemp2Value(),
        },
        {
            key: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP3_KEY,
            name: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP3_NAME,
            value: getBmsCellTempDataBattTemp3Value(),
        },
        {
            key: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP4_KEY,
            name: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP4_NAME,
            value: getBmsCellTempDataBattTemp4Value(),
        },
        {
            key: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP5_KEY,
            name: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP5_NAME,
            value: getBmsCellTempDataBattTemp5Value(),
        },
        {
            key: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP6_KEY,
            name: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP6_NAME,
            value: getBmsCellTempDataBattTemp6Value(),
        },
        {
            key: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP7_KEY,
            name: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP7_NAME,
            value: getBmsCellTempDataBattTemp7Value(),
        },
        {
            key: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP8_KEY,
            name: Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP8_NAME,
            value: getBmsCellTempDataBattTemp8Value(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region IC_Odometer
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [icOdometerPanelOpen, setIcOdometerPanelOpen] = useState(false);
    const [icOdometerChartMounted, setIcOdometerChartMounted] = useState(false);
    const [selectedIcOdometer, setSelectedIcOdometer] = useState<Array<React.Key>>([]);
    const [seriesChartDatasIcOdometer, setSeriesChartDatasIcOdometer] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartIcOdometerTrip, setChartIcOdometerTrip] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_ODOMETER_TRIP_NAME,
        data: [],
    });

    const [chartIcOdometerOdometer, setChartIcOdometerOdometer] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_ODOMETER_ODOMETER_NAME,
        data: [],
    });

    const getTableTooltipIcOdometer = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_IC_ODOMETER_TRIP_KEY:
                return (
                    <>
                        <p>
                            IC_Odometer
                            <br />
                            CAN ID: 0x18FEE017
                            <br />
                            Name: IC_Trip
                        </p>
                        <p>StartBit: 0, Length: 32; Unit: km; Factor: 0.125</p>
                    </>
                );
            case Common.YEOUL_IC_ODOMETER_ODOMETER_KEY:
                return (
                    <>
                        <p>
                            IC_Odometer
                            <br />
                            CAN ID: 0x18FEE017
                            <br />
                            Name: IC_Odometer
                        </p>
                        <p>StartBit: 32, Length: 32; Unit: km; Factor: 0.125</p>
                    </>
                );
        }
        return null;
    };

    const getIcOdometerTripValue = () => {
        if (selectedIcOdometer.includes(Common.YEOUL_IC_ODOMETER_TRIP_KEY) && currentCanData?.icOdometer) {
            return convertRemarkWithUnit(currentCanData.icOdometer.trip, Common.UNIT_DISTANCE);
        }
        return "";
    };

    const getIcOdometerOdometerValue = () => {
        if (selectedIcOdometer.includes(Common.YEOUL_IC_ODOMETER_ODOMETER_KEY) && currentCanData?.icOdometer) {
            return convertRemarkWithUnit(currentCanData.icOdometer.odometer, Common.UNIT_DISTANCE);
        }
        return "";
    };

    const onChangeIcOdometer = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedIcOdometer(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasIcOdometer: Array<TypeUtils.ChartData> = [];

        if (selectedIcOdometer.includes(Common.YEOUL_IC_ODOMETER_TRIP_KEY)) chartDatasIcOdometer.push(chartIcOdometerTrip);
        if (selectedIcOdometer.includes(Common.YEOUL_IC_ODOMETER_ODOMETER_KEY)) chartDatasIcOdometer.push(chartIcOdometerOdometer);

        setSeriesChartDatasIcOdometer(chartDatasIcOdometer);
    }, [selectedIcOdometer, chartIcOdometerTrip, chartIcOdometerOdometer]);

    const tableDataIcOdometer: CanTableType[] = [
        {
            key: Common.YEOUL_IC_ODOMETER_TRIP_KEY,
            name: Common.YEOUL_IC_ODOMETER_TRIP_NAME,
            value: getIcOdometerTripValue(),
        },
        {
            key: Common.YEOUL_IC_ODOMETER_ODOMETER_KEY,
            name: Common.YEOUL_IC_ODOMETER_ODOMETER_NAME,
            value: getIcOdometerOdometerValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region IC_DoorSts
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [icDoorStsPanelOpen, setIcDoorStsPanelOpen] = useState(false);
    const [icDoorStsChartMounted, setIcDoorStsChartMounted] = useState(false);
    const [selectedIcDoorSts, setSelectedIcDoorSts] = useState<Array<React.Key>>([]);
    const [seriesChartDatasIcDoorSts, setSeriesChartDatasIcDoorSts] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartIcDoorStsBatteryLowvtge, setChartIcDoorStsBatteryLowvtge] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_BATTERY_LOWVTGE_NAME,
        data: [],
    });

    const [chartIcDoorStsDoor1OpenSts, setChartIcDoorStsDoor1OpenSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_DOOR1_OPEN_STS_NAME,
        data: [],
    });

    const [chartIcDoorStsDriverSeatbelts, setChartIcDoorStsDriverSeatbelts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_DRIVER_SEATBELTS_NAME,
        data: [],
    });

    const [chartIcDoorStsLampcircuitSts, setChartIcDoorStsLampcircuitSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_LAMPCIRCUIT_STS_NAME,
        data: [],
    });

    const [chartIcDoorStsDoor2OpenSts, setChartIcDoorStsDoor2OpenSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_DOOR2_OPEN_STS_NAME,
        data: [],
    });

    const [chartIcDoorStsDoorBell, setChartIcDoorStsDoorBell] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_DOOR_BELL_NAME,
        data: [],
    });

    const [chartIcDoorStsDriverSeat, setChartIcDoorStsDriverSeat] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_DRIVER_SEAT_NAME,
        data: [],
    });

    const [chartIcDoorStsTrumpetSts, setChartIcDoorStsTrumpetSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_TRUMPET_STS_NAME,
        data: [],
    });

    const [chartIcDoorStsDoor3OpenSts, setChartIcDoorStsDoor3OpenSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_DOOR3_OPEN_STS_NAME,
        data: [],
    });

    const [chartIcDoorStsPowerMode, setChartIcDoorStsPowerMode] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_POWER_MODE_NAME,
        data: [],
    });

    const [chartIcDoorStsDoor5LockSts, setChartIcDoorStsDoor5LockSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_DOOR5_LOCK_STS_NAME,
        data: [],
    });

    const [chartIcDoorStsDoor4OpenSts, setChartIcDoorStsDoor4OpenSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_DOOR4_OPEN_STS_NAME,
        data: [],
    });

    const [chartIcDoorStsFrontAirTankPrsure, setChartIcDoorStsFrontAirTankPrsure] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_FRONT_AIR_TANK_PRSURE_NAME,
        data: [],
    });

    const [chartIcDoorStsFrontAirTankLowPrsureAlarm, setChartIcDoorStsFrontAirTankLowPrsureAlarm] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_FRONT_AIR_TANK_LOW_PRSURE_ALARM_NAME,
        data: [],
    });

    const [chartIcDoorStsRearAirTankLowPrsureAlarm, setChartIcDoorStsRearAirTankLowPrsureAlarm] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_REAR_AIR_TANK_LOW_PRSURE_ALARM_NAME,
        data: [],
    });

    const [chartIcDoorStsRearAirTankPrsure, setChartIcDoorStsRearAirTankPrsure] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_REAR_AIR_TANK_PRSURE_NAME,
        data: [],
    });

    const [chartIcDoorStsPrakingAirTankLowPrsureAlarm, setChartIcDoorStsPrakingAirTankLowPrsureAlarm] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_PRAKING_AIR_TANK_LOW_PRSURE_ALARM_NAME,
        data: [],
    });

    const [chartIcDoorStsAssistAirTankLowPrsureAlarm, setChartIcDoorStsAssistAirTankLowPrsureAlarm] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_ASSIST_AIR_TANK_LOW_PRSURE_ALARM_NAME,
        data: [],
    });

    const [chartIcDoorStsSteeringIndicator, setChartIcDoorStsSteeringIndicator] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_STEERING_INDICATOR_NAME,
        data: [],
    });

    const [chartIcDoorStsDoorOpenSts, setChartIcDoorStsDoorOpenSts] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_DOOR_OPEN_STS_NAME,
        data: [],
    });

    const [chartIcDoorStsEmgValve, setChartIcDoorStsEmgValve] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_EMG_VALVE_NAME,
        data: [],
    });

    const [chartIcDoorStsCoolLqdPos, setChartIcDoorStsCoolLqdPos] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_COOL_LQD_POS_NAME,
        data: [],
    });

    const [chartIcDoorStsSosActive, setChartIcDoorStsSosActive] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_SOS_ACTIVE_NAME,
        data: [],
    });

    const [chartIcDoorStsDangeractive, setChartIcDoorStsDangeractive] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_IC_DOOR_STS_DANGERACTIVE_NAME,
        data: [],
    });

    const getTableTooltipIcDoorSts = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_IC_DOOR_STS_BATTERY_LOWVTGE_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_Battery_Lowvtge
                        </p>
                        <p>StartBit: 0, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_DOOR1_OPEN_STS_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_Door1OpenSts
                        </p>
                        <p>StartBit: 2, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_DRIVER_SEATBELTS_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_DriverSeatbelts
                        </p>
                        <p>StartBit: 4, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_LAMPCIRCUIT_STS_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_LampcircuitSts
                        </p>
                        <p>StartBit: 6, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_DOOR2_OPEN_STS_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_Door2OpenSts
                        </p>
                        <p>StartBit: 8, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_DOOR_BELL_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_DoorBell
                        </p>
                        <p>StartBit: 10, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_DRIVER_SEAT_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_DriverSeat
                        </p>
                        <p>StartBit: 12, Length: 1; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_TRUMPET_STS_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_TrumpetSts
                        </p>
                        <p>StartBit: 13, Length: 1; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_DOOR3_OPEN_STS_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_Door3OpenSts
                        </p>
                        <p>StartBit: 14, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_POWER_MODE_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_PowerMode
                        </p>
                        <p>StartBit: 16, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_DOOR5_LOCK_STS_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_Door5LockSts
                        </p>
                        <p>StartBit: 18, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_DOOR4_OPEN_STS_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_Door4OpenSts
                        </p>
                        <p>StartBit: 20, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_FRONT_AIR_TANK_PRSURE_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_FrontAirTankPrsure
                        </p>
                        <p>StartBit: 24, Length: 8; Unit: kPa; Factor: 5</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_FRONT_AIR_TANK_LOW_PRSURE_ALARM_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_FrontAirTankLowPrsureAlarm
                        </p>
                        <p>StartBit: 32, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_REAR_AIR_TANK_LOW_PRSURE_ALARM_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_RearAirTankLowPrsureAlarm
                        </p>
                        <p>StartBit: 34, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_REAR_AIR_TANK_PRSURE_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_RearAirTankPrsure
                        </p>
                        <p>StartBit: 40, Length: 8; Unit: kPa; Factor: 5</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_PRAKING_AIR_TANK_LOW_PRSURE_ALARM_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_PrakingAirTankLowPrsureAlarm
                        </p>
                        <p>StartBit: 36, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_ASSIST_AIR_TANK_LOW_PRSURE_ALARM_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_AssistAirTankLowPrsureAlarm
                        </p>
                        <p>StartBit: 38, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_STEERING_INDICATOR_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_SteeringIndicator
                        </p>
                        <p>StartBit: 48, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_DOOR_OPEN_STS_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_DoorOpenSts
                        </p>
                        <p>StartBit: 50, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_EMG_VALVE_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_EmgValve
                        </p>
                        <p>StartBit: 52, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_COOL_LQD_POS_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_CoolLqdPos
                        </p>
                        <p>StartBit: 54, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_SOS_ACTIVE_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: SOS_active
                        </p>
                        <p>StartBit: 56, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_IC_DOOR_STS_DANGERACTIVE_KEY:
                return (
                    <>
                        <p>
                            IC_DoorSts
                            <br />
                            CAN ID: 0x18FDA517
                            <br />
                            Name: IC_Dangeractive
                        </p>
                        <p>StartBit: 63, Length: 1; Unit: bit</p>
                    </>
                );
        }
        return null;
    };

    const getIcDoorStsBatteryLowvtgeValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_BATTERY_LOWVTGE_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.batteryLowvtge);
        }
        return "";
    };

    const getIcDoorStsDoor1OpenStsValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DOOR1_OPEN_STS_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.door1OpenSts);
        }
        return "";
    };

    const getIcDoorStsDriverSeatbeltsValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DRIVER_SEATBELTS_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.driverSeatbelts);
        }
        return "";
    };

    const getIcDoorStsLampcircuitStsValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_LAMPCIRCUIT_STS_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.lampcircuitSts);
        }
        return "";
    };

    const getIcDoorStsDoor2OpenStsValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DOOR2_OPEN_STS_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.door2OpenSts);
        }
        return "";
    };

    const getIcDoorStsDoorBellValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DOOR_BELL_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.doorBell);
        }
        return "";
    };

    const getIcDoorStsDriverSeatValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DRIVER_SEAT_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.driverSeat);
        }
        return "";
    };

    const getIcDoorStsTrumpetStsValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_TRUMPET_STS_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.trumpetSts);
        }
        return "";
    };

    const getIcDoorStsDoor3OpenStsValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DOOR3_OPEN_STS_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.door3OpenSts);
        }
        return "";
    };

    const getIcDoorStsPowerModeValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_POWER_MODE_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.powerMode);
        }
        return "";
    };

    const getIcDoorStsDoor5LockStsValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DOOR5_LOCK_STS_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.door5LockSts);
        }
        return "";
    };

    const getIcDoorStsDoor4OpenStsValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DOOR4_OPEN_STS_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.door4OpenSts);
        }
        return "";
    };

    const getIcDoorStsFrontAirTankPrsureValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_FRONT_AIR_TANK_PRSURE_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkWithUnit(currentCanData.icDoorSts.frontAirTankPrsure, Common.UNIT_K_PASCAL);
        }
        return "";
    };

    const getIcDoorStsFrontAirTankLowPrsureAlarmValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_FRONT_AIR_TANK_LOW_PRSURE_ALARM_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.frontAirTankLowPrsureAlarm);
        }
        return "";
    };

    const getIcDoorStsRearAirTankLowPrsureAlarmValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_REAR_AIR_TANK_LOW_PRSURE_ALARM_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.rearAirTankLowPrsureAlarm);
        }
        return "";
    };

    const getIcDoorStsRearAirTankPrsureValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_REAR_AIR_TANK_PRSURE_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkWithUnit(currentCanData.icDoorSts.rearAirTankPrsure, Common.UNIT_K_PASCAL);
        }
        return "";
    };

    const getIcDoorStsPrakingAirTankLowPrsureAlarmValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_PRAKING_AIR_TANK_LOW_PRSURE_ALARM_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.prakingAirTankLowPrsureAlarm);
        }
        return "";
    };

    const getIcDoorStsAssistAirTankLowPrsureAlarmValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_ASSIST_AIR_TANK_LOW_PRSURE_ALARM_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.assistAirTankLowPrsureAlarm);
        }
        return "";
    };

    const getIcDoorStsSteeringIndicatorValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_STEERING_INDICATOR_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.steeringIndicator);
        }
        return "";
    };

    const getIcDoorStsDoorOpenStsValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DOOR_OPEN_STS_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.doorOpenSts);
        }
        return "";
    };

    const getIcDoorStsEmgValveValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_EMG_VALVE_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.emgValve);
        }
        return "";
    };

    const getIcDoorStsCoolLqdPosValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_COOL_LQD_POS_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.coolLqdPos);
        }
        return "";
    };

    const getIcDoorStsSosActiveValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_SOS_ACTIVE_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.sosActive);
        }
        return "";
    };

    const getIcDoorStsDangeractiveValue = () => {
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DANGERACTIVE_KEY) && currentCanData?.icDoorSts) {
            return convertRemarkString(currentCanData.icDoorSts.dangeractive);
        }
        return "";
    };

    const onChangeIcDoorSts = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedIcDoorSts(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasIcDoorSts: Array<TypeUtils.ChartData> = [];

        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_BATTERY_LOWVTGE_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsBatteryLowvtge);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DOOR1_OPEN_STS_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsDoor1OpenSts);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DRIVER_SEATBELTS_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsDriverSeatbelts);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_LAMPCIRCUIT_STS_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsLampcircuitSts);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DOOR2_OPEN_STS_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsDoor2OpenSts);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DOOR_BELL_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsDoorBell);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DRIVER_SEAT_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsDriverSeat);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_TRUMPET_STS_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsTrumpetSts);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DOOR3_OPEN_STS_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsDoor3OpenSts);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_POWER_MODE_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsPowerMode);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DOOR5_LOCK_STS_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsDoor5LockSts);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DOOR4_OPEN_STS_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsDoor4OpenSts);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_FRONT_AIR_TANK_PRSURE_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsFrontAirTankPrsure);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_FRONT_AIR_TANK_LOW_PRSURE_ALARM_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsFrontAirTankLowPrsureAlarm);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_REAR_AIR_TANK_LOW_PRSURE_ALARM_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsRearAirTankLowPrsureAlarm);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_REAR_AIR_TANK_PRSURE_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsRearAirTankPrsure);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_PRAKING_AIR_TANK_LOW_PRSURE_ALARM_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsPrakingAirTankLowPrsureAlarm);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_ASSIST_AIR_TANK_LOW_PRSURE_ALARM_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsAssistAirTankLowPrsureAlarm);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_STEERING_INDICATOR_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsSteeringIndicator);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DOOR_OPEN_STS_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsDoorOpenSts);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_EMG_VALVE_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsEmgValve);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_COOL_LQD_POS_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsCoolLqdPos);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_SOS_ACTIVE_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsSosActive);
        if (selectedIcDoorSts.includes(Common.YEOUL_IC_DOOR_STS_DANGERACTIVE_KEY)) chartDatasIcDoorSts.push(chartIcDoorStsDangeractive);

        setSeriesChartDatasIcDoorSts(chartDatasIcDoorSts);
    }, [selectedIcDoorSts, chartIcDoorStsBatteryLowvtge, chartIcDoorStsDoor1OpenSts, chartIcDoorStsDriverSeatbelts, chartIcDoorStsLampcircuitSts, chartIcDoorStsDoor2OpenSts, chartIcDoorStsDoorBell, chartIcDoorStsDriverSeat, chartIcDoorStsTrumpetSts, chartIcDoorStsDoor3OpenSts, chartIcDoorStsPowerMode, chartIcDoorStsDoor5LockSts, chartIcDoorStsDoor4OpenSts, chartIcDoorStsFrontAirTankPrsure, chartIcDoorStsFrontAirTankLowPrsureAlarm, chartIcDoorStsRearAirTankLowPrsureAlarm, chartIcDoorStsRearAirTankPrsure, chartIcDoorStsPrakingAirTankLowPrsureAlarm, chartIcDoorStsAssistAirTankLowPrsureAlarm, chartIcDoorStsSteeringIndicator, chartIcDoorStsDoorOpenSts, chartIcDoorStsEmgValve, chartIcDoorStsCoolLqdPos, chartIcDoorStsSosActive, chartIcDoorStsDangeractive]);

    const tableDataIcDoorSts: CanTableType[] = [
        {
            key: Common.YEOUL_IC_DOOR_STS_BATTERY_LOWVTGE_KEY,
            name: Common.YEOUL_IC_DOOR_STS_BATTERY_LOWVTGE_NAME,
            value: getIcDoorStsBatteryLowvtgeValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_DOOR1_OPEN_STS_KEY,
            name: Common.YEOUL_IC_DOOR_STS_DOOR1_OPEN_STS_NAME,
            value: getIcDoorStsDoor1OpenStsValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_DRIVER_SEATBELTS_KEY,
            name: Common.YEOUL_IC_DOOR_STS_DRIVER_SEATBELTS_NAME,
            value: getIcDoorStsDriverSeatbeltsValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_LAMPCIRCUIT_STS_KEY,
            name: Common.YEOUL_IC_DOOR_STS_LAMPCIRCUIT_STS_NAME,
            value: getIcDoorStsLampcircuitStsValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_DOOR2_OPEN_STS_KEY,
            name: Common.YEOUL_IC_DOOR_STS_DOOR2_OPEN_STS_NAME,
            value: getIcDoorStsDoor2OpenStsValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_DOOR_BELL_KEY,
            name: Common.YEOUL_IC_DOOR_STS_DOOR_BELL_NAME,
            value: getIcDoorStsDoorBellValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_DRIVER_SEAT_KEY,
            name: Common.YEOUL_IC_DOOR_STS_DRIVER_SEAT_NAME,
            value: getIcDoorStsDriverSeatValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_TRUMPET_STS_KEY,
            name: Common.YEOUL_IC_DOOR_STS_TRUMPET_STS_NAME,
            value: getIcDoorStsTrumpetStsValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_DOOR3_OPEN_STS_KEY,
            name: Common.YEOUL_IC_DOOR_STS_DOOR3_OPEN_STS_NAME,
            value: getIcDoorStsDoor3OpenStsValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_POWER_MODE_KEY,
            name: Common.YEOUL_IC_DOOR_STS_POWER_MODE_NAME,
            value: getIcDoorStsPowerModeValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_DOOR5_LOCK_STS_KEY,
            name: Common.YEOUL_IC_DOOR_STS_DOOR5_LOCK_STS_NAME,
            value: getIcDoorStsDoor5LockStsValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_DOOR4_OPEN_STS_KEY,
            name: Common.YEOUL_IC_DOOR_STS_DOOR4_OPEN_STS_NAME,
            value: getIcDoorStsDoor4OpenStsValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_FRONT_AIR_TANK_PRSURE_KEY,
            name: Common.YEOUL_IC_DOOR_STS_FRONT_AIR_TANK_PRSURE_NAME,
            value: getIcDoorStsFrontAirTankPrsureValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_FRONT_AIR_TANK_LOW_PRSURE_ALARM_KEY,
            name: Common.YEOUL_IC_DOOR_STS_FRONT_AIR_TANK_LOW_PRSURE_ALARM_NAME,
            value: getIcDoorStsFrontAirTankLowPrsureAlarmValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_REAR_AIR_TANK_LOW_PRSURE_ALARM_KEY,
            name: Common.YEOUL_IC_DOOR_STS_REAR_AIR_TANK_LOW_PRSURE_ALARM_NAME,
            value: getIcDoorStsRearAirTankLowPrsureAlarmValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_REAR_AIR_TANK_PRSURE_KEY,
            name: Common.YEOUL_IC_DOOR_STS_REAR_AIR_TANK_PRSURE_NAME,
            value: getIcDoorStsRearAirTankPrsureValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_PRAKING_AIR_TANK_LOW_PRSURE_ALARM_KEY,
            name: Common.YEOUL_IC_DOOR_STS_PRAKING_AIR_TANK_LOW_PRSURE_ALARM_NAME,
            value: getIcDoorStsPrakingAirTankLowPrsureAlarmValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_ASSIST_AIR_TANK_LOW_PRSURE_ALARM_KEY,
            name: Common.YEOUL_IC_DOOR_STS_ASSIST_AIR_TANK_LOW_PRSURE_ALARM_NAME,
            value: getIcDoorStsAssistAirTankLowPrsureAlarmValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_STEERING_INDICATOR_KEY,
            name: Common.YEOUL_IC_DOOR_STS_STEERING_INDICATOR_NAME,
            value: getIcDoorStsSteeringIndicatorValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_DOOR_OPEN_STS_KEY,
            name: Common.YEOUL_IC_DOOR_STS_DOOR_OPEN_STS_NAME,
            value: getIcDoorStsDoorOpenStsValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_EMG_VALVE_KEY,
            name: Common.YEOUL_IC_DOOR_STS_EMG_VALVE_NAME,
            value: getIcDoorStsEmgValveValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_COOL_LQD_POS_KEY,
            name: Common.YEOUL_IC_DOOR_STS_COOL_LQD_POS_NAME,
            value: getIcDoorStsCoolLqdPosValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_SOS_ACTIVE_KEY,
            name: Common.YEOUL_IC_DOOR_STS_SOS_ACTIVE_NAME,
            value: getIcDoorStsSosActiveValue(),
        },
        {
            key: Common.YEOUL_IC_DOOR_STS_DANGERACTIVE_KEY,
            name: Common.YEOUL_IC_DOOR_STS_DANGERACTIVE_NAME,
            value: getIcDoorStsDangeractiveValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region VCU_CCVS
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcuCcvsPanelOpen, setVcuCcvsPanelOpen] = useState(false);
    const [vcuCcvsChartMounted, setVcuCcvsChartMounted] = useState(false);
    const [selectedVcuCcvs, setSelectedVcuCcvs] = useState<Array<React.Key>>([]);
    const [seriesChartDatasVcuCcvs, setSeriesChartDatasVcuCcvs] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcuCcvsHndbrkSts1939, setChartVcuCcvsHndbrkSts1939] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_CCVS_HNDBRK_STS1939_NAME,
        data: [],
    });

    const [chartVcuCcvsVehicleSpd1939, setChartVcuCcvsVehicleSpd1939] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_CCVS_VEHICLE_SPD1939_NAME,
        data: [],
    });

    const getTableTooltipVcuCcvs = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_VCU_CCVS_HNDBRK_STS1939_KEY:
                return (
                    <>
                        <p>
                            VCU_CCVS
                            <br />
                            CAN ID: 0x18FEF100
                            <br />
                            Name: VCU_HndbrkSts1939
                        </p>
                        <p>StartBit: 2, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_CCVS_VEHICLE_SPD1939_KEY:
                return (
                    <>
                        <p>
                            VCU_CCVS
                            <br />
                            CAN ID: 0x18FEF100
                            <br />
                            Name: VCU_VehicleSpd1939
                        </p>
                        <p>StartBit: 8, Length: 16; Unit: km/h; Factor: 0.00390625</p>
                    </>
                );
        }
        return null;
    };

    const getVcuCcvsHndbrkSts1939Value = () => {
        if (selectedVcuCcvs.includes(Common.YEOUL_VCU_CCVS_HNDBRK_STS1939_KEY) && currentCanData?.vcuCcvs) {
            return convertRemarkString(currentCanData.vcuCcvs.hndbrkSts1939);
        }
        return "";
    };

    const getVcuCcvsVehicleSpd1939Value = () => {
        if (selectedVcuCcvs.includes(Common.YEOUL_VCU_CCVS_VEHICLE_SPD1939_KEY) && currentCanData?.vcuCcvs) {
            return convertRemarkWithUnit(currentCanData.vcuCcvs.vehicleSpd1939, Common.UNIT_SPEED);
        }
        return "";
    };

    const onChangeVcuCcvs = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcuCcvs(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcuCcvs: Array<TypeUtils.ChartData> = [];

        if (selectedVcuCcvs.includes(Common.YEOUL_VCU_CCVS_HNDBRK_STS1939_KEY)) chartDatasVcuCcvs.push(chartVcuCcvsHndbrkSts1939);
        if (selectedVcuCcvs.includes(Common.YEOUL_VCU_CCVS_VEHICLE_SPD1939_KEY)) chartDatasVcuCcvs.push(chartVcuCcvsVehicleSpd1939);

        setSeriesChartDatasVcuCcvs(chartDatasVcuCcvs);
    }, [selectedVcuCcvs, chartVcuCcvsHndbrkSts1939, chartVcuCcvsVehicleSpd1939]);

    const tableDataVcuCcvs: CanTableType[] = [
        {
            key: Common.YEOUL_VCU_CCVS_HNDBRK_STS1939_KEY,
            name: Common.YEOUL_VCU_CCVS_HNDBRK_STS1939_NAME,
            value: getVcuCcvsHndbrkSts1939Value(),
        },
        {
            key: Common.YEOUL_VCU_CCVS_VEHICLE_SPD1939_KEY,
            name: Common.YEOUL_VCU_CCVS_VEHICLE_SPD1939_NAME,
            value: getVcuCcvsVehicleSpd1939Value(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region VCU_EMTrqSpdCtrl
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcuEmTrqSpdCtrlPanelOpen, setVcuEmTrqSpdCtrlPanelOpen] = useState(false);
    const [vcuEmTrqSpdCtrlChartMounted, setVcuEmTrqSpdCtrlChartMounted] = useState(false);
    const [selectedVcuEmTrqSpdCtrl, setSelectedVcuEmTrqSpdCtrl] = useState<Array<React.Key>>([]);
    const [seriesChartDatasVcuEmTrqSpdCtrl, setSeriesChartDatasVcuEmTrqSpdCtrl] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcuEmTrqSpdCtrlMcuEnableReq, setChartVcuEmTrqSpdCtrlMcuEnableReq] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MCU_ENABLE_REQ_NAME,
        data: [],
    });

    const [chartVcuEmTrqSpdCtrlEmCtrlMode, setChartVcuEmTrqSpdCtrlEmCtrlMode] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_CTRL_MODE_NAME,
        data: [],
    });

    const [chartVcuEmTrqSpdCtrlEmWorkMode, setChartVcuEmTrqSpdCtrlEmWorkMode] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_WORK_MODE_NAME,
        data: [],
    });

    const [chartVcuEmTrqSpdCtrlReqSpdOrLmt, setChartVcuEmTrqSpdCtrlReqSpdOrLmt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_REQ_SPD_OR_LMT_NAME,
        data: [],
    });

    const [chartVcuEmTrqSpdCtrlReqTrqOrLmt, setChartVcuEmTrqSpdCtrlReqTrqOrLmt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_REQ_TRQ_OR_LMT_NAME,
        data: [],
    });

    const [chartVcuEmTrqSpdCtrlMaxEmPwrLmt, setChartVcuEmTrqSpdCtrlMaxEmPwrLmt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MAX_EM_PWR_LMT_NAME,
        data: [],
    });

    const [chartVcuEmTrqSpdCtrlMinEmPwrLmt, setChartVcuEmTrqSpdCtrlMinEmPwrLmt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MIN_EM_PWR_LMT_NAME,
        data: [],
    });

    const [chartVcuEmTrqSpdCtrlEmTrqSpdCtrlAliveCnt, setChartVcuEmTrqSpdCtrlEmTrqSpdCtrlAliveCnt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_TRQ_SPD_CTRL_ALIVE_CNT_NAME,
        data: [],
    });

    const getTableTooltipVcuEmTrqSpdCtrl = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MCU_ENABLE_REQ_KEY:
                return (
                    <>
                        <p>
                            VCU_EMTrqSpdCtrl
                            <br />
                            CAN ID: 0x0C40EF27
                            <br />
                            Name: VCU_MCUEnableReq
                        </p>
                        <p>StartBit: 0, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_CTRL_MODE_KEY:
                return (
                    <>
                        <p>
                            VCU_EMTrqSpdCtrl
                            <br />
                            CAN ID: 0x0C40EF27
                            <br />
                            Name: VCU_EMCtrlMode
                        </p>
                        <p>StartBit: 2, Length: 2; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_WORK_MODE_KEY:
                return (
                    <>
                        <p>
                            VCU_EMTrqSpdCtrl
                            <br />
                            CAN ID: 0x0C40EF27
                            <br />
                            Name: VCU_EMWorkMode
                        </p>
                        <p>StartBit: 4, Length: 4; Unit: bit</p>
                    </>
                );
            case Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_REQ_SPD_OR_LMT_KEY:
                return (
                    <>
                        <p>
                            VCU_EMTrqSpdCtrl
                            <br />
                            CAN ID: 0x0C40EF27
                            <br />
                            Name: VCU_ReqSpdOrLmt
                        </p>
                        <p>StartBit: 8, Length: 16; Unit: bit; Factor: 0.5</p>
                    </>
                );
            case Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_REQ_TRQ_OR_LMT_KEY:
                return (
                    <>
                        <p>
                            VCU_EMTrqSpdCtrl
                            <br />
                            CAN ID: 0x0C40EF27
                            <br />
                            Name: VCU_ReqTrqOrLmt
                        </p>
                        <p>StartBit: 24, Length: 16; Unit: bit; Offset: -32000</p>
                    </>
                );
            case Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MAX_EM_PWR_LMT_KEY:
                return (
                    <>
                        <p>
                            VCU_EMTrqSpdCtrl
                            <br />
                            CAN ID: 0x0C40EF27
                            <br />
                            Name: VCU_MaxEMPwrLmt
                        </p>
                        <p>StartBit: 40, Length: 8; Unit: %; Factor: 0.4</p>
                    </>
                );
            case Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MIN_EM_PWR_LMT_KEY:
                return (
                    <>
                        <p>
                            VCU_EMTrqSpdCtrl
                            <br />
                            CAN ID: 0x0C40EF27
                            <br />
                            Name: VCU_MinEMPwrLmt
                        </p>
                        <p>StartBit: 48, Length: 8; Unit: %; Factor: 0.4</p>
                    </>
                );
            case Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_TRQ_SPD_CTRL_ALIVE_CNT_KEY:
                return (
                    <>
                        <p>
                            VCU_EMTrqSpdCtrl
                            <br />
                            CAN ID: 0x0C40EF27
                            <br />
                            Name: VCU_EMTrqSpdCtrl_AliveCnt
                        </p>
                        <p>StartBit: 56, Length: 8; Unit: bit</p>
                    </>
                );
        }
        return null;
    };

    const getVcuEmTrqSpdCtrlMcuEnableReqValue = () => {
        if (selectedVcuEmTrqSpdCtrl.includes(Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MCU_ENABLE_REQ_KEY) && currentCanData?.vcuEmTrqSpdCtrl) {
            return convertRemarkString(currentCanData.vcuEmTrqSpdCtrl.mcuEnableReq);
        }
        return "";
    };

    const getVcuEmTrqSpdCtrlEmCtrlModeValue = () => {
        if (selectedVcuEmTrqSpdCtrl.includes(Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_CTRL_MODE_KEY) && currentCanData?.vcuEmTrqSpdCtrl) {
            return convertRemarkString(currentCanData.vcuEmTrqSpdCtrl.emCtrlMode);
        }
        return "";
    };

    const getVcuEmTrqSpdCtrlEmWorkModeValue = () => {
        if (selectedVcuEmTrqSpdCtrl.includes(Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_WORK_MODE_KEY) && currentCanData?.vcuEmTrqSpdCtrl) {
            return convertRemarkString(currentCanData.vcuEmTrqSpdCtrl.emWorkMode);
        }
        return "";
    };

    const getVcuEmTrqSpdCtrlReqSpdOrLmtValue = () => {
        if (selectedVcuEmTrqSpdCtrl.includes(Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_REQ_SPD_OR_LMT_KEY) && currentCanData?.vcuEmTrqSpdCtrl) {
            return convertRemarkString(currentCanData.vcuEmTrqSpdCtrl.reqSpdOrLmt);
        }
        return "";
    };

    const getVcuEmTrqSpdCtrlReqTrqOrLmtValue = () => {
        if (selectedVcuEmTrqSpdCtrl.includes(Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_REQ_TRQ_OR_LMT_KEY) && currentCanData?.vcuEmTrqSpdCtrl) {
            return convertRemarkString(currentCanData.vcuEmTrqSpdCtrl.reqTrqOrLmt);
        }
        return "";
    };

    const getVcuEmTrqSpdCtrlMaxEmPwrLmtValue = () => {
        if (selectedVcuEmTrqSpdCtrl.includes(Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MAX_EM_PWR_LMT_KEY) && currentCanData?.vcuEmTrqSpdCtrl) {
            return convertRemarkWithUnit(currentCanData.vcuEmTrqSpdCtrl.maxEmPwrLmt, Common.UNIT_PERCENT);
        }
        return "";
    };

    const getVcuEmTrqSpdCtrlMinEmPwrLmtValue = () => {
        if (selectedVcuEmTrqSpdCtrl.includes(Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MIN_EM_PWR_LMT_KEY) && currentCanData?.vcuEmTrqSpdCtrl) {
            return convertRemarkWithUnit(currentCanData.vcuEmTrqSpdCtrl.minEmPwrLmt, Common.UNIT_PERCENT);
        }
        return "";
    };

    const getVcuEmTrqSpdCtrlEmTrqSpdCtrlAliveCntValue = () => {
        if (selectedVcuEmTrqSpdCtrl.includes(Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_TRQ_SPD_CTRL_ALIVE_CNT_KEY) && currentCanData?.vcuEmTrqSpdCtrl) {
            return convertRemarkString(currentCanData.vcuEmTrqSpdCtrl.emTrqSpdCtrlAliveCnt);
        }
        return "";
    };

    const onChangeVcuEmTrqSpdCtrl = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcuEmTrqSpdCtrl(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcuEmTrqSpdCtrl: Array<TypeUtils.ChartData> = [];

        if (selectedVcuEmTrqSpdCtrl.includes(Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MCU_ENABLE_REQ_KEY)) chartDatasVcuEmTrqSpdCtrl.push(chartVcuEmTrqSpdCtrlMcuEnableReq);
        if (selectedVcuEmTrqSpdCtrl.includes(Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_CTRL_MODE_KEY)) chartDatasVcuEmTrqSpdCtrl.push(chartVcuEmTrqSpdCtrlEmCtrlMode);
        if (selectedVcuEmTrqSpdCtrl.includes(Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_WORK_MODE_KEY)) chartDatasVcuEmTrqSpdCtrl.push(chartVcuEmTrqSpdCtrlEmWorkMode);
        if (selectedVcuEmTrqSpdCtrl.includes(Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_REQ_SPD_OR_LMT_KEY)) chartDatasVcuEmTrqSpdCtrl.push(chartVcuEmTrqSpdCtrlReqSpdOrLmt);
        if (selectedVcuEmTrqSpdCtrl.includes(Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_REQ_TRQ_OR_LMT_KEY)) chartDatasVcuEmTrqSpdCtrl.push(chartVcuEmTrqSpdCtrlReqTrqOrLmt);
        if (selectedVcuEmTrqSpdCtrl.includes(Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MAX_EM_PWR_LMT_KEY)) chartDatasVcuEmTrqSpdCtrl.push(chartVcuEmTrqSpdCtrlMaxEmPwrLmt);
        if (selectedVcuEmTrqSpdCtrl.includes(Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MIN_EM_PWR_LMT_KEY)) chartDatasVcuEmTrqSpdCtrl.push(chartVcuEmTrqSpdCtrlMinEmPwrLmt);
        if (selectedVcuEmTrqSpdCtrl.includes(Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_TRQ_SPD_CTRL_ALIVE_CNT_KEY)) chartDatasVcuEmTrqSpdCtrl.push(chartVcuEmTrqSpdCtrlEmTrqSpdCtrlAliveCnt);

        setSeriesChartDatasVcuEmTrqSpdCtrl(chartDatasVcuEmTrqSpdCtrl);
    }, [selectedVcuEmTrqSpdCtrl, chartVcuEmTrqSpdCtrlMcuEnableReq, chartVcuEmTrqSpdCtrlEmCtrlMode, chartVcuEmTrqSpdCtrlEmWorkMode, chartVcuEmTrqSpdCtrlReqSpdOrLmt, chartVcuEmTrqSpdCtrlReqTrqOrLmt, chartVcuEmTrqSpdCtrlMaxEmPwrLmt, chartVcuEmTrqSpdCtrlMinEmPwrLmt, chartVcuEmTrqSpdCtrlEmTrqSpdCtrlAliveCnt]);

    const tableDataVcuEmTrqSpdCtrl: CanTableType[] = [
        {
            key: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MCU_ENABLE_REQ_KEY,
            name: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MCU_ENABLE_REQ_NAME,
            value: getVcuEmTrqSpdCtrlMcuEnableReqValue(),
        },
        {
            key: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_CTRL_MODE_KEY,
            name: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_CTRL_MODE_NAME,
            value: getVcuEmTrqSpdCtrlEmCtrlModeValue(),
        },
        {
            key: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_WORK_MODE_KEY,
            name: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_WORK_MODE_NAME,
            value: getVcuEmTrqSpdCtrlEmWorkModeValue(),
        },
        {
            key: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_REQ_SPD_OR_LMT_KEY,
            name: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_REQ_SPD_OR_LMT_NAME,
            value: getVcuEmTrqSpdCtrlReqSpdOrLmtValue(),
        },
        {
            key: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_REQ_TRQ_OR_LMT_KEY,
            name: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_REQ_TRQ_OR_LMT_NAME,
            value: getVcuEmTrqSpdCtrlReqTrqOrLmtValue(),
        },
        {
            key: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MAX_EM_PWR_LMT_KEY,
            name: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MAX_EM_PWR_LMT_NAME,
            value: getVcuEmTrqSpdCtrlMaxEmPwrLmtValue(),
        },
        {
            key: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MIN_EM_PWR_LMT_KEY,
            name: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MIN_EM_PWR_LMT_NAME,
            value: getVcuEmTrqSpdCtrlMinEmPwrLmtValue(),
        },
        {
            key: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_TRQ_SPD_CTRL_ALIVE_CNT_KEY,
            name: Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_EM_TRQ_SPD_CTRL_ALIVE_CNT_NAME,
            value: getVcuEmTrqSpdCtrlEmTrqSpdCtrlAliveCntValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region MCU_MotorSpd
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [mcuMotorSpdPanelOpen, setMcuMotorSpdPanelOpen] = useState(false);
    const [mcuMotorSpdChartMounted, setMcuMotorSpdChartMounted] = useState(false);
    const [selectedMcuMotorSpd, setSelectedMcuMotorSpd] = useState<Array<React.Key>>([]);
    const [seriesChartDatasMcuMotorSpd, setSeriesChartDatasMcuMotorSpd] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartMcuMotorSpdMotorSpeedEbs, setChartMcuMotorSpdMotorSpeedEbs] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_SPD_MOTOR_SPEED_EBS_NAME,
        data: [],
    });

    const [chartMcuMotorSpdMotorTrqAliveCnt, setChartMcuMotorSpdMotorTrqAliveCnt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_SPD_MOTOR_TRQ_ALIVE_CNT_NAME,
        data: [],
    });

    const getTableTooltipMcuMotorSpd = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_MCU_MOTOR_SPD_MOTOR_SPEED_EBS_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorSpd
                            <br />
                            CAN ID: 0x0CFB02EF
                            <br />
                            Name: MCU_MotorSpeed_EBS
                        </p>
                        <p>StartBit: 24, Length: 16; Unit: rpm; Factor: 0.125</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_SPD_MOTOR_TRQ_ALIVE_CNT_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorSpd
                            <br />
                            CAN ID: 0x0CFB02EF
                            <br />
                            Name: MCU_MotorTrq_AliveCnt
                        </p>
                        <p>StartBit: 56, Length: 8; Unit: bit</p>
                    </>
                );
        }
        return null;
    };

    const getMcuMotorSpdMotorSpeedEbsValue = () => {
        if (selectedMcuMotorSpd.includes(Common.YEOUL_MCU_MOTOR_SPD_MOTOR_SPEED_EBS_KEY) && currentCanData?.mcuMotorSpd) {
            return convertRemarkWithUnit(currentCanData.mcuMotorSpd.motorSpeedEbs, Common.UNIT_MOTOR_SPEED);
        }
        return "";
    };

    const getMcuMotorSpdMotorTrqAliveCntValue = () => {
        if (selectedMcuMotorSpd.includes(Common.YEOUL_MCU_MOTOR_SPD_MOTOR_TRQ_ALIVE_CNT_KEY) && currentCanData?.mcuMotorSpd) {
            return convertRemarkString(currentCanData.mcuMotorSpd.motorTrqAliveCnt);
        }
        return "";
    };

    const onChangeMcuMotorSpd = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedMcuMotorSpd(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasMcuMotorSpd: Array<TypeUtils.ChartData> = [];

        if (selectedMcuMotorSpd.includes(Common.YEOUL_MCU_MOTOR_SPD_MOTOR_SPEED_EBS_KEY)) chartDatasMcuMotorSpd.push(chartMcuMotorSpdMotorSpeedEbs);
        if (selectedMcuMotorSpd.includes(Common.YEOUL_MCU_MOTOR_SPD_MOTOR_TRQ_ALIVE_CNT_KEY)) chartDatasMcuMotorSpd.push(chartMcuMotorSpdMotorTrqAliveCnt);

        setSeriesChartDatasMcuMotorSpd(chartDatasMcuMotorSpd);
    }, [selectedMcuMotorSpd, chartMcuMotorSpdMotorSpeedEbs, chartMcuMotorSpdMotorTrqAliveCnt]);

    const tableDataMcuMotorSpd: CanTableType[] = [
        {
            key: Common.YEOUL_MCU_MOTOR_SPD_MOTOR_SPEED_EBS_KEY,
            name: Common.YEOUL_MCU_MOTOR_SPD_MOTOR_SPEED_EBS_NAME,
            value: getMcuMotorSpdMotorSpeedEbsValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_SPD_MOTOR_TRQ_ALIVE_CNT_KEY,
            name: Common.YEOUL_MCU_MOTOR_SPD_MOTOR_TRQ_ALIVE_CNT_NAME,
            value: getMcuMotorSpdMotorTrqAliveCntValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region MCU_MotorTrq
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [mcuMotorTrqPanelOpen, setMcuMotorTrqPanelOpen] = useState(false);
    const [mcuMotorTrqChartMounted, setMcuMotorTrqChartMounted] = useState(false);
    const [selectedMcuMotorTrq, setSelectedMcuMotorTrq] = useState<Array<React.Key>>([]);
    const [seriesChartDatasMcuMotorTrq, setSeriesChartDatasMcuMotorTrq] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartMcuMotorTrqMotorMaxTrq, setChartMcuMotorTrqMotorMaxTrq] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_MAX_TRQ_NAME,
        data: [],
    });

    const [chartMcuMotorTrqMotorMinTrq, setChartMcuMotorTrqMotorMinTrq] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_MIN_TRQ_NAME,
        data: [],
    });

    const [chartMcuMotorTrqMotorTrqAliveCnt, setChartMcuMotorTrqMotorTrqAliveCnt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_TRQ_ALIVE_CNT_NAME,
        data: [],
    });

    const getTableTooltipMcuMotorTrq = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_MAX_TRQ_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorTrq
                            <br />
                            CAN ID: 0x0CFA03EF
                            <br />
                            Name: MCU_MotorMaxTrq
                        </p>
                        <p>StartBit: 0, Length: 16; Unit: Nm; Offset: -32000</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_MIN_TRQ_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorTrq
                            <br />
                            CAN ID: 0x0CFA03EF
                            <br />
                            Name: MCU_MotorMinTrq
                        </p>
                        <p>StartBit: 16, Length: 16; Unit: Nm; Offset: -32000</p>
                    </>
                );
            case Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_TRQ_ALIVE_CNT_KEY:
                return (
                    <>
                        <p>
                            MCU_MotorTrq
                            <br />
                            CAN ID: 0x0CFA03EF
                            <br />
                            Name: MCU_MotorTrq_AliveCnt
                        </p>
                        <p>StartBit: 56, Length: 8; Unit: bit</p>
                    </>
                );
        }
        return null;
    };

    const getMcuMotorTrqMotorMaxTrqValue = () => {
        if (selectedMcuMotorTrq.includes(Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_MAX_TRQ_KEY) && currentCanData?.mcuMotorTrq) {
            return convertRemarkWithUnit(currentCanData.mcuMotorTrq.motorMaxTrq, Common.UNIT_TORQUE);
        }
        return "";
    };

    const getMcuMotorTrqMotorMinTrqValue = () => {
        if (selectedMcuMotorTrq.includes(Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_MIN_TRQ_KEY) && currentCanData?.mcuMotorTrq) {
            return convertRemarkWithUnit(currentCanData.mcuMotorTrq.motorMinTrq, Common.UNIT_TORQUE);
        }
        return "";
    };

    const getMcuMotorTrqMotorTrqAliveCntValue = () => {
        if (selectedMcuMotorTrq.includes(Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_TRQ_ALIVE_CNT_KEY) && currentCanData?.mcuMotorTrq) {
            return convertRemarkString(currentCanData.mcuMotorTrq.motorTrqAliveCnt);
        }
        return "";
    };

    const onChangeMcuMotorTrq = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedMcuMotorTrq(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasMcuMotorTrq: Array<TypeUtils.ChartData> = [];

        if (selectedMcuMotorTrq.includes(Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_MAX_TRQ_KEY)) chartDatasMcuMotorTrq.push(chartMcuMotorTrqMotorMaxTrq);
        if (selectedMcuMotorTrq.includes(Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_MIN_TRQ_KEY)) chartDatasMcuMotorTrq.push(chartMcuMotorTrqMotorMinTrq);
        if (selectedMcuMotorTrq.includes(Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_TRQ_ALIVE_CNT_KEY)) chartDatasMcuMotorTrq.push(chartMcuMotorTrqMotorTrqAliveCnt);

        setSeriesChartDatasMcuMotorTrq(chartDatasMcuMotorTrq);
    }, [selectedMcuMotorTrq, chartMcuMotorTrqMotorMaxTrq, chartMcuMotorTrqMotorMinTrq, chartMcuMotorTrqMotorTrqAliveCnt]);

    const tableDataMcuMotorTrq: CanTableType[] = [
        {
            key: Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_MAX_TRQ_KEY,
            name: Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_MAX_TRQ_NAME,
            value: getMcuMotorTrqMotorMaxTrqValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_MIN_TRQ_KEY,
            name: Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_MIN_TRQ_NAME,
            value: getMcuMotorTrqMotorMinTrqValue(),
        },
        {
            key: Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_TRQ_ALIVE_CNT_KEY,
            name: Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_TRQ_ALIVE_CNT_NAME,
            value: getMcuMotorTrqMotorTrqAliveCntValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region LMCU_MotorTrq
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [lmcuMotorTrqPanelOpen, setLmcuMotorTrqPanelOpen] = useState(false);
    const [lmcuMotorTrqChartMounted, setLmcuMotorTrqChartMounted] = useState(false);
    const [selectedLmcuMotorTrq, setSelectedLmcuMotorTrq] = useState<Array<React.Key>>([]);
    const [seriesChartDatasLmcuMotorTrq, setSeriesChartDatasLmcuMotorTrq] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartLmcuMotorTrqMotorMaxTrq, setChartLmcuMotorTrqMotorMaxTrq] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_MAX_TRQ_NAME,
        data: [],
    });

    const [chartLmcuMotorTrqMotorMinTrq, setChartLmcuMotorTrqMotorMinTrq] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_MIN_TRQ_NAME,
        data: [],
    });

    const [chartLmcuMotorTrqMotorTrqAliveCnt, setChartLmcuMotorTrqMotorTrqAliveCnt] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_TRQ_ALIVE_CNT_NAME,
        data: [],
    });

    const getTableTooltipLmcuMotorTrq = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_MAX_TRQ_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorTrq
                            <br />
                            CAN ID: 0x0CFF3BEF
                            <br />
                            Name: LMCU_MotorMaxTrq
                        </p>
                        <p>StartBit: 0, Length: 16; Unit: Nm; Offset: -32000</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_MIN_TRQ_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorTrq
                            <br />
                            CAN ID: 0x0CFF3BEF
                            <br />
                            Name: LMCU_MotorMinTrq
                        </p>
                        <p>StartBit: 16, Length: 16; Unit: Nm; Offset: -32000</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_TRQ_ALIVE_CNT_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorTrq
                            <br />
                            CAN ID: 0x0CFF3BEF
                            <br />
                            Name: LMCU_MotorTrq_AliveCnt
                        </p>
                        <p>StartBit: 56, Length: 8; Unit: bit</p>
                    </>
                );
        }
        return null;
    };

    const getLmcuMotorTrqMotorMaxTrqValue = () => {
        if (selectedLmcuMotorTrq.includes(Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_MAX_TRQ_KEY) && currentCanData?.lmcuMotorTrq) {
            return convertRemarkWithUnit(currentCanData.lmcuMotorTrq.motorMaxTrq, Common.UNIT_TORQUE);
        }
        return "";
    };

    const getLmcuMotorTrqMotorMinTrqValue = () => {
        if (selectedLmcuMotorTrq.includes(Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_MIN_TRQ_KEY) && currentCanData?.lmcuMotorTrq) {
            return convertRemarkWithUnit(currentCanData.lmcuMotorTrq.motorMinTrq, Common.UNIT_TORQUE);
        }
        return "";
    };

    const getLmcuMotorTrqMotorTrqAliveCntValue = () => {
        if (selectedLmcuMotorTrq.includes(Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_TRQ_ALIVE_CNT_KEY) && currentCanData?.lmcuMotorTrq) {
            return convertRemarkString(currentCanData.lmcuMotorTrq.motorTrqAliveCnt);
        }
        return "";
    };

    const onChangeLmcuMotorTrq = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedLmcuMotorTrq(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasLmcuMotorTrq: Array<TypeUtils.ChartData> = [];

        if (selectedLmcuMotorTrq.includes(Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_MAX_TRQ_KEY)) chartDatasLmcuMotorTrq.push(chartLmcuMotorTrqMotorMaxTrq);
        if (selectedLmcuMotorTrq.includes(Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_MIN_TRQ_KEY)) chartDatasLmcuMotorTrq.push(chartLmcuMotorTrqMotorMinTrq);
        if (selectedLmcuMotorTrq.includes(Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_TRQ_ALIVE_CNT_KEY)) chartDatasLmcuMotorTrq.push(chartLmcuMotorTrqMotorTrqAliveCnt);

        setSeriesChartDatasLmcuMotorTrq(chartDatasLmcuMotorTrq);
    }, [selectedLmcuMotorTrq, chartLmcuMotorTrqMotorMaxTrq, chartLmcuMotorTrqMotorMinTrq, chartLmcuMotorTrqMotorTrqAliveCnt]);

    const tableDataLmcuMotorTrq: CanTableType[] = [
        {
            key: Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_MAX_TRQ_KEY,
            name: Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_MAX_TRQ_NAME,
            value: getLmcuMotorTrqMotorMaxTrqValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_MIN_TRQ_KEY,
            name: Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_MIN_TRQ_NAME,
            value: getLmcuMotorTrqMotorMinTrqValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_TRQ_ALIVE_CNT_KEY,
            name: Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_TRQ_ALIVE_CNT_NAME,
            value: getLmcuMotorTrqMotorTrqAliveCntValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region LMCU_MotorElePara
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [lmcuMotorEleParaPanelOpen, setLmcuMotorEleParaPanelOpen] = useState(false);
    const [lmcuMotorEleParaChartMounted, setLmcuMotorEleParaChartMounted] = useState(false);
    const [selectedLmcuMotorElePara, setSelectedLmcuMotorElePara] = useState<Array<React.Key>>([]);
    const [seriesChartDatasLmcuMotorElePara, setSeriesChartDatasLmcuMotorElePara] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartLmcuMotorEleParaHvBusVol, setChartLmcuMotorEleParaHvBusVol] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ELE_PARA_HV_BUS_VOL_NAME,
        data: [],
    });

    const [chartLmcuMotorEleParaHvdcCurr, setChartLmcuMotorEleParaHvdcCurr] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ELE_PARA_HVDC_CURR_NAME,
        data: [],
    });

    const [chartLmcuMotorEleParaMoterActOutPower, setChartLmcuMotorEleParaMoterActOutPower] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ELE_PARA_MOTER_ACT_OUT_POWER_NAME,
        data: [],
    });

    const [chartLmcuMotorEleParaMoterTemp, setChartLmcuMotorEleParaMoterTemp] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ELE_PARA_MOTER_TEMP_NAME,
        data: [],
    });

    const [chartLmcuMotorEleParaLmcuTemp, setChartLmcuMotorEleParaLmcuTemp] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_LMCU_MOTOR_ELE_PARA_LMCU_TEMP_NAME,
        data: [],
    });

    const getTableTooltipLmcuMotorElePara = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_LMCU_MOTOR_ELE_PARA_HV_BUS_VOL_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorElePara
                            <br />
                            CAN ID: 0x0CFF3CEF
                            <br />
                            Name: LMCU_HVBusVol
                        </p>
                        <p>StartBit: 0, Length: 16; Unit: V; Factor: 0.05</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ELE_PARA_HVDC_CURR_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorElePara
                            <br />
                            CAN ID: 0x0CFF3CEF
                            <br />
                            Name: LMCU_HVDCCurr
                        </p>
                        <p>StartBit: 16, Length: 16; Unit: A; Factor: 0.05; Offset: -1600</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ELE_PARA_MOTER_ACT_OUT_POWER_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorElePara
                            <br />
                            CAN ID: 0x0CFF3CEF
                            <br />
                            Name: LMCU_MoterActOutPower
                        </p>
                        <p>StartBit: 32, Length: 16; Unit: kw</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ELE_PARA_MOTER_TEMP_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorElePara
                            <br />
                            CAN ID: 0x0CFF3CEF
                            <br />
                            Name: LMCU_MoterTemp
                        </p>
                        <p>StartBit: 48, Length: 8; Unit: ℃; Offset: -40</p>
                    </>
                );
            case Common.YEOUL_LMCU_MOTOR_ELE_PARA_LMCU_TEMP_KEY:
                return (
                    <>
                        <p>
                            LMCU_MotorElePara
                            <br />
                            CAN ID: 0x0CFF3CEF
                            <br />
                            Name: LMCU_LMCUTemp
                        </p>
                        <p>StartBit: 56, Length: 8; Unit: ℃; Offset: -40</p>
                    </>
                );
        }
        return null;
    };

    const getLmcuMotorEleParaHvBusVolValue = () => {
        if (selectedLmcuMotorElePara.includes(Common.YEOUL_LMCU_MOTOR_ELE_PARA_HV_BUS_VOL_KEY) && currentCanData?.lmcuMotorElePara) {
            return convertRemarkWithUnit(currentCanData.lmcuMotorElePara.hvBusVol, Common.UNIT_VOLTAGE);
        }
        return "";
    };

    const getLmcuMotorEleParaHvdcCurrValue = () => {
        if (selectedLmcuMotorElePara.includes(Common.YEOUL_LMCU_MOTOR_ELE_PARA_HVDC_CURR_KEY) && currentCanData?.lmcuMotorElePara) {
            return convertRemarkWithUnit(currentCanData.lmcuMotorElePara.hvdcCurr, Common.UNIT_CURRENT);
        }
        return "";
    };

    const getLmcuMotorEleParaMoterActOutPowerValue = () => {
        if (selectedLmcuMotorElePara.includes(Common.YEOUL_LMCU_MOTOR_ELE_PARA_MOTER_ACT_OUT_POWER_KEY) && currentCanData?.lmcuMotorElePara) {
            return convertRemarkString(currentCanData.lmcuMotorElePara.moterActOutPower);
        }
        return "";
    };

    const getLmcuMotorEleParaMoterTempValue = () => {
        if (selectedLmcuMotorElePara.includes(Common.YEOUL_LMCU_MOTOR_ELE_PARA_MOTER_TEMP_KEY) && currentCanData?.lmcuMotorElePara) {
            return convertRemarkString(currentCanData.lmcuMotorElePara.moterTemp);
        }
        return "";
    };

    const getLmcuMotorEleParaLmcuTempValue = () => {
        if (selectedLmcuMotorElePara.includes(Common.YEOUL_LMCU_MOTOR_ELE_PARA_LMCU_TEMP_KEY) && currentCanData?.lmcuMotorElePara) {
            return convertRemarkString(currentCanData.lmcuMotorElePara.lmcuTemp);
        }
        return "";
    };

    const onChangeLmcuMotorElePara = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedLmcuMotorElePara(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasLmcuMotorElePara: Array<TypeUtils.ChartData> = [];

        if (selectedLmcuMotorElePara.includes(Common.YEOUL_LMCU_MOTOR_ELE_PARA_HV_BUS_VOL_KEY)) chartDatasLmcuMotorElePara.push(chartLmcuMotorEleParaHvBusVol);
        if (selectedLmcuMotorElePara.includes(Common.YEOUL_LMCU_MOTOR_ELE_PARA_HVDC_CURR_KEY)) chartDatasLmcuMotorElePara.push(chartLmcuMotorEleParaHvdcCurr);
        if (selectedLmcuMotorElePara.includes(Common.YEOUL_LMCU_MOTOR_ELE_PARA_MOTER_ACT_OUT_POWER_KEY)) chartDatasLmcuMotorElePara.push(chartLmcuMotorEleParaMoterActOutPower);
        if (selectedLmcuMotorElePara.includes(Common.YEOUL_LMCU_MOTOR_ELE_PARA_MOTER_TEMP_KEY)) chartDatasLmcuMotorElePara.push(chartLmcuMotorEleParaMoterTemp);
        if (selectedLmcuMotorElePara.includes(Common.YEOUL_LMCU_MOTOR_ELE_PARA_LMCU_TEMP_KEY)) chartDatasLmcuMotorElePara.push(chartLmcuMotorEleParaLmcuTemp);

        setSeriesChartDatasLmcuMotorElePara(chartDatasLmcuMotorElePara);
    }, [selectedLmcuMotorElePara, chartLmcuMotorEleParaHvBusVol, chartLmcuMotorEleParaHvdcCurr, chartLmcuMotorEleParaMoterActOutPower, chartLmcuMotorEleParaMoterTemp, chartLmcuMotorEleParaLmcuTemp]);

    const tableDataLmcuMotorElePara: CanTableType[] = [
        {
            key: Common.YEOUL_LMCU_MOTOR_ELE_PARA_HV_BUS_VOL_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ELE_PARA_HV_BUS_VOL_NAME,
            value: getLmcuMotorEleParaHvBusVolValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ELE_PARA_HVDC_CURR_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ELE_PARA_HVDC_CURR_NAME,
            value: getLmcuMotorEleParaHvdcCurrValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ELE_PARA_MOTER_ACT_OUT_POWER_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ELE_PARA_MOTER_ACT_OUT_POWER_NAME,
            value: getLmcuMotorEleParaMoterActOutPowerValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ELE_PARA_MOTER_TEMP_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ELE_PARA_MOTER_TEMP_NAME,
            value: getLmcuMotorEleParaMoterTempValue(),
        },
        {
            key: Common.YEOUL_LMCU_MOTOR_ELE_PARA_LMCU_TEMP_KEY,
            name: Common.YEOUL_LMCU_MOTOR_ELE_PARA_LMCU_TEMP_NAME,
            value: getLmcuMotorEleParaLmcuTempValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region BMS_ChgInfo_G
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bmsChgInfoGPanelOpen, setBmsChgInfoGPanelOpen] = useState(false);
    const [bmsChgInfoGChartMounted, setBmsChgInfoGChartMounted] = useState(false);
    const [selectedBmsChgInfoG, setSelectedBmsChgInfoG] = useState<Array<React.Key>>([]);
    const [seriesChartDatasBmsChgInfoG, setSeriesChartDatasBmsChgInfoG] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBmsChgInfoGChgTimeTatol, setChartBmsChgInfoGChgTimeTatol] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_CHG_INFO_G_CHG_TIME_TATOL_NAME,
        data: [],
    });

    const getTableTooltipBmsChgInfoG = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_BMS_CHG_INFO_G_CHG_TIME_TATOL_KEY:
                return (
                    <>
                        <p>
                            BMS_ChgInfo_G
                            <br />
                            CAN ID: 0x18FC0AF4
                            <br />
                            Name: BMS_ChgTimeTatol
                        </p>
                        <p>StartBit: 16, Length: 16; Unit: Min</p>
                    </>
                );
        }
        return null;
    };

    const getBmsChgInfoGChgTimeTatolValue = () => {
        if (selectedBmsChgInfoG.includes(Common.YEOUL_BMS_CHG_INFO_G_CHG_TIME_TATOL_KEY) && currentCanData?.bmsChgInfoG) {
            return convertRemarkString(currentCanData.bmsChgInfoG.chgTimeTatol);
        }
        return "";
    };

    const onChangeBmsChgInfoG = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBmsChgInfoG(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBmsChgInfoG: Array<TypeUtils.ChartData> = [];

        if (selectedBmsChgInfoG.includes(Common.YEOUL_BMS_CHG_INFO_G_CHG_TIME_TATOL_KEY)) chartDatasBmsChgInfoG.push(chartBmsChgInfoGChgTimeTatol);

        setSeriesChartDatasBmsChgInfoG(chartDatasBmsChgInfoG);
    }, [selectedBmsChgInfoG, chartBmsChgInfoGChgTimeTatol]);

    const tableDataBmsChgInfoG: CanTableType[] = [
        {
            key: Common.YEOUL_BMS_CHG_INFO_G_CHG_TIME_TATOL_KEY,
            name: Common.YEOUL_BMS_CHG_INFO_G_CHG_TIME_TATOL_NAME,
            value: getBmsChgInfoGChgTimeTatolValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region BMS_BattEnyInfo1
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bmsBattEnyInfo1PanelOpen, setBmsBattEnyInfo1PanelOpen] = useState(false);
    const [bmsBattEnyInfo1ChartMounted, setBmsBattEnyInfo1ChartMounted] = useState(false);
    const [selectedBmsBattEnyInfo1, setSelectedBmsBattEnyInfo1] = useState<Array<React.Key>>([]);
    const [seriesChartDatasBmsBattEnyInfo1, setSeriesChartDatasBmsBattEnyInfo1] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBmsBattEnyInfo1ChgCount, setChartBmsBattEnyInfo1ChgCount] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATT_ENY_INFO1_CHG_COUNT_NAME,
        data: [],
    });

    const [chartBmsBattEnyInfo1SingleChgEnergy, setChartBmsBattEnyInfo1SingleChgEnergy] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATT_ENY_INFO1_SINGLE_CHG_ENERGY_NAME,
        data: [],
    });

    const [chartBmsBattEnyInfo1SingleDisChgEny, setChartBmsBattEnyInfo1SingleDisChgEny] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATT_ENY_INFO1_SINGLE_DIS_CHG_ENY_NAME,
        data: [],
    });

    const [chartBmsBattEnyInfo1ChgTimeRemain, setChartBmsBattEnyInfo1ChgTimeRemain] = useState<TypeUtils.ChartData>({
        name: Common.YEOUL_BMS_BATT_ENY_INFO1_CHG_TIME_REMAIN_NAME,
        data: [],
    });

    const getTableTooltipBmsBattEnyInfo1 = (key: React.Key) => {
        switch (key) {
            case Common.YEOUL_BMS_BATT_ENY_INFO1_CHG_COUNT_KEY:
                return (
                    <>
                        <p>
                            BMS_BattEnyInfo1
                            <br />
                            CAN ID: 0x18FC03F4
                            <br />
                            Name: BMS_ChgCount
                        </p>
                        <p>StartBit: 0, Length: 16; Unit: kWh</p>
                    </>
                );
            case Common.YEOUL_BMS_BATT_ENY_INFO1_SINGLE_CHG_ENERGY_KEY:
                return (
                    <>
                        <p>
                            BMS_BattEnyInfo1
                            <br />
                            CAN ID: 0x18FC03F4
                            <br />
                            Name: BMS_SingleChgEnergy
                        </p>
                        <p>StartBit: 16, Length: 16; Unit: kWh; Factor: 0.1</p>
                    </>
                );
            case Common.YEOUL_BMS_BATT_ENY_INFO1_SINGLE_DIS_CHG_ENY_KEY:
                return (
                    <>
                        <p>
                            BMS_BattEnyInfo1
                            <br />
                            CAN ID: 0x18FC03F4
                            <br />
                            Name: BMS_SingleDisChgEny
                        </p>
                        <p>StartBit: 32, Length: 16; Unit: kWh; Factor: 0.1</p>
                    </>
                );
            case Common.YEOUL_BMS_BATT_ENY_INFO1_CHG_TIME_REMAIN_KEY:
                return (
                    <>
                        <p>
                            BMS_BattEnyInfo1
                            <br />
                            CAN ID: 0x18FC03F4
                            <br />
                            Name: BMS_ChgTimeRemain
                        </p>
                        <p>StartBit: 48, Length: 16; Unit: min</p>
                    </>
                );
        }
        return null;
    };

    const getBmsBattEnyInfo1ChgCountValue = () => {
        if (selectedBmsBattEnyInfo1.includes(Common.YEOUL_BMS_BATT_ENY_INFO1_CHG_COUNT_KEY) && currentCanData?.bmsBattEnyInfo1) {
            return convertRemarkWithUnit(currentCanData.bmsBattEnyInfo1.chgCount, Common.UNIT_POWER_H);
        }
        return "";
    };

    const getBmsBattEnyInfo1SingleChgEnergyValue = () => {
        if (selectedBmsBattEnyInfo1.includes(Common.YEOUL_BMS_BATT_ENY_INFO1_SINGLE_CHG_ENERGY_KEY) && currentCanData?.bmsBattEnyInfo1) {
            return convertRemarkWithUnit(currentCanData.bmsBattEnyInfo1.singleChgEnergy, Common.UNIT_POWER_H);
        }
        return "";
    };

    const getBmsBattEnyInfo1SingleDisChgEnyValue = () => {
        if (selectedBmsBattEnyInfo1.includes(Common.YEOUL_BMS_BATT_ENY_INFO1_SINGLE_DIS_CHG_ENY_KEY) && currentCanData?.bmsBattEnyInfo1) {
            return convertRemarkWithUnit(currentCanData.bmsBattEnyInfo1.singleDisChgEny, Common.UNIT_POWER_H);
        }
        return "";
    };

    const getBmsBattEnyInfo1ChgTimeRemainValue = () => {
        if (selectedBmsBattEnyInfo1.includes(Common.YEOUL_BMS_BATT_ENY_INFO1_CHG_TIME_REMAIN_KEY) && currentCanData?.bmsBattEnyInfo1) {
            return convertRemarkWithUnit(currentCanData.bmsBattEnyInfo1.chgTimeRemain, Common.UNIT_MINUTE);
        }
        return "";
    };

    const onChangeBmsBattEnyInfo1 = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBmsBattEnyInfo1(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBmsBattEnyInfo1: Array<TypeUtils.ChartData> = [];

        if (selectedBmsBattEnyInfo1.includes(Common.YEOUL_BMS_BATT_ENY_INFO1_CHG_COUNT_KEY)) chartDatasBmsBattEnyInfo1.push(chartBmsBattEnyInfo1ChgCount);
        if (selectedBmsBattEnyInfo1.includes(Common.YEOUL_BMS_BATT_ENY_INFO1_SINGLE_CHG_ENERGY_KEY)) chartDatasBmsBattEnyInfo1.push(chartBmsBattEnyInfo1SingleChgEnergy);
        if (selectedBmsBattEnyInfo1.includes(Common.YEOUL_BMS_BATT_ENY_INFO1_SINGLE_DIS_CHG_ENY_KEY)) chartDatasBmsBattEnyInfo1.push(chartBmsBattEnyInfo1SingleDisChgEny);
        if (selectedBmsBattEnyInfo1.includes(Common.YEOUL_BMS_BATT_ENY_INFO1_CHG_TIME_REMAIN_KEY)) chartDatasBmsBattEnyInfo1.push(chartBmsBattEnyInfo1ChgTimeRemain);

        setSeriesChartDatasBmsBattEnyInfo1(chartDatasBmsBattEnyInfo1);
    }, [selectedBmsBattEnyInfo1, chartBmsBattEnyInfo1ChgCount, chartBmsBattEnyInfo1SingleChgEnergy, chartBmsBattEnyInfo1SingleDisChgEny, chartBmsBattEnyInfo1ChgTimeRemain]);

    const tableDataBmsBattEnyInfo1: CanTableType[] = [
        {
            key: Common.YEOUL_BMS_BATT_ENY_INFO1_CHG_COUNT_KEY,
            name: Common.YEOUL_BMS_BATT_ENY_INFO1_CHG_COUNT_NAME,
            value: getBmsBattEnyInfo1ChgCountValue(),
        },
        {
            key: Common.YEOUL_BMS_BATT_ENY_INFO1_SINGLE_CHG_ENERGY_KEY,
            name: Common.YEOUL_BMS_BATT_ENY_INFO1_SINGLE_CHG_ENERGY_NAME,
            value: getBmsBattEnyInfo1SingleChgEnergyValue(),
        },
        {
            key: Common.YEOUL_BMS_BATT_ENY_INFO1_SINGLE_DIS_CHG_ENY_KEY,
            name: Common.YEOUL_BMS_BATT_ENY_INFO1_SINGLE_DIS_CHG_ENY_NAME,
            value: getBmsBattEnyInfo1SingleDisChgEnyValue(),
        },
        {
            key: Common.YEOUL_BMS_BATT_ENY_INFO1_CHG_TIME_REMAIN_KEY,
            name: Common.YEOUL_BMS_BATT_ENY_INFO1_CHG_TIME_REMAIN_NAME,
            value: getBmsBattEnyInfo1ChgTimeRemainValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region Data Processing
    useEffect(() => {
        if (vehicleInfo?.makerModel?.maker?.makerName !== Common.VehicleMaker.TSEco) return;
        if (!runningCanDataList || runningCanDataList.length === 0) return;

        // BMS_BatteryInfo
        const bmsBatteryInfoBattVolData: Array<TypeUtils.ChartElement> = [];
        const bmsBatteryInfoBattCurrData: Array<TypeUtils.ChartElement> = [];
        const bmsBatteryInfoBattSOCData: Array<TypeUtils.ChartElement> = [];
        const bmsBatteryInfoFaultLevelData: Array<TypeUtils.ChartElement> = [];
        const bmsBatteryInfoBattSOHData: Array<TypeUtils.ChartElement> = [];
        const bmsBatteryInfoEmergCutoffHvReqData: Array<TypeUtils.ChartElement> = [];
        const bmsBatteryInfoPmtCutoffLvFbData: Array<TypeUtils.ChartElement> = [];
        const bmsBatteryInfoSelfChkStateData: Array<TypeUtils.ChartElement> = [];
        const bmsBatteryInfoNegRelayStsData: Array<TypeUtils.ChartElement> = [];
        const bmsBatteryInfoHeatRelayStsData: Array<TypeUtils.ChartElement> = [];
        const bmsBatteryInfoActWorkStsData: Array<TypeUtils.ChartElement> = [];
        // VCU_BodyControlInfo
        const vcuBodyControlInfoVehicleSpdData: Array<TypeUtils.ChartElement> = [];
        const vcuBodyControlInfoAccPedalPositionData: Array<TypeUtils.ChartElement> = [];
        const vcuBodyControlInfoAceleratPedalPositionFltData: Array<TypeUtils.ChartElement> = [];
        const vcuBodyControlInfoBrakePedalPositionFltData: Array<TypeUtils.ChartElement> = [];
        // VCU_ErrCode
        const vcuErrCodeAecData: Array<TypeUtils.ChartElement> = [];
        const vcuErrCodeDteData: Array<TypeUtils.ChartElement> = [];
        // LBMS_Info
        const lbmsInfoBattCurrentData: Array<TypeUtils.ChartElement> = [];
        const lbmsInfoBattVoltData: Array<TypeUtils.ChartElement> = [];
        // VCU_PTInfoIndicate
        const vcuPtInfoIndicateGearPositionIndData: Array<TypeUtils.ChartElement> = [];
        const vcuPtInfoIndicateHandbrakeStsData: Array<TypeUtils.ChartElement> = [];
        const vcuPtInfoIndicateVehicleRunModeData: Array<TypeUtils.ChartElement> = [];
        const vcuPtInfoIndicateDriveModeIndData: Array<TypeUtils.ChartElement> = [];
        // BMS_Min_Max_CellVolt
        const bmsMinMaxCellVoltMinCellVoltData: Array<TypeUtils.ChartElement> = [];
        const bmsMinMaxCellVoltMinVoltCellNumData: Array<TypeUtils.ChartElement> = [];
        const bmsMinMaxCellVoltMinVoltCellPackNumData: Array<TypeUtils.ChartElement> = [];
        const bmsMinMaxCellVoltMaxCellVoltData: Array<TypeUtils.ChartElement> = [];
        const bmsMinMaxCellVoltMaxVoltCellNumData: Array<TypeUtils.ChartElement> = [];
        const bmsMinMaxCellVoltMaxVoltCellPackNumData: Array<TypeUtils.ChartElement> = [];
        // BMS_Min_Max_CellTemp
        const bmsMinMaxCellTempBattMinTempData: Array<TypeUtils.ChartElement> = [];
        const bmsMinMaxCellTempMinTempPackNumData: Array<TypeUtils.ChartElement> = [];
        const bmsMinMaxCellTempMinTempSnsNumData: Array<TypeUtils.ChartElement> = [];
        const bmsMinMaxCellTempBnttMaxTempData: Array<TypeUtils.ChartElement> = [];
        const bmsMinMaxCellTempMaxTempPackNumData: Array<TypeUtils.ChartElement> = [];
        const bmsMinMaxCellTempMaxTempSnsNumData: Array<TypeUtils.ChartElement> = [];
        const bmsMinMaxCellTempCellAvgTempData: Array<TypeUtils.ChartElement> = [];
        // MCU_MotorAlarmInfo
        const mcuMotorAlarmInfoMotorTempHighAlarmData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoMcuTempHighAlarmData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoMotorSpdHighAlarmData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoCanCommFltData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoMcuMemoryFltData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoDchvCurrSensorFltData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoMotorUCurrSensorFltData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoMotorVCurrSensorFltData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoMotorFltLevelData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoMcurtcUcedPwrRunErrData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoActiveDischgFltData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoSoftwareCapOverVoltData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoHardwareCapOverVoltData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoBusVoltErrData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoMotorLockRotErrData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoMcuTempSensorErrData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoMotorTempSensorErrData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoSysFltCodeData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorAlarmInfoMotorSNData: Array<TypeUtils.ChartElement> = [];
        // LMCU_MotorAlarmInfo
        const lmcuMotorAlarmInfoMotorTempHighAlarmData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoLmcuTempHighAlarmData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoMotorSpdHighAlarmData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoCanCommFltData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoLmcuMemoryFltData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoDchvCurrSensorFltData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoMotorUCurrSensorFltData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoMotorVCurrSensorFltData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoMotorFltLevelData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoLmcurtcUcedPwrRunErrData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoActiveDischgFltData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoSoftwareCapOverVoltData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoHardwareCapOverVoltData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoBusVoltErrData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoMotorLockRotErrData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoLmcuTempSensorErrData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoMotorTempSensorErrData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoSysFltCodeData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorAlarmInfoMotorSNData: Array<TypeUtils.ChartElement> = [];
        // BMS_HVIsolationInfo
        const bmsHvIsolationInfoPosIsolationResData: Array<TypeUtils.ChartElement> = [];
        const bmsHvIsolationInfoNegIsolationResData: Array<TypeUtils.ChartElement> = [];
        const bmsHvIsolationInfoHvIsolationStsData: Array<TypeUtils.ChartElement> = [];
        const bmsHvIsolationInfoIsolationFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsHvIsolationInfoBattFireFaultData: Array<TypeUtils.ChartElement> = [];
        // TCU_Info1
        const tcuInfo1CurrentgearData: Array<TypeUtils.ChartElement> = [];
        const tcuInfo1GearStateData: Array<TypeUtils.ChartElement> = [];
        const tcuInfo1FultGrdData: Array<TypeUtils.ChartElement> = [];
        // DCDC_StatusInfo
        const dcdcStatusInfoFaultLevelData: Array<TypeUtils.ChartElement> = [];
        // SDCAC_StatusInfo
        const sdcacStatusInfoFaultLevelData: Array<TypeUtils.ChartElement> = [];
        // BDCAC_StatusInfo
        const bdcacStatusInfoFaultLevelData: Array<TypeUtils.ChartElement> = [];
        // HCM_WorkInfo
        const hcmWorkInfoWorkStsData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoAssistPosConnStsData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoSelfChkStsData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoFaultLevelData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoEmergCutOffHVData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoCutOffLvFbData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoMainPosConnStsData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoPreChgConnStsData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoPtcConnStsFbData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoFastChgConnStsFbData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoSlowChgConnStsFbData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoInterLockLoopStsData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoOverTempData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoCanComFaultData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoHvLoopFaultData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoSupplyVolFaultData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoHvLoopWorkStsData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoMainNegConnStsData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoMainPosRalayFltData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoPreChgRelayFltData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoFastChgRelayFltData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoPtcRelayFltData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoSlowChgRelayFltData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoAssistPosRelayFltData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoMainNegRelayFltData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoAssitPreChgConnStsData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoAssistPreChgRelayFltData: Array<TypeUtils.ChartElement> = [];
        const hcmWorkInfoWorkInfAliveCntData: Array<TypeUtils.ChartElement> = [];
        // VCU_HVFunctionCtrl
        const vcuHvFunctionCtrlMainPosCtrlComndData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlAllowChgData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlBmshvOnOffReqData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlTmsoffRequestData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlDcdcEnableOutData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlBdcacEnableOutData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlSdcacEnableOutData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlAssitPosCtrlComndData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlHcmCutOffLVData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlBmsCutOffLVData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlMcuCutOffLVData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlPtcCtrlCmdData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlDcdcPwrLmtData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlSdcacOutFreqData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlAssitPos2CtrlCmdData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlMainNegCtrlComndData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlLsdcacCtrlComndData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlSelfCheckStsData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlHvFunctionCtrlAliverCounterData: Array<TypeUtils.ChartElement> = [];
        const vcuHvFunctionCtrlHvFunctionCtrlChecksumData: Array<TypeUtils.ChartElement> = [];
        // VCU_LVFunctionCtrl
        const vcuLvFunctionCtrlDefrosterCtrlLData: Array<TypeUtils.ChartElement> = [];
        const vcuLvFunctionCtrlDefrosterCtrlHData: Array<TypeUtils.ChartElement> = [];
        const vcuLvFunctionCtrlAcPanelCtrlData: Array<TypeUtils.ChartElement> = [];
        const vcuLvFunctionCtrlHcmPowerCtrlData: Array<TypeUtils.ChartElement> = [];
        const vcuLvFunctionCtrlCehModeCmdData: Array<TypeUtils.ChartElement> = [];
        const vcuLvFunctionCtrlCehPwmCmdData: Array<TypeUtils.ChartElement> = [];
        const vcuLvFunctionCtrlCehTempCmdData: Array<TypeUtils.ChartElement> = [];
        // MCU_MotorElePara
        const mcuMotorEleParaHvBusVolData: Array<TypeUtils.ChartElement> = [];
        // BMS_BatPackLmt
        const bmsBatPackLmtMaxPmtEnyRecoCurrData: Array<TypeUtils.ChartElement> = [];
        const bmsBatPackLmtMaxPmtDischgCurrData: Array<TypeUtils.ChartElement> = [];
        const bmsBatPackLmtBattMaxWorkTempData: Array<TypeUtils.ChartElement> = [];
        const bmsBatPackLmtBattMinWorkTempData: Array<TypeUtils.ChartElement> = [];
        const bmsBatPackLmtMinPmtSOCData: Array<TypeUtils.ChartElement> = [];
        const bmsBatPackLmtMaxPmtEnyRecoVolData: Array<TypeUtils.ChartElement> = [];
        // BMS_BattaryFltInfo
        const bmsBattaryFltInfoBattPackVolFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoBattCellVolFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoBattTempFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoBattSocFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoSocJumpFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoBattEqualizationStsData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoDischargeCurrFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoChargeCurrFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoBattIsolationStsData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoCanComFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoBattPackMatchFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoBattConsistencyFltData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoCurrSensorFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoMsdFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoHeatPosRelayFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoHeatNegRelayFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoOverChgFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoSt1FltHwData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoPosRelayFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoNegRelayFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoSt1FltHvilData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoCellVolDiffFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoCellTempDiffFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoEnyRecoCurrHighFltData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoPowerActiveModeData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoBattFireFaultData: Array<TypeUtils.ChartElement> = [];
        const bmsBattaryFltInfoBattFaultInfoAliveCntData: Array<TypeUtils.ChartElement> = [];
        // BMS_CellVoltData
        const bmsCellVoltDataCellVolt1Data: Array<TypeUtils.ChartElement> = [];
        const bmsCellVoltDataCellVolt2Data: Array<TypeUtils.ChartElement> = [];
        const bmsCellVoltDataCellVolt3Data: Array<TypeUtils.ChartElement> = [];
        const bmsCellVoltDataCellVolt4Data: Array<TypeUtils.ChartElement> = [];
        // BMS_CellTempData
        const bmsCellTempDataBattTemp1Data: Array<TypeUtils.ChartElement> = [];
        const bmsCellTempDataBattTemp2Data: Array<TypeUtils.ChartElement> = [];
        const bmsCellTempDataBattTemp3Data: Array<TypeUtils.ChartElement> = [];
        const bmsCellTempDataBattTemp4Data: Array<TypeUtils.ChartElement> = [];
        const bmsCellTempDataBattTemp5Data: Array<TypeUtils.ChartElement> = [];
        const bmsCellTempDataBattTemp6Data: Array<TypeUtils.ChartElement> = [];
        const bmsCellTempDataBattTemp7Data: Array<TypeUtils.ChartElement> = [];
        const bmsCellTempDataBattTemp8Data: Array<TypeUtils.ChartElement> = [];
        // IC_Odometer
        const icOdometerTripData: Array<TypeUtils.ChartElement> = [];
        const icOdometerOdometerData: Array<TypeUtils.ChartElement> = [];
        // IC_DoorSts
        const icDoorStsBatteryLowvtgeData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsDoor1OpenStsData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsDriverSeatbeltsData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsLampcircuitStsData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsDoor2OpenStsData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsDoorBellData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsDriverSeatData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsTrumpetStsData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsDoor3OpenStsData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsPowerModeData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsDoor5LockStsData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsDoor4OpenStsData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsFrontAirTankPrsureData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsFrontAirTankLowPrsureAlarmData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsRearAirTankLowPrsureAlarmData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsRearAirTankPrsureData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsPrakingAirTankLowPrsureAlarmData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsAssistAirTankLowPrsureAlarmData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsSteeringIndicatorData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsDoorOpenStsData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsEmgValveData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsCoolLqdPosData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsSosActiveData: Array<TypeUtils.ChartElement> = [];
        const icDoorStsDangeractiveData: Array<TypeUtils.ChartElement> = [];
        // VCU_CCVS
        const vcuCcvsHndbrkSts1939Data: Array<TypeUtils.ChartElement> = [];
        const vcuCcvsVehicleSpd1939Data: Array<TypeUtils.ChartElement> = [];
        // VCU_EMTrqSpdCtrl
        const vcuEmTrqSpdCtrlMcuEnableReqData: Array<TypeUtils.ChartElement> = [];
        const vcuEmTrqSpdCtrlEmCtrlModeData: Array<TypeUtils.ChartElement> = [];
        const vcuEmTrqSpdCtrlEmWorkModeData: Array<TypeUtils.ChartElement> = [];
        const vcuEmTrqSpdCtrlReqSpdOrLmtData: Array<TypeUtils.ChartElement> = [];
        const vcuEmTrqSpdCtrlReqTrqOrLmtData: Array<TypeUtils.ChartElement> = [];
        const vcuEmTrqSpdCtrlMaxEmPwrLmtData: Array<TypeUtils.ChartElement> = [];
        const vcuEmTrqSpdCtrlMinEmPwrLmtData: Array<TypeUtils.ChartElement> = [];
        const vcuEmTrqSpdCtrlEmTrqSpdCtrlAliveCntData: Array<TypeUtils.ChartElement> = [];
        // MCU_MotorSpd
        const mcuMotorSpdMotorSpeedEbsData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorSpdMotorTrqAliveCntData: Array<TypeUtils.ChartElement> = [];
        // MCU_MotorTrq
        const mcuMotorTrqMotorMaxTrqData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorTrqMotorMinTrqData: Array<TypeUtils.ChartElement> = [];
        const mcuMotorTrqMotorTrqAliveCntData: Array<TypeUtils.ChartElement> = [];
        // LMCU_MotorTrq
        const lmcuMotorTrqMotorMaxTrqData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorTrqMotorMinTrqData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorTrqMotorTrqAliveCntData: Array<TypeUtils.ChartElement> = [];
        // LMCU_MotorElePara
        const lmcuMotorEleParaHvBusVolData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorEleParaHvdcCurrData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorEleParaMoterActOutPowerData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorEleParaMoterTempData: Array<TypeUtils.ChartElement> = [];
        const lmcuMotorEleParaLmcuTempData: Array<TypeUtils.ChartElement> = [];
        // BMS_ChgInfo_G
        const bmsChgInfoGChgTimeTatolData: Array<TypeUtils.ChartElement> = [];
        // BMS_BattEnyInfo1
        const bmsBattEnyInfo1ChgCountData: Array<TypeUtils.ChartElement> = [];
        const bmsBattEnyInfo1SingleChgEnergyData: Array<TypeUtils.ChartElement> = [];
        const bmsBattEnyInfo1SingleDisChgEnyData: Array<TypeUtils.ChartElement> = [];
        const bmsBattEnyInfo1ChgTimeRemainData: Array<TypeUtils.ChartElement> = [];

        runningCanDataList.forEach((canData) => {
            const yeoulData = canData as CanDataYeoul.CanData;
            const dataTime = moment(yeoulData.dataTime).valueOf();

            // BMS_BatteryInfo
            if (yeoulData.bmsBatteryInfo) {
                bmsBatteryInfoBattVolData.push({ x: dataTime, y: yeoulData.bmsBatteryInfo.battVol });
                bmsBatteryInfoBattCurrData.push({ x: dataTime, y: yeoulData.bmsBatteryInfo.battCurr });
                bmsBatteryInfoBattSOCData.push({ x: dataTime, y: yeoulData.bmsBatteryInfo.battSOC });
                bmsBatteryInfoFaultLevelData.push({ x: dataTime, y: yeoulData.bmsBatteryInfo.faultLevel });
                bmsBatteryInfoBattSOHData.push({ x: dataTime, y: yeoulData.bmsBatteryInfo.battSOH });
                bmsBatteryInfoEmergCutoffHvReqData.push({ x: dataTime, y: yeoulData.bmsBatteryInfo.emergCutoffHvReq });
                bmsBatteryInfoPmtCutoffLvFbData.push({ x: dataTime, y: yeoulData.bmsBatteryInfo.pmtCutoffLvFb });
                bmsBatteryInfoSelfChkStateData.push({ x: dataTime, y: yeoulData.bmsBatteryInfo.selfChkState });
                bmsBatteryInfoNegRelayStsData.push({ x: dataTime, y: yeoulData.bmsBatteryInfo.negRelaySts });
                bmsBatteryInfoHeatRelayStsData.push({ x: dataTime, y: yeoulData.bmsBatteryInfo.heatRelaySts });
                bmsBatteryInfoActWorkStsData.push({ x: dataTime, y: yeoulData.bmsBatteryInfo.actWorkSts });
            }
            // VCU_BodyControlInfo
            if (yeoulData.vcuBodyControlInfo) {
                vcuBodyControlInfoVehicleSpdData.push({ x: dataTime, y: yeoulData.vcuBodyControlInfo.vehicleSpd });
                vcuBodyControlInfoAccPedalPositionData.push({ x: dataTime, y: yeoulData.vcuBodyControlInfo.accPedalPosition });
                vcuBodyControlInfoAceleratPedalPositionFltData.push({ x: dataTime, y: yeoulData.vcuBodyControlInfo.aceleratPedalPositionFlt });
                vcuBodyControlInfoBrakePedalPositionFltData.push({ x: dataTime, y: yeoulData.vcuBodyControlInfo.brakePedalPositionFlt });
            }
            // VCU_ErrCode
            if (yeoulData.vcuErrCode) {
                vcuErrCodeAecData.push({ x: dataTime, y: yeoulData.vcuErrCode.aec });
                vcuErrCodeDteData.push({ x: dataTime, y: yeoulData.vcuErrCode.dte });
            }
            // LBMS_Info
            if (yeoulData.lbmsInfo) {
                lbmsInfoBattCurrentData.push({ x: dataTime, y: yeoulData.lbmsInfo.battCurrent });
                lbmsInfoBattVoltData.push({ x: dataTime, y: yeoulData.lbmsInfo.battVolt });
            }
            // VCU_PTInfoIndicate
            if (yeoulData.vcuPtInfoIndicate) {
                vcuPtInfoIndicateGearPositionIndData.push({ x: dataTime, y: yeoulData.vcuPtInfoIndicate.gearPositionInd });
                vcuPtInfoIndicateHandbrakeStsData.push({ x: dataTime, y: yeoulData.vcuPtInfoIndicate.handbrakeSts });
                vcuPtInfoIndicateVehicleRunModeData.push({ x: dataTime, y: yeoulData.vcuPtInfoIndicate.vehicleRunMode });
                vcuPtInfoIndicateDriveModeIndData.push({ x: dataTime, y: yeoulData.vcuPtInfoIndicate.driveModeInd });
            }
            // BMS_Min_Max_CellVolt
            if (yeoulData.bmsMinMaxCellVolt) {
                bmsMinMaxCellVoltMinCellVoltData.push({ x: dataTime, y: yeoulData.bmsMinMaxCellVolt.minCellVolt });
                bmsMinMaxCellVoltMinVoltCellNumData.push({ x: dataTime, y: yeoulData.bmsMinMaxCellVolt.minVoltCellNum });
                bmsMinMaxCellVoltMinVoltCellPackNumData.push({ x: dataTime, y: yeoulData.bmsMinMaxCellVolt.minVoltCellPackNum });
                bmsMinMaxCellVoltMaxCellVoltData.push({ x: dataTime, y: yeoulData.bmsMinMaxCellVolt.maxCellVolt });
                bmsMinMaxCellVoltMaxVoltCellNumData.push({ x: dataTime, y: yeoulData.bmsMinMaxCellVolt.maxVoltCellNum });
                bmsMinMaxCellVoltMaxVoltCellPackNumData.push({ x: dataTime, y: yeoulData.bmsMinMaxCellVolt.maxVoltCellPackNum });
            }
            // BMS_Min_Max_CellTemp
            if (yeoulData.bmsMinMaxCellTemp) {
                bmsMinMaxCellTempBattMinTempData.push({ x: dataTime, y: yeoulData.bmsMinMaxCellTemp.battMinTemp });
                bmsMinMaxCellTempMinTempPackNumData.push({ x: dataTime, y: yeoulData.bmsMinMaxCellTemp.minTempPackNum });
                bmsMinMaxCellTempMinTempSnsNumData.push({ x: dataTime, y: yeoulData.bmsMinMaxCellTemp.minTempSnsNum });
                bmsMinMaxCellTempBnttMaxTempData.push({ x: dataTime, y: yeoulData.bmsMinMaxCellTemp.bnttMaxTemp });
                bmsMinMaxCellTempMaxTempPackNumData.push({ x: dataTime, y: yeoulData.bmsMinMaxCellTemp.maxTempPackNum });
                bmsMinMaxCellTempMaxTempSnsNumData.push({ x: dataTime, y: yeoulData.bmsMinMaxCellTemp.maxTempSnsNum });
                bmsMinMaxCellTempCellAvgTempData.push({ x: dataTime, y: yeoulData.bmsMinMaxCellTemp.cellAvgTemp });
            }
            // MCU_MotorAlarmInfo
            if (yeoulData.mcuMotorAlarmInfo) {
                mcuMotorAlarmInfoMotorTempHighAlarmData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.motorTempHighAlarm });
                mcuMotorAlarmInfoMcuTempHighAlarmData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.mcuTempHighAlarm });
                mcuMotorAlarmInfoMotorSpdHighAlarmData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.motorSpdHighAlarm });
                mcuMotorAlarmInfoCanCommFltData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.canCommFlt });
                mcuMotorAlarmInfoMcuMemoryFltData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.mcuMemoryFlt });
                mcuMotorAlarmInfoDchvCurrSensorFltData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.dchvCurrSensorFlt });
                mcuMotorAlarmInfoMotorUCurrSensorFltData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.motorUCurrSensorFlt });
                mcuMotorAlarmInfoMotorVCurrSensorFltData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.motorVCurrSensorFlt });
                mcuMotorAlarmInfoMotorFltLevelData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.motorFltLevel });
                mcuMotorAlarmInfoMcurtcUcedPwrRunErrData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.mcurtcUcedPwrRunErr });
                mcuMotorAlarmInfoActiveDischgFltData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.activeDischgFlt });
                mcuMotorAlarmInfoSoftwareCapOverVoltData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.softwareCapOverVolt });
                mcuMotorAlarmInfoHardwareCapOverVoltData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.hardwareCapOverVolt });
                mcuMotorAlarmInfoBusVoltErrData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.busVoltErr });
                mcuMotorAlarmInfoMotorLockRotErrData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.motorLockRotErr });
                mcuMotorAlarmInfoMcuTempSensorErrData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.mcuTempSensorErr });
                mcuMotorAlarmInfoMotorTempSensorErrData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.motorTempSensorErr });
                mcuMotorAlarmInfoSysFltCodeData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.sysFltCode });
                mcuMotorAlarmInfoMotorSNData.push({ x: dataTime, y: yeoulData.mcuMotorAlarmInfo.motorSN });
            }
            // LMCU_MotorAlarmInfo
            if (yeoulData.lmcuMotorAlarmInfo) {
                lmcuMotorAlarmInfoMotorTempHighAlarmData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.motorTempHighAlarm });
                lmcuMotorAlarmInfoLmcuTempHighAlarmData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.lmcuTempHighAlarm });
                lmcuMotorAlarmInfoMotorSpdHighAlarmData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.motorSpdHighAlarm });
                lmcuMotorAlarmInfoCanCommFltData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.canCommFlt });
                lmcuMotorAlarmInfoLmcuMemoryFltData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.lmcuMemoryFlt });
                lmcuMotorAlarmInfoDchvCurrSensorFltData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.dchvCurrSensorFlt });
                lmcuMotorAlarmInfoMotorUCurrSensorFltData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.motorUCurrSensorFlt });
                lmcuMotorAlarmInfoMotorVCurrSensorFltData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.motorVCurrSensorFlt });
                lmcuMotorAlarmInfoMotorFltLevelData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.motorFltLevel });
                lmcuMotorAlarmInfoLmcurtcUcedPwrRunErrData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.lmcurtcUcedPwrRunErr });
                lmcuMotorAlarmInfoActiveDischgFltData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.activeDischgFlt });
                lmcuMotorAlarmInfoSoftwareCapOverVoltData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.softwareCapOverVolt });
                lmcuMotorAlarmInfoHardwareCapOverVoltData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.hardwareCapOverVolt });
                lmcuMotorAlarmInfoBusVoltErrData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.busVoltErr });
                lmcuMotorAlarmInfoMotorLockRotErrData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.motorLockRotErr });
                lmcuMotorAlarmInfoLmcuTempSensorErrData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.lmcuTempSensorErr });
                lmcuMotorAlarmInfoMotorTempSensorErrData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.motorTempSensorErr });
                lmcuMotorAlarmInfoSysFltCodeData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.sysFltCode });
                lmcuMotorAlarmInfoMotorSNData.push({ x: dataTime, y: yeoulData.lmcuMotorAlarmInfo.motorSN });
            }
            // BMS_HVIsolationInfo
            if (yeoulData.bmsHvIsolationInfo) {
                bmsHvIsolationInfoPosIsolationResData.push({ x: dataTime, y: yeoulData.bmsHvIsolationInfo.posIsolationRes });
                bmsHvIsolationInfoNegIsolationResData.push({ x: dataTime, y: yeoulData.bmsHvIsolationInfo.negIsolationRes });
                bmsHvIsolationInfoHvIsolationStsData.push({ x: dataTime, y: yeoulData.bmsHvIsolationInfo.hvIsolationSts });
                bmsHvIsolationInfoIsolationFaultData.push({ x: dataTime, y: yeoulData.bmsHvIsolationInfo.isolationFault });
                bmsHvIsolationInfoBattFireFaultData.push({ x: dataTime, y: yeoulData.bmsHvIsolationInfo.battFireFault });
            }
            // TCU_Info1
            if (yeoulData.tcuInfo1) {
                tcuInfo1CurrentgearData.push({ x: dataTime, y: yeoulData.tcuInfo1.currentgear });
                tcuInfo1GearStateData.push({ x: dataTime, y: yeoulData.tcuInfo1.gearState });
                tcuInfo1FultGrdData.push({ x: dataTime, y: yeoulData.tcuInfo1.fultGrd });
            }
            // DCDC_StatusInfo
            if (yeoulData.dcdcStatusInfo) {
                dcdcStatusInfoFaultLevelData.push({ x: dataTime, y: yeoulData.dcdcStatusInfo.faultLevel });
            }
            // SDCAC_StatusInfo
            if (yeoulData.sdcacStatusInfo) {
                sdcacStatusInfoFaultLevelData.push({ x: dataTime, y: yeoulData.sdcacStatusInfo.faultLevel });
            }
            // BDCAC_StatusInfo
            if (yeoulData.bdcacStatusInfo) {
                bdcacStatusInfoFaultLevelData.push({ x: dataTime, y: yeoulData.bdcacStatusInfo.faultLevel });
            }
            // HCM_WorkInfo
            if (yeoulData.hcmWorkInfo) {
                hcmWorkInfoWorkStsData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.workSts });
                hcmWorkInfoAssistPosConnStsData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.assistPosConnSts });
                hcmWorkInfoSelfChkStsData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.selfChkSts });
                hcmWorkInfoFaultLevelData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.faultLevel });
                hcmWorkInfoEmergCutOffHVData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.emergCutOffHV });
                hcmWorkInfoCutOffLvFbData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.cutOffLvFb });
                hcmWorkInfoMainPosConnStsData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.mainPosConnSts });
                hcmWorkInfoPreChgConnStsData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.preChgConnSts });
                hcmWorkInfoPtcConnStsFbData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.ptcConnStsFb });
                hcmWorkInfoFastChgConnStsFbData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.fastChgConnStsFb });
                hcmWorkInfoSlowChgConnStsFbData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.slowChgConnStsFb });
                hcmWorkInfoInterLockLoopStsData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.interLockLoopSts });
                hcmWorkInfoOverTempData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.overTemp });
                hcmWorkInfoCanComFaultData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.canComFault });
                hcmWorkInfoHvLoopFaultData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.hvLoopFault });
                hcmWorkInfoSupplyVolFaultData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.supplyVolFault });
                hcmWorkInfoHvLoopWorkStsData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.hvLoopWorkSts });
                hcmWorkInfoMainNegConnStsData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.mainNegConnSts });
                hcmWorkInfoMainPosRalayFltData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.mainPosRalayFlt });
                hcmWorkInfoPreChgRelayFltData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.preChgRelayFlt });
                hcmWorkInfoFastChgRelayFltData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.fastChgRelayFlt });
                hcmWorkInfoPtcRelayFltData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.ptcRelayFlt });
                hcmWorkInfoSlowChgRelayFltData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.slowChgRelayFlt });
                hcmWorkInfoAssistPosRelayFltData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.assistPosRelayFlt });
                hcmWorkInfoMainNegRelayFltData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.mainNegRelayFlt });
                hcmWorkInfoAssitPreChgConnStsData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.assitPreChgConnSts });
                hcmWorkInfoAssistPreChgRelayFltData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.assistPreChgRelayFlt });
                hcmWorkInfoWorkInfAliveCntData.push({ x: dataTime, y: yeoulData.hcmWorkInfo.workInfAliveCnt });
            }
            // VCU_HVFunctionCtrl
            if (yeoulData.vcuHvFunctionCtrl) {
                vcuHvFunctionCtrlMainPosCtrlComndData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.mainPosCtrlComnd });
                vcuHvFunctionCtrlAllowChgData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.allowChg });
                vcuHvFunctionCtrlBmshvOnOffReqData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.bmshvOnOffReq });
                vcuHvFunctionCtrlTmsoffRequestData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.tmsoffRequest });
                vcuHvFunctionCtrlDcdcEnableOutData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.dcdcEnableOut });
                vcuHvFunctionCtrlBdcacEnableOutData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.bdcacEnableOut });
                vcuHvFunctionCtrlSdcacEnableOutData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.sdcacEnableOut });
                vcuHvFunctionCtrlAssitPosCtrlComndData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.assitPosCtrlComnd });
                vcuHvFunctionCtrlHcmCutOffLVData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.hcmCutOffLV });
                vcuHvFunctionCtrlBmsCutOffLVData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.bmsCutOffLV });
                vcuHvFunctionCtrlMcuCutOffLVData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.mcuCutOffLV });
                vcuHvFunctionCtrlPtcCtrlCmdData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.ptcCtrlCmd });
                vcuHvFunctionCtrlDcdcPwrLmtData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.dcdcPwrLmt });
                vcuHvFunctionCtrlSdcacOutFreqData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.sdcacOutFreq });
                vcuHvFunctionCtrlAssitPos2CtrlCmdData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.assitPos2CtrlCmd });
                vcuHvFunctionCtrlMainNegCtrlComndData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.mainNegCtrlComnd });
                vcuHvFunctionCtrlLsdcacCtrlComndData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.lsdcacCtrlComnd });
                vcuHvFunctionCtrlSelfCheckStsData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.selfCheckSts });
                vcuHvFunctionCtrlHvFunctionCtrlAliverCounterData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.hvFunctionCtrlAliverCounter });
                vcuHvFunctionCtrlHvFunctionCtrlChecksumData.push({ x: dataTime, y: yeoulData.vcuHvFunctionCtrl.hvFunctionCtrlChecksum });
            }
            // VCU_LVFunctionCtrl
            if (yeoulData.vcuLvFunctionCtrl) {
                vcuLvFunctionCtrlDefrosterCtrlLData.push({ x: dataTime, y: yeoulData.vcuLvFunctionCtrl.defrosterCtrlL });
                vcuLvFunctionCtrlDefrosterCtrlHData.push({ x: dataTime, y: yeoulData.vcuLvFunctionCtrl.defrosterCtrlH });
                vcuLvFunctionCtrlAcPanelCtrlData.push({ x: dataTime, y: yeoulData.vcuLvFunctionCtrl.acPanelCtrl });
                vcuLvFunctionCtrlHcmPowerCtrlData.push({ x: dataTime, y: yeoulData.vcuLvFunctionCtrl.hcmPowerCtrl });
                vcuLvFunctionCtrlCehModeCmdData.push({ x: dataTime, y: yeoulData.vcuLvFunctionCtrl.cehModeCmd });
                vcuLvFunctionCtrlCehPwmCmdData.push({ x: dataTime, y: yeoulData.vcuLvFunctionCtrl.cehPwmCmd });
                vcuLvFunctionCtrlCehTempCmdData.push({ x: dataTime, y: yeoulData.vcuLvFunctionCtrl.cehTempCmd });
            }
            // MCU_MotorElePara
            if (yeoulData.mcuMotorElePara) {
                mcuMotorEleParaHvBusVolData.push({ x: dataTime, y: yeoulData.mcuMotorElePara.hvBusVol });
            }
            // BMS_BatPackLmt
            if (yeoulData.bmsBatPackLmt) {
                bmsBatPackLmtMaxPmtEnyRecoCurrData.push({ x: dataTime, y: yeoulData.bmsBatPackLmt.maxPmtEnyRecoCurr });
                bmsBatPackLmtMaxPmtDischgCurrData.push({ x: dataTime, y: yeoulData.bmsBatPackLmt.maxPmtDischgCurr });
                bmsBatPackLmtBattMaxWorkTempData.push({ x: dataTime, y: yeoulData.bmsBatPackLmt.battMaxWorkTemp });
                bmsBatPackLmtBattMinWorkTempData.push({ x: dataTime, y: yeoulData.bmsBatPackLmt.battMinWorkTemp });
                bmsBatPackLmtMinPmtSOCData.push({ x: dataTime, y: yeoulData.bmsBatPackLmt.minPmtSOC });
                bmsBatPackLmtMaxPmtEnyRecoVolData.push({ x: dataTime, y: yeoulData.bmsBatPackLmt.maxPmtEnyRecoVol });
            }
            // BMS_BattaryFltInfo
            if (yeoulData.bmsBattaryFltInfo) {
                bmsBattaryFltInfoBattPackVolFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.battPackVolFault });
                bmsBattaryFltInfoBattCellVolFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.battCellVolFault });
                bmsBattaryFltInfoBattTempFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.battTempFault });
                bmsBattaryFltInfoBattSocFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.battSocFault });
                bmsBattaryFltInfoSocJumpFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.socJumpFault });
                bmsBattaryFltInfoBattEqualizationStsData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.battEqualizationSts });
                bmsBattaryFltInfoDischargeCurrFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.dischargeCurrFault });
                bmsBattaryFltInfoChargeCurrFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.chargeCurrFault });
                bmsBattaryFltInfoBattIsolationStsData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.battIsolationSts });
                bmsBattaryFltInfoCanComFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.canComFault });
                bmsBattaryFltInfoBattPackMatchFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.battPackMatchFault });
                bmsBattaryFltInfoBattConsistencyFltData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.battConsistencyFlt });
                bmsBattaryFltInfoCurrSensorFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.currSensorFault });
                bmsBattaryFltInfoMsdFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.msdFault });
                bmsBattaryFltInfoHeatPosRelayFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.heatPosRelayFault });
                bmsBattaryFltInfoHeatNegRelayFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.heatNegRelayFault });
                bmsBattaryFltInfoOverChgFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.overChgFault });
                bmsBattaryFltInfoSt1FltHwData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.st1FltHw });
                bmsBattaryFltInfoPosRelayFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.posRelayFault });
                bmsBattaryFltInfoNegRelayFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.negRelayFault });
                bmsBattaryFltInfoSt1FltHvilData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.st1FltHvil });
                bmsBattaryFltInfoCellVolDiffFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.cellVolDiffFault });
                bmsBattaryFltInfoCellTempDiffFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.cellTempDiffFault });
                bmsBattaryFltInfoEnyRecoCurrHighFltData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.enyRecoCurrHighFlt });
                bmsBattaryFltInfoPowerActiveModeData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.powerActiveMode });
                bmsBattaryFltInfoBattFireFaultData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.battFireFault });
                bmsBattaryFltInfoBattFaultInfoAliveCntData.push({ x: dataTime, y: yeoulData.bmsBattaryFltInfo.battFaultInfoAliveCnt });
            }
            // BMS_CellVoltData
            if (yeoulData.bmsCellVoltData) {
                bmsCellVoltDataCellVolt1Data.push({ x: dataTime, y: yeoulData.bmsCellVoltData.cellVolt1 });
                bmsCellVoltDataCellVolt2Data.push({ x: dataTime, y: yeoulData.bmsCellVoltData.cellVolt2 });
                bmsCellVoltDataCellVolt3Data.push({ x: dataTime, y: yeoulData.bmsCellVoltData.cellVolt3 });
                bmsCellVoltDataCellVolt4Data.push({ x: dataTime, y: yeoulData.bmsCellVoltData.cellVolt4 });
            }
            // BMS_CellTempData
            if (yeoulData.bmsCellTempData) {
                bmsCellTempDataBattTemp1Data.push({ x: dataTime, y: yeoulData.bmsCellTempData.battTemp1 });
                bmsCellTempDataBattTemp2Data.push({ x: dataTime, y: yeoulData.bmsCellTempData.battTemp2 });
                bmsCellTempDataBattTemp3Data.push({ x: dataTime, y: yeoulData.bmsCellTempData.battTemp3 });
                bmsCellTempDataBattTemp4Data.push({ x: dataTime, y: yeoulData.bmsCellTempData.battTemp4 });
                bmsCellTempDataBattTemp5Data.push({ x: dataTime, y: yeoulData.bmsCellTempData.battTemp5 });
                bmsCellTempDataBattTemp6Data.push({ x: dataTime, y: yeoulData.bmsCellTempData.battTemp6 });
                bmsCellTempDataBattTemp7Data.push({ x: dataTime, y: yeoulData.bmsCellTempData.battTemp7 });
                bmsCellTempDataBattTemp8Data.push({ x: dataTime, y: yeoulData.bmsCellTempData.battTemp8 });
            }
            // IC_Odometer
            if (yeoulData.icOdometer) {
                icOdometerTripData.push({ x: dataTime, y: yeoulData.icOdometer.trip });
                icOdometerOdometerData.push({ x: dataTime, y: yeoulData.icOdometer.odometer });
            }
            // IC_DoorSts
            if (yeoulData.icDoorSts) {
                icDoorStsBatteryLowvtgeData.push({ x: dataTime, y: yeoulData.icDoorSts.batteryLowvtge });
                icDoorStsDoor1OpenStsData.push({ x: dataTime, y: yeoulData.icDoorSts.door1OpenSts });
                icDoorStsDriverSeatbeltsData.push({ x: dataTime, y: yeoulData.icDoorSts.driverSeatbelts });
                icDoorStsLampcircuitStsData.push({ x: dataTime, y: yeoulData.icDoorSts.lampcircuitSts });
                icDoorStsDoor2OpenStsData.push({ x: dataTime, y: yeoulData.icDoorSts.door2OpenSts });
                icDoorStsDoorBellData.push({ x: dataTime, y: yeoulData.icDoorSts.doorBell });
                icDoorStsDriverSeatData.push({ x: dataTime, y: yeoulData.icDoorSts.driverSeat });
                icDoorStsTrumpetStsData.push({ x: dataTime, y: yeoulData.icDoorSts.trumpetSts });
                icDoorStsDoor3OpenStsData.push({ x: dataTime, y: yeoulData.icDoorSts.door3OpenSts });
                icDoorStsPowerModeData.push({ x: dataTime, y: yeoulData.icDoorSts.powerMode });
                icDoorStsDoor5LockStsData.push({ x: dataTime, y: yeoulData.icDoorSts.door5LockSts });
                icDoorStsDoor4OpenStsData.push({ x: dataTime, y: yeoulData.icDoorSts.door4OpenSts });
                icDoorStsFrontAirTankPrsureData.push({ x: dataTime, y: yeoulData.icDoorSts.frontAirTankPrsure });
                icDoorStsFrontAirTankLowPrsureAlarmData.push({ x: dataTime, y: yeoulData.icDoorSts.frontAirTankLowPrsureAlarm });
                icDoorStsRearAirTankLowPrsureAlarmData.push({ x: dataTime, y: yeoulData.icDoorSts.rearAirTankLowPrsureAlarm });
                icDoorStsRearAirTankPrsureData.push({ x: dataTime, y: yeoulData.icDoorSts.rearAirTankPrsure });
                icDoorStsPrakingAirTankLowPrsureAlarmData.push({ x: dataTime, y: yeoulData.icDoorSts.prakingAirTankLowPrsureAlarm });
                icDoorStsAssistAirTankLowPrsureAlarmData.push({ x: dataTime, y: yeoulData.icDoorSts.assistAirTankLowPrsureAlarm });
                icDoorStsSteeringIndicatorData.push({ x: dataTime, y: yeoulData.icDoorSts.steeringIndicator });
                icDoorStsDoorOpenStsData.push({ x: dataTime, y: yeoulData.icDoorSts.doorOpenSts });
                icDoorStsEmgValveData.push({ x: dataTime, y: yeoulData.icDoorSts.emgValve });
                icDoorStsCoolLqdPosData.push({ x: dataTime, y: yeoulData.icDoorSts.coolLqdPos });
                icDoorStsSosActiveData.push({ x: dataTime, y: yeoulData.icDoorSts.sosActive });
                icDoorStsDangeractiveData.push({ x: dataTime, y: yeoulData.icDoorSts.dangeractive });
            }
            // VCU_CCVS
            if (yeoulData.vcuCcvs) {
                vcuCcvsHndbrkSts1939Data.push({ x: dataTime, y: yeoulData.vcuCcvs.hndbrkSts1939 });
                vcuCcvsVehicleSpd1939Data.push({ x: dataTime, y: yeoulData.vcuCcvs.vehicleSpd1939 });
            }
            // VCU_EMTrqSpdCtrl
            if (yeoulData.vcuEmTrqSpdCtrl) {
                vcuEmTrqSpdCtrlMcuEnableReqData.push({ x: dataTime, y: yeoulData.vcuEmTrqSpdCtrl.mcuEnableReq });
                vcuEmTrqSpdCtrlEmCtrlModeData.push({ x: dataTime, y: yeoulData.vcuEmTrqSpdCtrl.emCtrlMode });
                vcuEmTrqSpdCtrlEmWorkModeData.push({ x: dataTime, y: yeoulData.vcuEmTrqSpdCtrl.emWorkMode });
                vcuEmTrqSpdCtrlReqSpdOrLmtData.push({ x: dataTime, y: yeoulData.vcuEmTrqSpdCtrl.reqSpdOrLmt });
                vcuEmTrqSpdCtrlReqTrqOrLmtData.push({ x: dataTime, y: yeoulData.vcuEmTrqSpdCtrl.reqTrqOrLmt });
                vcuEmTrqSpdCtrlMaxEmPwrLmtData.push({ x: dataTime, y: yeoulData.vcuEmTrqSpdCtrl.maxEmPwrLmt });
                vcuEmTrqSpdCtrlMinEmPwrLmtData.push({ x: dataTime, y: yeoulData.vcuEmTrqSpdCtrl.minEmPwrLmt });
                vcuEmTrqSpdCtrlEmTrqSpdCtrlAliveCntData.push({ x: dataTime, y: yeoulData.vcuEmTrqSpdCtrl.emTrqSpdCtrlAliveCnt });
            }
            // MCU_MotorSpd
            if (yeoulData.mcuMotorSpd) {
                mcuMotorSpdMotorSpeedEbsData.push({ x: dataTime, y: yeoulData.mcuMotorSpd.motorSpeedEbs });
                mcuMotorSpdMotorTrqAliveCntData.push({ x: dataTime, y: yeoulData.mcuMotorSpd.motorTrqAliveCnt });
            }
            // MCU_MotorTrq
            if (yeoulData.mcuMotorTrq) {
                mcuMotorTrqMotorMaxTrqData.push({ x: dataTime, y: yeoulData.mcuMotorTrq.motorMaxTrq });
                mcuMotorTrqMotorMinTrqData.push({ x: dataTime, y: yeoulData.mcuMotorTrq.motorMinTrq });
                mcuMotorTrqMotorTrqAliveCntData.push({ x: dataTime, y: yeoulData.mcuMotorTrq.motorTrqAliveCnt });
            }
            // LMCU_MotorTrq
            if (yeoulData.lmcuMotorTrq) {
                lmcuMotorTrqMotorMaxTrqData.push({ x: dataTime, y: yeoulData.lmcuMotorTrq.motorMaxTrq });
                lmcuMotorTrqMotorMinTrqData.push({ x: dataTime, y: yeoulData.lmcuMotorTrq.motorMinTrq });
                lmcuMotorTrqMotorTrqAliveCntData.push({ x: dataTime, y: yeoulData.lmcuMotorTrq.motorTrqAliveCnt });
            }
            // LMCU_MotorElePara
            if (yeoulData.lmcuMotorElePara) {
                lmcuMotorEleParaHvBusVolData.push({ x: dataTime, y: yeoulData.lmcuMotorElePara.hvBusVol });
                lmcuMotorEleParaHvdcCurrData.push({ x: dataTime, y: yeoulData.lmcuMotorElePara.hvdcCurr });
                lmcuMotorEleParaMoterActOutPowerData.push({ x: dataTime, y: yeoulData.lmcuMotorElePara.moterActOutPower });
                lmcuMotorEleParaMoterTempData.push({ x: dataTime, y: yeoulData.lmcuMotorElePara.moterTemp });
                lmcuMotorEleParaLmcuTempData.push({ x: dataTime, y: yeoulData.lmcuMotorElePara.lmcuTemp });
            }
            // BMS_ChgInfo_G
            if (yeoulData.bmsChgInfoG) {
                bmsChgInfoGChgTimeTatolData.push({ x: dataTime, y: yeoulData.bmsChgInfoG.chgTimeTatol });
            }
            // BMS_BattEnyInfo1
            if (yeoulData.bmsBattEnyInfo1) {
                bmsBattEnyInfo1ChgCountData.push({ x: dataTime, y: yeoulData.bmsBattEnyInfo1.chgCount });
                bmsBattEnyInfo1SingleChgEnergyData.push({ x: dataTime, y: yeoulData.bmsBattEnyInfo1.singleChgEnergy });
                bmsBattEnyInfo1SingleDisChgEnyData.push({ x: dataTime, y: yeoulData.bmsBattEnyInfo1.singleDisChgEny });
                bmsBattEnyInfo1ChgTimeRemainData.push({ x: dataTime, y: yeoulData.bmsBattEnyInfo1.chgTimeRemain });
            }
        });

        setChartBmsBatteryInfoBattVol((prev) => ({ ...prev, data: bmsBatteryInfoBattVolData }));
        setChartBmsBatteryInfoBattCurr((prev) => ({ ...prev, data: bmsBatteryInfoBattCurrData }));
        setChartBmsBatteryInfoBattSOC((prev) => ({ ...prev, data: bmsBatteryInfoBattSOCData }));
        setChartBmsBatteryInfoFaultLevel((prev) => ({ ...prev, data: bmsBatteryInfoFaultLevelData }));
        setChartBmsBatteryInfoBattSOH((prev) => ({ ...prev, data: bmsBatteryInfoBattSOHData }));
        setChartBmsBatteryInfoEmergCutoffHvReq((prev) => ({ ...prev, data: bmsBatteryInfoEmergCutoffHvReqData }));
        setChartBmsBatteryInfoPmtCutoffLvFb((prev) => ({ ...prev, data: bmsBatteryInfoPmtCutoffLvFbData }));
        setChartBmsBatteryInfoSelfChkState((prev) => ({ ...prev, data: bmsBatteryInfoSelfChkStateData }));
        setChartBmsBatteryInfoNegRelaySts((prev) => ({ ...prev, data: bmsBatteryInfoNegRelayStsData }));
        setChartBmsBatteryInfoHeatRelaySts((prev) => ({ ...prev, data: bmsBatteryInfoHeatRelayStsData }));
        setChartBmsBatteryInfoActWorkSts((prev) => ({ ...prev, data: bmsBatteryInfoActWorkStsData }));
        setChartVcuBodyControlInfoVehicleSpd((prev) => ({ ...prev, data: vcuBodyControlInfoVehicleSpdData }));
        setChartVcuBodyControlInfoAccPedalPosition((prev) => ({ ...prev, data: vcuBodyControlInfoAccPedalPositionData }));
        setChartVcuBodyControlInfoAceleratPedalPositionFlt((prev) => ({ ...prev, data: vcuBodyControlInfoAceleratPedalPositionFltData }));
        setChartVcuBodyControlInfoBrakePedalPositionFlt((prev) => ({ ...prev, data: vcuBodyControlInfoBrakePedalPositionFltData }));
        setChartVcuErrCodeAec((prev) => ({ ...prev, data: vcuErrCodeAecData }));
        setChartVcuErrCodeDte((prev) => ({ ...prev, data: vcuErrCodeDteData }));
        setChartLbmsInfoBattCurrent((prev) => ({ ...prev, data: lbmsInfoBattCurrentData }));
        setChartLbmsInfoBattVolt((prev) => ({ ...prev, data: lbmsInfoBattVoltData }));
        setChartVcuPtInfoIndicateGearPositionInd((prev) => ({ ...prev, data: vcuPtInfoIndicateGearPositionIndData }));
        setChartVcuPtInfoIndicateHandbrakeSts((prev) => ({ ...prev, data: vcuPtInfoIndicateHandbrakeStsData }));
        setChartVcuPtInfoIndicateVehicleRunMode((prev) => ({ ...prev, data: vcuPtInfoIndicateVehicleRunModeData }));
        setChartVcuPtInfoIndicateDriveModeInd((prev) => ({ ...prev, data: vcuPtInfoIndicateDriveModeIndData }));
        setChartBmsMinMaxCellVoltMinCellVolt((prev) => ({ ...prev, data: bmsMinMaxCellVoltMinCellVoltData }));
        setChartBmsMinMaxCellVoltMinVoltCellNum((prev) => ({ ...prev, data: bmsMinMaxCellVoltMinVoltCellNumData }));
        setChartBmsMinMaxCellVoltMinVoltCellPackNum((prev) => ({ ...prev, data: bmsMinMaxCellVoltMinVoltCellPackNumData }));
        setChartBmsMinMaxCellVoltMaxCellVolt((prev) => ({ ...prev, data: bmsMinMaxCellVoltMaxCellVoltData }));
        setChartBmsMinMaxCellVoltMaxVoltCellNum((prev) => ({ ...prev, data: bmsMinMaxCellVoltMaxVoltCellNumData }));
        setChartBmsMinMaxCellVoltMaxVoltCellPackNum((prev) => ({ ...prev, data: bmsMinMaxCellVoltMaxVoltCellPackNumData }));
        setChartBmsMinMaxCellTempBattMinTemp((prev) => ({ ...prev, data: bmsMinMaxCellTempBattMinTempData }));
        setChartBmsMinMaxCellTempMinTempPackNum((prev) => ({ ...prev, data: bmsMinMaxCellTempMinTempPackNumData }));
        setChartBmsMinMaxCellTempMinTempSnsNum((prev) => ({ ...prev, data: bmsMinMaxCellTempMinTempSnsNumData }));
        setChartBmsMinMaxCellTempBnttMaxTemp((prev) => ({ ...prev, data: bmsMinMaxCellTempBnttMaxTempData }));
        setChartBmsMinMaxCellTempMaxTempPackNum((prev) => ({ ...prev, data: bmsMinMaxCellTempMaxTempPackNumData }));
        setChartBmsMinMaxCellTempMaxTempSnsNum((prev) => ({ ...prev, data: bmsMinMaxCellTempMaxTempSnsNumData }));
        setChartBmsMinMaxCellTempCellAvgTemp((prev) => ({ ...prev, data: bmsMinMaxCellTempCellAvgTempData }));
        setChartMcuMotorAlarmInfoMotorTempHighAlarm((prev) => ({ ...prev, data: mcuMotorAlarmInfoMotorTempHighAlarmData }));
        setChartMcuMotorAlarmInfoMcuTempHighAlarm((prev) => ({ ...prev, data: mcuMotorAlarmInfoMcuTempHighAlarmData }));
        setChartMcuMotorAlarmInfoMotorSpdHighAlarm((prev) => ({ ...prev, data: mcuMotorAlarmInfoMotorSpdHighAlarmData }));
        setChartMcuMotorAlarmInfoCanCommFlt((prev) => ({ ...prev, data: mcuMotorAlarmInfoCanCommFltData }));
        setChartMcuMotorAlarmInfoMcuMemoryFlt((prev) => ({ ...prev, data: mcuMotorAlarmInfoMcuMemoryFltData }));
        setChartMcuMotorAlarmInfoDchvCurrSensorFlt((prev) => ({ ...prev, data: mcuMotorAlarmInfoDchvCurrSensorFltData }));
        setChartMcuMotorAlarmInfoMotorUCurrSensorFlt((prev) => ({ ...prev, data: mcuMotorAlarmInfoMotorUCurrSensorFltData }));
        setChartMcuMotorAlarmInfoMotorVCurrSensorFlt((prev) => ({ ...prev, data: mcuMotorAlarmInfoMotorVCurrSensorFltData }));
        setChartMcuMotorAlarmInfoMotorFltLevel((prev) => ({ ...prev, data: mcuMotorAlarmInfoMotorFltLevelData }));
        setChartMcuMotorAlarmInfoMcurtcUcedPwrRunErr((prev) => ({ ...prev, data: mcuMotorAlarmInfoMcurtcUcedPwrRunErrData }));
        setChartMcuMotorAlarmInfoActiveDischgFlt((prev) => ({ ...prev, data: mcuMotorAlarmInfoActiveDischgFltData }));
        setChartMcuMotorAlarmInfoSoftwareCapOverVolt((prev) => ({ ...prev, data: mcuMotorAlarmInfoSoftwareCapOverVoltData }));
        setChartMcuMotorAlarmInfoHardwareCapOverVolt((prev) => ({ ...prev, data: mcuMotorAlarmInfoHardwareCapOverVoltData }));
        setChartMcuMotorAlarmInfoBusVoltErr((prev) => ({ ...prev, data: mcuMotorAlarmInfoBusVoltErrData }));
        setChartMcuMotorAlarmInfoMotorLockRotErr((prev) => ({ ...prev, data: mcuMotorAlarmInfoMotorLockRotErrData }));
        setChartMcuMotorAlarmInfoMcuTempSensorErr((prev) => ({ ...prev, data: mcuMotorAlarmInfoMcuTempSensorErrData }));
        setChartMcuMotorAlarmInfoMotorTempSensorErr((prev) => ({ ...prev, data: mcuMotorAlarmInfoMotorTempSensorErrData }));
        setChartMcuMotorAlarmInfoSysFltCode((prev) => ({ ...prev, data: mcuMotorAlarmInfoSysFltCodeData }));
        setChartMcuMotorAlarmInfoMotorSN((prev) => ({ ...prev, data: mcuMotorAlarmInfoMotorSNData }));
        setChartLmcuMotorAlarmInfoMotorTempHighAlarm((prev) => ({ ...prev, data: lmcuMotorAlarmInfoMotorTempHighAlarmData }));
        setChartLmcuMotorAlarmInfoLmcuTempHighAlarm((prev) => ({ ...prev, data: lmcuMotorAlarmInfoLmcuTempHighAlarmData }));
        setChartLmcuMotorAlarmInfoMotorSpdHighAlarm((prev) => ({ ...prev, data: lmcuMotorAlarmInfoMotorSpdHighAlarmData }));
        setChartLmcuMotorAlarmInfoCanCommFlt((prev) => ({ ...prev, data: lmcuMotorAlarmInfoCanCommFltData }));
        setChartLmcuMotorAlarmInfoLmcuMemoryFlt((prev) => ({ ...prev, data: lmcuMotorAlarmInfoLmcuMemoryFltData }));
        setChartLmcuMotorAlarmInfoDchvCurrSensorFlt((prev) => ({ ...prev, data: lmcuMotorAlarmInfoDchvCurrSensorFltData }));
        setChartLmcuMotorAlarmInfoMotorUCurrSensorFlt((prev) => ({ ...prev, data: lmcuMotorAlarmInfoMotorUCurrSensorFltData }));
        setChartLmcuMotorAlarmInfoMotorVCurrSensorFlt((prev) => ({ ...prev, data: lmcuMotorAlarmInfoMotorVCurrSensorFltData }));
        setChartLmcuMotorAlarmInfoMotorFltLevel((prev) => ({ ...prev, data: lmcuMotorAlarmInfoMotorFltLevelData }));
        setChartLmcuMotorAlarmInfoLmcurtcUcedPwrRunErr((prev) => ({ ...prev, data: lmcuMotorAlarmInfoLmcurtcUcedPwrRunErrData }));
        setChartLmcuMotorAlarmInfoActiveDischgFlt((prev) => ({ ...prev, data: lmcuMotorAlarmInfoActiveDischgFltData }));
        setChartLmcuMotorAlarmInfoSoftwareCapOverVolt((prev) => ({ ...prev, data: lmcuMotorAlarmInfoSoftwareCapOverVoltData }));
        setChartLmcuMotorAlarmInfoHardwareCapOverVolt((prev) => ({ ...prev, data: lmcuMotorAlarmInfoHardwareCapOverVoltData }));
        setChartLmcuMotorAlarmInfoBusVoltErr((prev) => ({ ...prev, data: lmcuMotorAlarmInfoBusVoltErrData }));
        setChartLmcuMotorAlarmInfoMotorLockRotErr((prev) => ({ ...prev, data: lmcuMotorAlarmInfoMotorLockRotErrData }));
        setChartLmcuMotorAlarmInfoLmcuTempSensorErr((prev) => ({ ...prev, data: lmcuMotorAlarmInfoLmcuTempSensorErrData }));
        setChartLmcuMotorAlarmInfoMotorTempSensorErr((prev) => ({ ...prev, data: lmcuMotorAlarmInfoMotorTempSensorErrData }));
        setChartLmcuMotorAlarmInfoSysFltCode((prev) => ({ ...prev, data: lmcuMotorAlarmInfoSysFltCodeData }));
        setChartLmcuMotorAlarmInfoMotorSN((prev) => ({ ...prev, data: lmcuMotorAlarmInfoMotorSNData }));
        setChartBmsHvIsolationInfoPosIsolationRes((prev) => ({ ...prev, data: bmsHvIsolationInfoPosIsolationResData }));
        setChartBmsHvIsolationInfoNegIsolationRes((prev) => ({ ...prev, data: bmsHvIsolationInfoNegIsolationResData }));
        setChartBmsHvIsolationInfoHvIsolationSts((prev) => ({ ...prev, data: bmsHvIsolationInfoHvIsolationStsData }));
        setChartBmsHvIsolationInfoIsolationFault((prev) => ({ ...prev, data: bmsHvIsolationInfoIsolationFaultData }));
        setChartBmsHvIsolationInfoBattFireFault((prev) => ({ ...prev, data: bmsHvIsolationInfoBattFireFaultData }));
        setChartTcuInfo1Currentgear((prev) => ({ ...prev, data: tcuInfo1CurrentgearData }));
        setChartTcuInfo1GearState((prev) => ({ ...prev, data: tcuInfo1GearStateData }));
        setChartTcuInfo1FultGrd((prev) => ({ ...prev, data: tcuInfo1FultGrdData }));
        setChartDcdcStatusInfoFaultLevel((prev) => ({ ...prev, data: dcdcStatusInfoFaultLevelData }));
        setChartSdcacStatusInfoFaultLevel((prev) => ({ ...prev, data: sdcacStatusInfoFaultLevelData }));
        setChartBdcacStatusInfoFaultLevel((prev) => ({ ...prev, data: bdcacStatusInfoFaultLevelData }));
        setChartHcmWorkInfoWorkSts((prev) => ({ ...prev, data: hcmWorkInfoWorkStsData }));
        setChartHcmWorkInfoAssistPosConnSts((prev) => ({ ...prev, data: hcmWorkInfoAssistPosConnStsData }));
        setChartHcmWorkInfoSelfChkSts((prev) => ({ ...prev, data: hcmWorkInfoSelfChkStsData }));
        setChartHcmWorkInfoFaultLevel((prev) => ({ ...prev, data: hcmWorkInfoFaultLevelData }));
        setChartHcmWorkInfoEmergCutOffHV((prev) => ({ ...prev, data: hcmWorkInfoEmergCutOffHVData }));
        setChartHcmWorkInfoCutOffLvFb((prev) => ({ ...prev, data: hcmWorkInfoCutOffLvFbData }));
        setChartHcmWorkInfoMainPosConnSts((prev) => ({ ...prev, data: hcmWorkInfoMainPosConnStsData }));
        setChartHcmWorkInfoPreChgConnSts((prev) => ({ ...prev, data: hcmWorkInfoPreChgConnStsData }));
        setChartHcmWorkInfoPtcConnStsFb((prev) => ({ ...prev, data: hcmWorkInfoPtcConnStsFbData }));
        setChartHcmWorkInfoFastChgConnStsFb((prev) => ({ ...prev, data: hcmWorkInfoFastChgConnStsFbData }));
        setChartHcmWorkInfoSlowChgConnStsFb((prev) => ({ ...prev, data: hcmWorkInfoSlowChgConnStsFbData }));
        setChartHcmWorkInfoInterLockLoopSts((prev) => ({ ...prev, data: hcmWorkInfoInterLockLoopStsData }));
        setChartHcmWorkInfoOverTemp((prev) => ({ ...prev, data: hcmWorkInfoOverTempData }));
        setChartHcmWorkInfoCanComFault((prev) => ({ ...prev, data: hcmWorkInfoCanComFaultData }));
        setChartHcmWorkInfoHvLoopFault((prev) => ({ ...prev, data: hcmWorkInfoHvLoopFaultData }));
        setChartHcmWorkInfoSupplyVolFault((prev) => ({ ...prev, data: hcmWorkInfoSupplyVolFaultData }));
        setChartHcmWorkInfoHvLoopWorkSts((prev) => ({ ...prev, data: hcmWorkInfoHvLoopWorkStsData }));
        setChartHcmWorkInfoMainNegConnSts((prev) => ({ ...prev, data: hcmWorkInfoMainNegConnStsData }));
        setChartHcmWorkInfoMainPosRalayFlt((prev) => ({ ...prev, data: hcmWorkInfoMainPosRalayFltData }));
        setChartHcmWorkInfoPreChgRelayFlt((prev) => ({ ...prev, data: hcmWorkInfoPreChgRelayFltData }));
        setChartHcmWorkInfoFastChgRelayFlt((prev) => ({ ...prev, data: hcmWorkInfoFastChgRelayFltData }));
        setChartHcmWorkInfoPtcRelayFlt((prev) => ({ ...prev, data: hcmWorkInfoPtcRelayFltData }));
        setChartHcmWorkInfoSlowChgRelayFlt((prev) => ({ ...prev, data: hcmWorkInfoSlowChgRelayFltData }));
        setChartHcmWorkInfoAssistPosRelayFlt((prev) => ({ ...prev, data: hcmWorkInfoAssistPosRelayFltData }));
        setChartHcmWorkInfoMainNegRelayFlt((prev) => ({ ...prev, data: hcmWorkInfoMainNegRelayFltData }));
        setChartHcmWorkInfoAssitPreChgConnSts((prev) => ({ ...prev, data: hcmWorkInfoAssitPreChgConnStsData }));
        setChartHcmWorkInfoAssistPreChgRelayFlt((prev) => ({ ...prev, data: hcmWorkInfoAssistPreChgRelayFltData }));
        setChartHcmWorkInfoWorkInfAliveCnt((prev) => ({ ...prev, data: hcmWorkInfoWorkInfAliveCntData }));
        setChartVcuHvFunctionCtrlMainPosCtrlComnd((prev) => ({ ...prev, data: vcuHvFunctionCtrlMainPosCtrlComndData }));
        setChartVcuHvFunctionCtrlAllowChg((prev) => ({ ...prev, data: vcuHvFunctionCtrlAllowChgData }));
        setChartVcuHvFunctionCtrlBmshvOnOffReq((prev) => ({ ...prev, data: vcuHvFunctionCtrlBmshvOnOffReqData }));
        setChartVcuHvFunctionCtrlTmsoffRequest((prev) => ({ ...prev, data: vcuHvFunctionCtrlTmsoffRequestData }));
        setChartVcuHvFunctionCtrlDcdcEnableOut((prev) => ({ ...prev, data: vcuHvFunctionCtrlDcdcEnableOutData }));
        setChartVcuHvFunctionCtrlBdcacEnableOut((prev) => ({ ...prev, data: vcuHvFunctionCtrlBdcacEnableOutData }));
        setChartVcuHvFunctionCtrlSdcacEnableOut((prev) => ({ ...prev, data: vcuHvFunctionCtrlSdcacEnableOutData }));
        setChartVcuHvFunctionCtrlAssitPosCtrlComnd((prev) => ({ ...prev, data: vcuHvFunctionCtrlAssitPosCtrlComndData }));
        setChartVcuHvFunctionCtrlHcmCutOffLV((prev) => ({ ...prev, data: vcuHvFunctionCtrlHcmCutOffLVData }));
        setChartVcuHvFunctionCtrlBmsCutOffLV((prev) => ({ ...prev, data: vcuHvFunctionCtrlBmsCutOffLVData }));
        setChartVcuHvFunctionCtrlMcuCutOffLV((prev) => ({ ...prev, data: vcuHvFunctionCtrlMcuCutOffLVData }));
        setChartVcuHvFunctionCtrlPtcCtrlCmd((prev) => ({ ...prev, data: vcuHvFunctionCtrlPtcCtrlCmdData }));
        setChartVcuHvFunctionCtrlDcdcPwrLmt((prev) => ({ ...prev, data: vcuHvFunctionCtrlDcdcPwrLmtData }));
        setChartVcuHvFunctionCtrlSdcacOutFreq((prev) => ({ ...prev, data: vcuHvFunctionCtrlSdcacOutFreqData }));
        setChartVcuHvFunctionCtrlAssitPos2CtrlCmd((prev) => ({ ...prev, data: vcuHvFunctionCtrlAssitPos2CtrlCmdData }));
        setChartVcuHvFunctionCtrlMainNegCtrlComnd((prev) => ({ ...prev, data: vcuHvFunctionCtrlMainNegCtrlComndData }));
        setChartVcuHvFunctionCtrlLsdcacCtrlComnd((prev) => ({ ...prev, data: vcuHvFunctionCtrlLsdcacCtrlComndData }));
        setChartVcuHvFunctionCtrlSelfCheckSts((prev) => ({ ...prev, data: vcuHvFunctionCtrlSelfCheckStsData }));
        setChartVcuHvFunctionCtrlHvFunctionCtrlAliverCounter((prev) => ({ ...prev, data: vcuHvFunctionCtrlHvFunctionCtrlAliverCounterData }));
        setChartVcuHvFunctionCtrlHvFunctionCtrlChecksum((prev) => ({ ...prev, data: vcuHvFunctionCtrlHvFunctionCtrlChecksumData }));
        setChartVcuLvFunctionCtrlDefrosterCtrlL((prev) => ({ ...prev, data: vcuLvFunctionCtrlDefrosterCtrlLData }));
        setChartVcuLvFunctionCtrlDefrosterCtrlH((prev) => ({ ...prev, data: vcuLvFunctionCtrlDefrosterCtrlHData }));
        setChartVcuLvFunctionCtrlAcPanelCtrl((prev) => ({ ...prev, data: vcuLvFunctionCtrlAcPanelCtrlData }));
        setChartVcuLvFunctionCtrlHcmPowerCtrl((prev) => ({ ...prev, data: vcuLvFunctionCtrlHcmPowerCtrlData }));
        setChartVcuLvFunctionCtrlCehModeCmd((prev) => ({ ...prev, data: vcuLvFunctionCtrlCehModeCmdData }));
        setChartVcuLvFunctionCtrlCehPwmCmd((prev) => ({ ...prev, data: vcuLvFunctionCtrlCehPwmCmdData }));
        setChartVcuLvFunctionCtrlCehTempCmd((prev) => ({ ...prev, data: vcuLvFunctionCtrlCehTempCmdData }));
        setChartMcuMotorEleParaHvBusVol((prev) => ({ ...prev, data: mcuMotorEleParaHvBusVolData }));
        setChartBmsBatPackLmtMaxPmtEnyRecoCurr((prev) => ({ ...prev, data: bmsBatPackLmtMaxPmtEnyRecoCurrData }));
        setChartBmsBatPackLmtMaxPmtDischgCurr((prev) => ({ ...prev, data: bmsBatPackLmtMaxPmtDischgCurrData }));
        setChartBmsBatPackLmtBattMaxWorkTemp((prev) => ({ ...prev, data: bmsBatPackLmtBattMaxWorkTempData }));
        setChartBmsBatPackLmtBattMinWorkTemp((prev) => ({ ...prev, data: bmsBatPackLmtBattMinWorkTempData }));
        setChartBmsBatPackLmtMinPmtSOC((prev) => ({ ...prev, data: bmsBatPackLmtMinPmtSOCData }));
        setChartBmsBatPackLmtMaxPmtEnyRecoVol((prev) => ({ ...prev, data: bmsBatPackLmtMaxPmtEnyRecoVolData }));
        setChartBmsBattaryFltInfoBattPackVolFault((prev) => ({ ...prev, data: bmsBattaryFltInfoBattPackVolFaultData }));
        setChartBmsBattaryFltInfoBattCellVolFault((prev) => ({ ...prev, data: bmsBattaryFltInfoBattCellVolFaultData }));
        setChartBmsBattaryFltInfoBattTempFault((prev) => ({ ...prev, data: bmsBattaryFltInfoBattTempFaultData }));
        setChartBmsBattaryFltInfoBattSocFault((prev) => ({ ...prev, data: bmsBattaryFltInfoBattSocFaultData }));
        setChartBmsBattaryFltInfoSocJumpFault((prev) => ({ ...prev, data: bmsBattaryFltInfoSocJumpFaultData }));
        setChartBmsBattaryFltInfoBattEqualizationSts((prev) => ({ ...prev, data: bmsBattaryFltInfoBattEqualizationStsData }));
        setChartBmsBattaryFltInfoDischargeCurrFault((prev) => ({ ...prev, data: bmsBattaryFltInfoDischargeCurrFaultData }));
        setChartBmsBattaryFltInfoChargeCurrFault((prev) => ({ ...prev, data: bmsBattaryFltInfoChargeCurrFaultData }));
        setChartBmsBattaryFltInfoBattIsolationSts((prev) => ({ ...prev, data: bmsBattaryFltInfoBattIsolationStsData }));
        setChartBmsBattaryFltInfoCanComFault((prev) => ({ ...prev, data: bmsBattaryFltInfoCanComFaultData }));
        setChartBmsBattaryFltInfoBattPackMatchFault((prev) => ({ ...prev, data: bmsBattaryFltInfoBattPackMatchFaultData }));
        setChartBmsBattaryFltInfoBattConsistencyFlt((prev) => ({ ...prev, data: bmsBattaryFltInfoBattConsistencyFltData }));
        setChartBmsBattaryFltInfoCurrSensorFault((prev) => ({ ...prev, data: bmsBattaryFltInfoCurrSensorFaultData }));
        setChartBmsBattaryFltInfoMsdFault((prev) => ({ ...prev, data: bmsBattaryFltInfoMsdFaultData }));
        setChartBmsBattaryFltInfoHeatPosRelayFault((prev) => ({ ...prev, data: bmsBattaryFltInfoHeatPosRelayFaultData }));
        setChartBmsBattaryFltInfoHeatNegRelayFault((prev) => ({ ...prev, data: bmsBattaryFltInfoHeatNegRelayFaultData }));
        setChartBmsBattaryFltInfoOverChgFault((prev) => ({ ...prev, data: bmsBattaryFltInfoOverChgFaultData }));
        setChartBmsBattaryFltInfoSt1FltHw((prev) => ({ ...prev, data: bmsBattaryFltInfoSt1FltHwData }));
        setChartBmsBattaryFltInfoPosRelayFault((prev) => ({ ...prev, data: bmsBattaryFltInfoPosRelayFaultData }));
        setChartBmsBattaryFltInfoNegRelayFault((prev) => ({ ...prev, data: bmsBattaryFltInfoNegRelayFaultData }));
        setChartBmsBattaryFltInfoSt1FltHvil((prev) => ({ ...prev, data: bmsBattaryFltInfoSt1FltHvilData }));
        setChartBmsBattaryFltInfoCellVolDiffFault((prev) => ({ ...prev, data: bmsBattaryFltInfoCellVolDiffFaultData }));
        setChartBmsBattaryFltInfoCellTempDiffFault((prev) => ({ ...prev, data: bmsBattaryFltInfoCellTempDiffFaultData }));
        setChartBmsBattaryFltInfoEnyRecoCurrHighFlt((prev) => ({ ...prev, data: bmsBattaryFltInfoEnyRecoCurrHighFltData }));
        setChartBmsBattaryFltInfoPowerActiveMode((prev) => ({ ...prev, data: bmsBattaryFltInfoPowerActiveModeData }));
        setChartBmsBattaryFltInfoBattFireFault((prev) => ({ ...prev, data: bmsBattaryFltInfoBattFireFaultData }));
        setChartBmsBattaryFltInfoBattFaultInfoAliveCnt((prev) => ({ ...prev, data: bmsBattaryFltInfoBattFaultInfoAliveCntData }));
        setChartBmsCellVoltDataCellVolt1((prev) => ({ ...prev, data: bmsCellVoltDataCellVolt1Data }));
        setChartBmsCellVoltDataCellVolt2((prev) => ({ ...prev, data: bmsCellVoltDataCellVolt2Data }));
        setChartBmsCellVoltDataCellVolt3((prev) => ({ ...prev, data: bmsCellVoltDataCellVolt3Data }));
        setChartBmsCellVoltDataCellVolt4((prev) => ({ ...prev, data: bmsCellVoltDataCellVolt4Data }));
        setChartBmsCellTempDataBattTemp1((prev) => ({ ...prev, data: bmsCellTempDataBattTemp1Data }));
        setChartBmsCellTempDataBattTemp2((prev) => ({ ...prev, data: bmsCellTempDataBattTemp2Data }));
        setChartBmsCellTempDataBattTemp3((prev) => ({ ...prev, data: bmsCellTempDataBattTemp3Data }));
        setChartBmsCellTempDataBattTemp4((prev) => ({ ...prev, data: bmsCellTempDataBattTemp4Data }));
        setChartBmsCellTempDataBattTemp5((prev) => ({ ...prev, data: bmsCellTempDataBattTemp5Data }));
        setChartBmsCellTempDataBattTemp6((prev) => ({ ...prev, data: bmsCellTempDataBattTemp6Data }));
        setChartBmsCellTempDataBattTemp7((prev) => ({ ...prev, data: bmsCellTempDataBattTemp7Data }));
        setChartBmsCellTempDataBattTemp8((prev) => ({ ...prev, data: bmsCellTempDataBattTemp8Data }));
        setChartIcOdometerTrip((prev) => ({ ...prev, data: icOdometerTripData }));
        setChartIcOdometerOdometer((prev) => ({ ...prev, data: icOdometerOdometerData }));
        setChartIcDoorStsBatteryLowvtge((prev) => ({ ...prev, data: icDoorStsBatteryLowvtgeData }));
        setChartIcDoorStsDoor1OpenSts((prev) => ({ ...prev, data: icDoorStsDoor1OpenStsData }));
        setChartIcDoorStsDriverSeatbelts((prev) => ({ ...prev, data: icDoorStsDriverSeatbeltsData }));
        setChartIcDoorStsLampcircuitSts((prev) => ({ ...prev, data: icDoorStsLampcircuitStsData }));
        setChartIcDoorStsDoor2OpenSts((prev) => ({ ...prev, data: icDoorStsDoor2OpenStsData }));
        setChartIcDoorStsDoorBell((prev) => ({ ...prev, data: icDoorStsDoorBellData }));
        setChartIcDoorStsDriverSeat((prev) => ({ ...prev, data: icDoorStsDriverSeatData }));
        setChartIcDoorStsTrumpetSts((prev) => ({ ...prev, data: icDoorStsTrumpetStsData }));
        setChartIcDoorStsDoor3OpenSts((prev) => ({ ...prev, data: icDoorStsDoor3OpenStsData }));
        setChartIcDoorStsPowerMode((prev) => ({ ...prev, data: icDoorStsPowerModeData }));
        setChartIcDoorStsDoor5LockSts((prev) => ({ ...prev, data: icDoorStsDoor5LockStsData }));
        setChartIcDoorStsDoor4OpenSts((prev) => ({ ...prev, data: icDoorStsDoor4OpenStsData }));
        setChartIcDoorStsFrontAirTankPrsure((prev) => ({ ...prev, data: icDoorStsFrontAirTankPrsureData }));
        setChartIcDoorStsFrontAirTankLowPrsureAlarm((prev) => ({ ...prev, data: icDoorStsFrontAirTankLowPrsureAlarmData }));
        setChartIcDoorStsRearAirTankLowPrsureAlarm((prev) => ({ ...prev, data: icDoorStsRearAirTankLowPrsureAlarmData }));
        setChartIcDoorStsRearAirTankPrsure((prev) => ({ ...prev, data: icDoorStsRearAirTankPrsureData }));
        setChartIcDoorStsPrakingAirTankLowPrsureAlarm((prev) => ({ ...prev, data: icDoorStsPrakingAirTankLowPrsureAlarmData }));
        setChartIcDoorStsAssistAirTankLowPrsureAlarm((prev) => ({ ...prev, data: icDoorStsAssistAirTankLowPrsureAlarmData }));
        setChartIcDoorStsSteeringIndicator((prev) => ({ ...prev, data: icDoorStsSteeringIndicatorData }));
        setChartIcDoorStsDoorOpenSts((prev) => ({ ...prev, data: icDoorStsDoorOpenStsData }));
        setChartIcDoorStsEmgValve((prev) => ({ ...prev, data: icDoorStsEmgValveData }));
        setChartIcDoorStsCoolLqdPos((prev) => ({ ...prev, data: icDoorStsCoolLqdPosData }));
        setChartIcDoorStsSosActive((prev) => ({ ...prev, data: icDoorStsSosActiveData }));
        setChartIcDoorStsDangeractive((prev) => ({ ...prev, data: icDoorStsDangeractiveData }));
        setChartVcuCcvsHndbrkSts1939((prev) => ({ ...prev, data: vcuCcvsHndbrkSts1939Data }));
        setChartVcuCcvsVehicleSpd1939((prev) => ({ ...prev, data: vcuCcvsVehicleSpd1939Data }));
        setChartVcuEmTrqSpdCtrlMcuEnableReq((prev) => ({ ...prev, data: vcuEmTrqSpdCtrlMcuEnableReqData }));
        setChartVcuEmTrqSpdCtrlEmCtrlMode((prev) => ({ ...prev, data: vcuEmTrqSpdCtrlEmCtrlModeData }));
        setChartVcuEmTrqSpdCtrlEmWorkMode((prev) => ({ ...prev, data: vcuEmTrqSpdCtrlEmWorkModeData }));
        setChartVcuEmTrqSpdCtrlReqSpdOrLmt((prev) => ({ ...prev, data: vcuEmTrqSpdCtrlReqSpdOrLmtData }));
        setChartVcuEmTrqSpdCtrlReqTrqOrLmt((prev) => ({ ...prev, data: vcuEmTrqSpdCtrlReqTrqOrLmtData }));
        setChartVcuEmTrqSpdCtrlMaxEmPwrLmt((prev) => ({ ...prev, data: vcuEmTrqSpdCtrlMaxEmPwrLmtData }));
        setChartVcuEmTrqSpdCtrlMinEmPwrLmt((prev) => ({ ...prev, data: vcuEmTrqSpdCtrlMinEmPwrLmtData }));
        setChartVcuEmTrqSpdCtrlEmTrqSpdCtrlAliveCnt((prev) => ({ ...prev, data: vcuEmTrqSpdCtrlEmTrqSpdCtrlAliveCntData }));
        setChartMcuMotorSpdMotorSpeedEbs((prev) => ({ ...prev, data: mcuMotorSpdMotorSpeedEbsData }));
        setChartMcuMotorSpdMotorTrqAliveCnt((prev) => ({ ...prev, data: mcuMotorSpdMotorTrqAliveCntData }));
        setChartMcuMotorTrqMotorMaxTrq((prev) => ({ ...prev, data: mcuMotorTrqMotorMaxTrqData }));
        setChartMcuMotorTrqMotorMinTrq((prev) => ({ ...prev, data: mcuMotorTrqMotorMinTrqData }));
        setChartMcuMotorTrqMotorTrqAliveCnt((prev) => ({ ...prev, data: mcuMotorTrqMotorTrqAliveCntData }));
        setChartLmcuMotorTrqMotorMaxTrq((prev) => ({ ...prev, data: lmcuMotorTrqMotorMaxTrqData }));
        setChartLmcuMotorTrqMotorMinTrq((prev) => ({ ...prev, data: lmcuMotorTrqMotorMinTrqData }));
        setChartLmcuMotorTrqMotorTrqAliveCnt((prev) => ({ ...prev, data: lmcuMotorTrqMotorTrqAliveCntData }));
        setChartLmcuMotorEleParaHvBusVol((prev) => ({ ...prev, data: lmcuMotorEleParaHvBusVolData }));
        setChartLmcuMotorEleParaHvdcCurr((prev) => ({ ...prev, data: lmcuMotorEleParaHvdcCurrData }));
        setChartLmcuMotorEleParaMoterActOutPower((prev) => ({ ...prev, data: lmcuMotorEleParaMoterActOutPowerData }));
        setChartLmcuMotorEleParaMoterTemp((prev) => ({ ...prev, data: lmcuMotorEleParaMoterTempData }));
        setChartLmcuMotorEleParaLmcuTemp((prev) => ({ ...prev, data: lmcuMotorEleParaLmcuTempData }));
        setChartBmsChgInfoGChgTimeTatol((prev) => ({ ...prev, data: bmsChgInfoGChgTimeTatolData }));
        setChartBmsBattEnyInfo1ChgCount((prev) => ({ ...prev, data: bmsBattEnyInfo1ChgCountData }));
        setChartBmsBattEnyInfo1SingleChgEnergy((prev) => ({ ...prev, data: bmsBattEnyInfo1SingleChgEnergyData }));
        setChartBmsBattEnyInfo1SingleDisChgEny((prev) => ({ ...prev, data: bmsBattEnyInfo1SingleDisChgEnyData }));
        setChartBmsBattEnyInfo1ChgTimeRemain((prev) => ({ ...prev, data: bmsBattEnyInfo1ChgTimeRemainData }));
    }, [runningCanDataList]);

    useEffect(() => {
        if (runningCanDataList === undefined || selectedDataPointIndex === undefined) return;

        if (vehicleInfo?.makerModel?.maker?.makerName === Common.VehicleMaker.TSEco) {
            const canData = runningCanDataList[selectedDataPointIndex] as CanDataYeoul.CanData;

            setCurrentCanData(canData);
        }
    }, [selectedDataPointIndex]);

    useEffect(() => {
        if (
            bmsBatteryInfoChartMounted === true ||
            vcuBodyControlInfoChartMounted === true ||
            vcuErrCodeChartMounted === true ||
            lbmsInfoChartMounted === true ||
            vcuPtInfoIndicateChartMounted === true ||
            bmsMinMaxCellVoltChartMounted === true ||
            bmsMinMaxCellTempChartMounted === true ||
            mcuMotorAlarmInfoChartMounted === true ||
            lmcuMotorAlarmInfoChartMounted === true ||
            bmsHvIsolationInfoChartMounted === true ||
            tcuInfo1ChartMounted === true ||
            dcdcStatusInfoChartMounted === true ||
            sdcacStatusInfoChartMounted === true ||
            bdcacStatusInfoChartMounted === true ||
            hcmWorkInfoChartMounted === true ||
            vcuHvFunctionCtrlChartMounted === true ||
            vcuLvFunctionCtrlChartMounted === true ||
            mcuMotorEleParaChartMounted === true ||
            bmsBatPackLmtChartMounted === true ||
            bmsBattaryFltInfoChartMounted === true ||
            bmsCellVoltDataChartMounted === true ||
            bmsCellTempDataChartMounted === true ||
            icOdometerChartMounted === true ||
            icDoorStsChartMounted === true ||
            vcuCcvsChartMounted === true ||
            vcuEmTrqSpdCtrlChartMounted === true ||
            mcuMotorSpdChartMounted === true ||
            mcuMotorTrqChartMounted === true ||
            lmcuMotorTrqChartMounted === true ||
            lmcuMotorEleParaChartMounted === true ||
            bmsChgInfoGChartMounted === true ||
            bmsBattEnyInfo1ChartMounted === true
        ) {
            if (onMountedChart !== undefined) onMountedChart();
        }
    }, [bmsBatteryInfoChartMounted, vcuBodyControlInfoChartMounted, vcuErrCodeChartMounted, lbmsInfoChartMounted, vcuPtInfoIndicateChartMounted, bmsMinMaxCellVoltChartMounted, bmsMinMaxCellTempChartMounted, mcuMotorAlarmInfoChartMounted, lmcuMotorAlarmInfoChartMounted, bmsHvIsolationInfoChartMounted, tcuInfo1ChartMounted, dcdcStatusInfoChartMounted, sdcacStatusInfoChartMounted, bdcacStatusInfoChartMounted, hcmWorkInfoChartMounted, vcuHvFunctionCtrlChartMounted, vcuLvFunctionCtrlChartMounted, mcuMotorEleParaChartMounted, bmsBatPackLmtChartMounted, bmsBattaryFltInfoChartMounted, bmsCellVoltDataChartMounted, bmsCellTempDataChartMounted, icOdometerChartMounted, icDoorStsChartMounted, vcuCcvsChartMounted, vcuEmTrqSpdCtrlChartMounted, mcuMotorSpdChartMounted, mcuMotorTrqChartMounted, lmcuMotorTrqChartMounted, lmcuMotorEleParaChartMounted, bmsChgInfoGChartMounted, bmsBattEnyInfo1ChartMounted]);
    //#endregion

    const convertChartTooltip = (seriesName: string, value: number) => {
        let convertTooltipString = String(value);
        switch (seriesName) {
            case Common.YEOUL_BMS_BATTERY_INFO_BATT_VOL_NAME:
            case Common.YEOUL_LBMS_INFO_BATT_VOLT_NAME:
            case Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MIN_CELL_VOLT_NAME:
            case Common.YEOUL_BMS_MIN_MAX_CELL_VOLT_MAX_CELL_VOLT_NAME:
            case Common.YEOUL_MCU_MOTOR_ELE_PARA_HV_BUS_VOL_NAME:
            case Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT1_NAME:
            case Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT2_NAME:
            case Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT3_NAME:
            case Common.YEOUL_BMS_CELL_VOLT_DATA_CELL_VOLT4_NAME:
            case Common.YEOUL_LMCU_MOTOR_ELE_PARA_HV_BUS_VOL_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_VOLTAGE);
                break;
            }

            case Common.YEOUL_BMS_BATTERY_INFO_BATT_CURR_NAME:
            case Common.YEOUL_LBMS_INFO_BATT_CURRENT_NAME:
            case Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_ENY_RECO_CURR_NAME:
            case Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_DISCHG_CURR_NAME:
            case Common.YEOUL_LMCU_MOTOR_ELE_PARA_HVDC_CURR_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_CURRENT);
                break;
            }

            case Common.YEOUL_BMS_BATTERY_INFO_BATT_SOC_NAME:
            case Common.YEOUL_BMS_BATTERY_INFO_BATT_SOH_NAME:
            case Common.YEOUL_VCU_BODY_CONTROL_INFO_ACC_PEDAL_POSITION_NAME:
            case Common.YEOUL_VCU_LV_FUNCTION_CTRL_CEH_PWM_CMD_NAME:
            case Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MAX_EM_PWR_LMT_NAME:
            case Common.YEOUL_VCU_EM_TRQ_SPD_CTRL_MIN_EM_PWR_LMT_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_PERCENT);
                break;
            }

            case Common.YEOUL_VCU_BODY_CONTROL_INFO_VEHICLE_SPD_NAME:
            case Common.YEOUL_VCU_CCVS_VEHICLE_SPD1939_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_SPEED);
                break;
            }

            case Common.YEOUL_VCU_ERR_CODE_DTE_NAME:
            case Common.YEOUL_IC_ODOMETER_TRIP_NAME:
            case Common.YEOUL_IC_ODOMETER_ODOMETER_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_DISTANCE);
                break;
            }

            case Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_BATT_MIN_TEMP_NAME:
            case Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_BNTT_MAX_TEMP_NAME:
            case Common.YEOUL_BMS_MIN_MAX_CELL_TEMP_CELL_AVG_TEMP_NAME:
            case Common.YEOUL_BMS_BAT_PACK_LMT_BATT_MAX_WORK_TEMP_NAME:
            case Common.YEOUL_BMS_BAT_PACK_LMT_BATT_MIN_WORK_TEMP_NAME:
            case Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP1_NAME:
            case Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP2_NAME:
            case Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP3_NAME:
            case Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP4_NAME:
            case Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP5_NAME:
            case Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP6_NAME:
            case Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP7_NAME:
            case Common.YEOUL_BMS_CELL_TEMP_DATA_BATT_TEMP8_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_CELSIUS);
                break;
            }

            case Common.YEOUL_VCU_HV_FUNCTION_CTRL_DCDC_PWR_LMT_NAME:
            case Common.YEOUL_BMS_BAT_PACK_LMT_MIN_PMT_SOC_NAME:
            case Common.YEOUL_BMS_BAT_PACK_LMT_MAX_PMT_ENY_RECO_VOL_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, "％");
                break;
            }

            case Common.YEOUL_IC_DOOR_STS_FRONT_AIR_TANK_PRSURE_NAME:
            case Common.YEOUL_IC_DOOR_STS_REAR_AIR_TANK_PRSURE_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_K_PASCAL);
                break;
            }

            case Common.YEOUL_MCU_MOTOR_SPD_MOTOR_SPEED_EBS_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_MOTOR_SPEED);
                break;
            }

            case Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_MAX_TRQ_NAME:
            case Common.YEOUL_MCU_MOTOR_TRQ_MOTOR_MIN_TRQ_NAME:
            case Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_MAX_TRQ_NAME:
            case Common.YEOUL_LMCU_MOTOR_TRQ_MOTOR_MIN_TRQ_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_TORQUE);
                break;
            }

            case Common.YEOUL_BMS_BATT_ENY_INFO1_CHG_COUNT_NAME:
            case Common.YEOUL_BMS_BATT_ENY_INFO1_SINGLE_CHG_ENERGY_NAME:
            case Common.YEOUL_BMS_BATT_ENY_INFO1_SINGLE_DIS_CHG_ENY_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_POWER_H);
                break;
            }

            case Common.YEOUL_BMS_BATT_ENY_INFO1_CHG_TIME_REMAIN_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_MINUTE);
                break;
            }

        }
        return convertTooltipString;
    };

    const onChangeZoom = (zoom: any) => {
        onZoomed && onZoomed(zoom);
    };

    return (
        <div>
            <Space direction="vertical" size={20} style={{ width: "100%" }}>
                <div>
                    {/* BMS_BatteryInfo */}
                    <CanDataWrapper
                        title="BMS_BatteryInfo"
                        id="yeoul-bms-battery-info"
                        panelOpen={bmsBatteryInfoPanelOpen}
                        onChangePanelOpen={setBmsBatteryInfoPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataBmsBatteryInfo}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBmsBatteryInfo}
                        onChangeTableSelect={onChangeBmsBatteryInfo}
                        tableGetTooltips={getTableTooltipBmsBatteryInfo}
                        seriesChartDatas={seriesChartDatasBmsBatteryInfo}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBmsBatteryInfoChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* VCU_BodyControlInfo */}
                    <CanDataWrapper
                        title="VCU_BodyControlInfo"
                        id="yeoul-vcu-body-control-info"
                        panelOpen={vcuBodyControlInfoPanelOpen}
                        onChangePanelOpen={setVcuBodyControlInfoPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataVcuBodyControlInfo}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcuBodyControlInfo}
                        onChangeTableSelect={onChangeVcuBodyControlInfo}
                        tableGetTooltips={getTableTooltipVcuBodyControlInfo}
                        seriesChartDatas={seriesChartDatasVcuBodyControlInfo}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcuBodyControlInfoChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* VCU_ErrCode */}
                    <CanDataWrapper
                        title="VCU_ErrCode"
                        id="yeoul-vcu-err-code"
                        panelOpen={vcuErrCodePanelOpen}
                        onChangePanelOpen={setVcuErrCodePanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataVcuErrCode}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcuErrCode}
                        onChangeTableSelect={onChangeVcuErrCode}
                        tableGetTooltips={getTableTooltipVcuErrCode}
                        seriesChartDatas={seriesChartDatasVcuErrCode}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcuErrCodeChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* LBMS_Info */}
                    <CanDataWrapper
                        title="LBMS_Info"
                        id="yeoul-lbms-info"
                        panelOpen={lbmsInfoPanelOpen}
                        onChangePanelOpen={setLbmsInfoPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataLbmsInfo}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedLbmsInfo}
                        onChangeTableSelect={onChangeLbmsInfo}
                        tableGetTooltips={getTableTooltipLbmsInfo}
                        seriesChartDatas={seriesChartDatasLbmsInfo}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setLbmsInfoChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* VCU_PTInfoIndicate */}
                    <CanDataWrapper
                        title="VCU_PTInfoIndicate"
                        id="yeoul-vcu-pt-info-indicate"
                        panelOpen={vcuPtInfoIndicatePanelOpen}
                        onChangePanelOpen={setVcuPtInfoIndicatePanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataVcuPtInfoIndicate}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcuPtInfoIndicate}
                        onChangeTableSelect={onChangeVcuPtInfoIndicate}
                        tableGetTooltips={getTableTooltipVcuPtInfoIndicate}
                        seriesChartDatas={seriesChartDatasVcuPtInfoIndicate}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcuPtInfoIndicateChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* BMS_Min_Max_CellVolt */}
                    <CanDataWrapper
                        title="BMS_Min_Max_CellVolt"
                        id="yeoul-bms-min-max-cell-volt"
                        panelOpen={bmsMinMaxCellVoltPanelOpen}
                        onChangePanelOpen={setBmsMinMaxCellVoltPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataBmsMinMaxCellVolt}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBmsMinMaxCellVolt}
                        onChangeTableSelect={onChangeBmsMinMaxCellVolt}
                        tableGetTooltips={getTableTooltipBmsMinMaxCellVolt}
                        seriesChartDatas={seriesChartDatasBmsMinMaxCellVolt}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBmsMinMaxCellVoltChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* BMS_Min_Max_CellTemp */}
                    <CanDataWrapper
                        title="BMS_Min_Max_CellTemp"
                        id="yeoul-bms-min-max-cell-temp"
                        panelOpen={bmsMinMaxCellTempPanelOpen}
                        onChangePanelOpen={setBmsMinMaxCellTempPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataBmsMinMaxCellTemp}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBmsMinMaxCellTemp}
                        onChangeTableSelect={onChangeBmsMinMaxCellTemp}
                        tableGetTooltips={getTableTooltipBmsMinMaxCellTemp}
                        seriesChartDatas={seriesChartDatasBmsMinMaxCellTemp}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBmsMinMaxCellTempChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* MCU_MotorAlarmInfo */}
                    <CanDataWrapper
                        title="MCU_MotorAlarmInfo"
                        id="yeoul-mcu-motor-alarm-info"
                        panelOpen={mcuMotorAlarmInfoPanelOpen}
                        onChangePanelOpen={setMcuMotorAlarmInfoPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataMcuMotorAlarmInfo}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedMcuMotorAlarmInfo}
                        onChangeTableSelect={onChangeMcuMotorAlarmInfo}
                        tableGetTooltips={getTableTooltipMcuMotorAlarmInfo}
                        seriesChartDatas={seriesChartDatasMcuMotorAlarmInfo}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setMcuMotorAlarmInfoChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* LMCU_MotorAlarmInfo */}
                    <CanDataWrapper
                        title="LMCU_MotorAlarmInfo"
                        id="yeoul-lmcu-motor-alarm-info"
                        panelOpen={lmcuMotorAlarmInfoPanelOpen}
                        onChangePanelOpen={setLmcuMotorAlarmInfoPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataLmcuMotorAlarmInfo}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedLmcuMotorAlarmInfo}
                        onChangeTableSelect={onChangeLmcuMotorAlarmInfo}
                        tableGetTooltips={getTableTooltipLmcuMotorAlarmInfo}
                        seriesChartDatas={seriesChartDatasLmcuMotorAlarmInfo}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setLmcuMotorAlarmInfoChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* BMS_HVIsolationInfo */}
                    <CanDataWrapper
                        title="BMS_HVIsolationInfo"
                        id="yeoul-bms-hv-isolation-info"
                        panelOpen={bmsHvIsolationInfoPanelOpen}
                        onChangePanelOpen={setBmsHvIsolationInfoPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataBmsHvIsolationInfo}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBmsHvIsolationInfo}
                        onChangeTableSelect={onChangeBmsHvIsolationInfo}
                        tableGetTooltips={getTableTooltipBmsHvIsolationInfo}
                        seriesChartDatas={seriesChartDatasBmsHvIsolationInfo}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBmsHvIsolationInfoChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* TCU_Info1 */}
                    <CanDataWrapper
                        title="TCU_Info1"
                        id="yeoul-tcu-info1"
                        panelOpen={tcuInfo1PanelOpen}
                        onChangePanelOpen={setTcuInfo1PanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataTcuInfo1}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedTcuInfo1}
                        onChangeTableSelect={onChangeTcuInfo1}
                        tableGetTooltips={getTableTooltipTcuInfo1}
                        seriesChartDatas={seriesChartDatasTcuInfo1}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setTcuInfo1ChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* DCDC_StatusInfo */}
                    <CanDataWrapper
                        title="DCDC_StatusInfo"
                        id="yeoul-dcdc-status-info"
                        panelOpen={dcdcStatusInfoPanelOpen}
                        onChangePanelOpen={setDcdcStatusInfoPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataDcdcStatusInfo}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedDcdcStatusInfo}
                        onChangeTableSelect={onChangeDcdcStatusInfo}
                        tableGetTooltips={getTableTooltipDcdcStatusInfo}
                        seriesChartDatas={seriesChartDatasDcdcStatusInfo}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setDcdcStatusInfoChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* SDCAC_StatusInfo */}
                    <CanDataWrapper
                        title="SDCAC_StatusInfo"
                        id="yeoul-sdcac-status-info"
                        panelOpen={sdcacStatusInfoPanelOpen}
                        onChangePanelOpen={setSdcacStatusInfoPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataSdcacStatusInfo}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedSdcacStatusInfo}
                        onChangeTableSelect={onChangeSdcacStatusInfo}
                        tableGetTooltips={getTableTooltipSdcacStatusInfo}
                        seriesChartDatas={seriesChartDatasSdcacStatusInfo}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setSdcacStatusInfoChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* BDCAC_StatusInfo */}
                    <CanDataWrapper
                        title="BDCAC_StatusInfo"
                        id="yeoul-bdcac-status-info"
                        panelOpen={bdcacStatusInfoPanelOpen}
                        onChangePanelOpen={setBdcacStatusInfoPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataBdcacStatusInfo}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBdcacStatusInfo}
                        onChangeTableSelect={onChangeBdcacStatusInfo}
                        tableGetTooltips={getTableTooltipBdcacStatusInfo}
                        seriesChartDatas={seriesChartDatasBdcacStatusInfo}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBdcacStatusInfoChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* HCM_WorkInfo */}
                    <CanDataWrapper
                        title="HCM_WorkInfo"
                        id="yeoul-hcm-work-info"
                        panelOpen={hcmWorkInfoPanelOpen}
                        onChangePanelOpen={setHcmWorkInfoPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataHcmWorkInfo}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedHcmWorkInfo}
                        onChangeTableSelect={onChangeHcmWorkInfo}
                        tableGetTooltips={getTableTooltipHcmWorkInfo}
                        seriesChartDatas={seriesChartDatasHcmWorkInfo}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setHcmWorkInfoChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* VCU_HVFunctionCtrl */}
                    <CanDataWrapper
                        title="VCU_HVFunctionCtrl"
                        id="yeoul-vcu-hv-function-ctrl"
                        panelOpen={vcuHvFunctionCtrlPanelOpen}
                        onChangePanelOpen={setVcuHvFunctionCtrlPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataVcuHvFunctionCtrl}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcuHvFunctionCtrl}
                        onChangeTableSelect={onChangeVcuHvFunctionCtrl}
                        tableGetTooltips={getTableTooltipVcuHvFunctionCtrl}
                        seriesChartDatas={seriesChartDatasVcuHvFunctionCtrl}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcuHvFunctionCtrlChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* VCU_LVFunctionCtrl */}
                    <CanDataWrapper
                        title="VCU_LVFunctionCtrl"
                        id="yeoul-vcu-lv-function-ctrl"
                        panelOpen={vcuLvFunctionCtrlPanelOpen}
                        onChangePanelOpen={setVcuLvFunctionCtrlPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataVcuLvFunctionCtrl}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcuLvFunctionCtrl}
                        onChangeTableSelect={onChangeVcuLvFunctionCtrl}
                        tableGetTooltips={getTableTooltipVcuLvFunctionCtrl}
                        seriesChartDatas={seriesChartDatasVcuLvFunctionCtrl}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcuLvFunctionCtrlChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* MCU_MotorElePara */}
                    <CanDataWrapper
                        title="MCU_MotorElePara"
                        id="yeoul-mcu-motor-ele-para"
                        panelOpen={mcuMotorEleParaPanelOpen}
                        onChangePanelOpen={setMcuMotorEleParaPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataMcuMotorElePara}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedMcuMotorElePara}
                        onChangeTableSelect={onChangeMcuMotorElePara}
                        tableGetTooltips={getTableTooltipMcuMotorElePara}
                        seriesChartDatas={seriesChartDatasMcuMotorElePara}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setMcuMotorEleParaChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* BMS_BatPackLmt */}
                    <CanDataWrapper
                        title="BMS_BatPackLmt"
                        id="yeoul-bms-bat-pack-lmt"
                        panelOpen={bmsBatPackLmtPanelOpen}
                        onChangePanelOpen={setBmsBatPackLmtPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataBmsBatPackLmt}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBmsBatPackLmt}
                        onChangeTableSelect={onChangeBmsBatPackLmt}
                        tableGetTooltips={getTableTooltipBmsBatPackLmt}
                        seriesChartDatas={seriesChartDatasBmsBatPackLmt}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBmsBatPackLmtChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* BMS_BattaryFltInfo */}
                    <CanDataWrapper
                        title="BMS_BattaryFltInfo"
                        id="yeoul-bms-battary-flt-info"
                        panelOpen={bmsBattaryFltInfoPanelOpen}
                        onChangePanelOpen={setBmsBattaryFltInfoPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataBmsBattaryFltInfo}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBmsBattaryFltInfo}
                        onChangeTableSelect={onChangeBmsBattaryFltInfo}
                        tableGetTooltips={getTableTooltipBmsBattaryFltInfo}
                        seriesChartDatas={seriesChartDatasBmsBattaryFltInfo}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBmsBattaryFltInfoChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* BMS_CellVoltData */}
                    <CanDataWrapper
                        title="BMS_CellVoltData"
                        id="yeoul-bms-cell-volt-data"
                        panelOpen={bmsCellVoltDataPanelOpen}
                        onChangePanelOpen={setBmsCellVoltDataPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataBmsCellVoltData}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBmsCellVoltData}
                        onChangeTableSelect={onChangeBmsCellVoltData}
                        tableGetTooltips={getTableTooltipBmsCellVoltData}
                        seriesChartDatas={seriesChartDatasBmsCellVoltData}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBmsCellVoltDataChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* BMS_CellTempData */}
                    <CanDataWrapper
                        title="BMS_CellTempData"
                        id="yeoul-bms-cell-temp-data"
                        panelOpen={bmsCellTempDataPanelOpen}
                        onChangePanelOpen={setBmsCellTempDataPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataBmsCellTempData}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBmsCellTempData}
                        onChangeTableSelect={onChangeBmsCellTempData}
                        tableGetTooltips={getTableTooltipBmsCellTempData}
                        seriesChartDatas={seriesChartDatasBmsCellTempData}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBmsCellTempDataChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* IC_Odometer */}
                    <CanDataWrapper
                        title="IC_Odometer"
                        id="yeoul-ic-odometer"
                        panelOpen={icOdometerPanelOpen}
                        onChangePanelOpen={setIcOdometerPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataIcOdometer}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedIcOdometer}
                        onChangeTableSelect={onChangeIcOdometer}
                        tableGetTooltips={getTableTooltipIcOdometer}
                        seriesChartDatas={seriesChartDatasIcOdometer}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setIcOdometerChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* IC_DoorSts */}
                    <CanDataWrapper
                        title="IC_DoorSts"
                        id="yeoul-ic-door-sts"
                        panelOpen={icDoorStsPanelOpen}
                        onChangePanelOpen={setIcDoorStsPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataIcDoorSts}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedIcDoorSts}
                        onChangeTableSelect={onChangeIcDoorSts}
                        tableGetTooltips={getTableTooltipIcDoorSts}
                        seriesChartDatas={seriesChartDatasIcDoorSts}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setIcDoorStsChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* VCU_CCVS */}
                    <CanDataWrapper
                        title="VCU_CCVS"
                        id="yeoul-vcu-ccvs"
                        panelOpen={vcuCcvsPanelOpen}
                        onChangePanelOpen={setVcuCcvsPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataVcuCcvs}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcuCcvs}
                        onChangeTableSelect={onChangeVcuCcvs}
                        tableGetTooltips={getTableTooltipVcuCcvs}
                        seriesChartDatas={seriesChartDatasVcuCcvs}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcuCcvsChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* VCU_EMTrqSpdCtrl */}
                    <CanDataWrapper
                        title="VCU_EMTrqSpdCtrl"
                        id="yeoul-vcu-em-trq-spd-ctrl"
                        panelOpen={vcuEmTrqSpdCtrlPanelOpen}
                        onChangePanelOpen={setVcuEmTrqSpdCtrlPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataVcuEmTrqSpdCtrl}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcuEmTrqSpdCtrl}
                        onChangeTableSelect={onChangeVcuEmTrqSpdCtrl}
                        tableGetTooltips={getTableTooltipVcuEmTrqSpdCtrl}
                        seriesChartDatas={seriesChartDatasVcuEmTrqSpdCtrl}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcuEmTrqSpdCtrlChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* MCU_MotorSpd */}
                    <CanDataWrapper
                        title="MCU_MotorSpd"
                        id="yeoul-mcu-motor-spd"
                        panelOpen={mcuMotorSpdPanelOpen}
                        onChangePanelOpen={setMcuMotorSpdPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataMcuMotorSpd}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedMcuMotorSpd}
                        onChangeTableSelect={onChangeMcuMotorSpd}
                        tableGetTooltips={getTableTooltipMcuMotorSpd}
                        seriesChartDatas={seriesChartDatasMcuMotorSpd}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setMcuMotorSpdChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* MCU_MotorTrq */}
                    <CanDataWrapper
                        title="MCU_MotorTrq"
                        id="yeoul-mcu-motor-trq"
                        panelOpen={mcuMotorTrqPanelOpen}
                        onChangePanelOpen={setMcuMotorTrqPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataMcuMotorTrq}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedMcuMotorTrq}
                        onChangeTableSelect={onChangeMcuMotorTrq}
                        tableGetTooltips={getTableTooltipMcuMotorTrq}
                        seriesChartDatas={seriesChartDatasMcuMotorTrq}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setMcuMotorTrqChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* LMCU_MotorTrq */}
                    <CanDataWrapper
                        title="LMCU_MotorTrq"
                        id="yeoul-lmcu-motor-trq"
                        panelOpen={lmcuMotorTrqPanelOpen}
                        onChangePanelOpen={setLmcuMotorTrqPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataLmcuMotorTrq}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedLmcuMotorTrq}
                        onChangeTableSelect={onChangeLmcuMotorTrq}
                        tableGetTooltips={getTableTooltipLmcuMotorTrq}
                        seriesChartDatas={seriesChartDatasLmcuMotorTrq}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setLmcuMotorTrqChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* LMCU_MotorElePara */}
                    <CanDataWrapper
                        title="LMCU_MotorElePara"
                        id="yeoul-lmcu-motor-ele-para"
                        panelOpen={lmcuMotorEleParaPanelOpen}
                        onChangePanelOpen={setLmcuMotorEleParaPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataLmcuMotorElePara}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedLmcuMotorElePara}
                        onChangeTableSelect={onChangeLmcuMotorElePara}
                        tableGetTooltips={getTableTooltipLmcuMotorElePara}
                        seriesChartDatas={seriesChartDatasLmcuMotorElePara}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setLmcuMotorEleParaChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* BMS_ChgInfo_G */}
                    <CanDataWrapper
                        title="BMS_ChgInfo_G"
                        id="yeoul-bms-chg-info-g"
                        panelOpen={bmsChgInfoGPanelOpen}
                        onChangePanelOpen={setBmsChgInfoGPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataBmsChgInfoG}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBmsChgInfoG}
                        onChangeTableSelect={onChangeBmsChgInfoG}
                        tableGetTooltips={getTableTooltipBmsChgInfoG}
                        seriesChartDatas={seriesChartDatasBmsChgInfoG}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBmsChgInfoGChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* BMS_BattEnyInfo1 */}
                    <CanDataWrapper
                        title="BMS_BattEnyInfo1"
                        id="yeoul-bms-batt-eny-info1"
                        panelOpen={bmsBattEnyInfo1PanelOpen}
                        onChangePanelOpen={setBmsBattEnyInfo1PanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataBmsBattEnyInfo1}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBmsBattEnyInfo1}
                        onChangeTableSelect={onChangeBmsBattEnyInfo1}
                        tableGetTooltips={getTableTooltipBmsBattEnyInfo1}
                        seriesChartDatas={seriesChartDatasBmsBattEnyInfo1}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBmsBattEnyInfo1ChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                </div>
            </Space>
        </div>
    );
}

export default CanDataYeoulViewer;
